
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea2a1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea2a1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("iZZ9K", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42, (v) => $dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd4d5cd9b8817e88$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");
function $dd4d5cd9b8817e88$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dd4d5cd9b8817e88$var$objectIs = "function" === typeof Object.is ? Object.is : $dd4d5cd9b8817e88$var$is, $dd4d5cd9b8817e88$var$useSyncExternalStore = $acw62.useSyncExternalStore, $dd4d5cd9b8817e88$var$useRef = $acw62.useRef, $dd4d5cd9b8817e88$var$useEffect = $acw62.useEffect, $dd4d5cd9b8817e88$var$useMemo = $acw62.useMemo, $dd4d5cd9b8817e88$var$useDebugValue = $acw62.useDebugValue;
$dd4d5cd9b8817e88$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $dd4d5cd9b8817e88$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $dd4d5cd9b8817e88$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($dd4d5cd9b8817e88$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $dd4d5cd9b8817e88$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $dd4d5cd9b8817e88$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $dd4d5cd9b8817e88$var$useDebugValue(value);
    return value;
};

});

parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("7YFi7", function(module, exports) {

$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);
$parcel$export(module.exports, "ErrorMessage", () => ErrorMessage);

var $cCVp3 = parcelRequire("cCVp3");

var $3rtvu = parcelRequire("3rtvu");

var $chB0Q = parcelRequire("chB0Q");

var $acw62 = parcelRequire("acw62");

var $ai2Pb = parcelRequire("ai2Pb");

var $9RYKL = parcelRequire("9RYKL");

var $hNIl0 = parcelRequire("hNIl0");

var $58lCa = parcelRequire("58lCa");

var $9ORqK = parcelRequire("9ORqK");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $acw62.useContext)(FormikContext);
    !!!formik && (0, $9RYKL.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === "object";
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $acw62.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== "undefined" ? document : undefined);
    if (typeof doc === "undefined") return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $58lCa.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $hNIl0.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $58lCa.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $hNIl0.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case "SET_VALUES":
            return _extends({}, state, {
                values: msg.payload
            });
        case "SET_TOUCHED":
            return _extends({}, state, {
                touched: msg.payload
            });
        case "SET_ERRORS":
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case "SET_STATUS":
            return _extends({}, state, {
                status: msg.payload
            });
        case "SET_ISSUBMITTING":
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case "SET_ISVALIDATING":
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case "SET_FIELD_VALUE":
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_TOUCHED":
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case "SET_FIELD_ERROR":
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case "RESET_FORM":
            return _extends({}, state, msg.payload);
        case "SET_FORMIK_STATE":
            return msg.payload(state);
        case "SUBMIT_ATTEMPT":
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case "SUBMIT_FAILURE":
            return _extends({}, state, {
                isSubmitting: false
            });
        case "SUBMIT_SUCCESS":
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $acw62.useRef)(props.initialValues);
    var initialErrors = (0, $acw62.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $acw62.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $acw62.useRef)(props.initialStatus);
    var isMounted = (0, $acw62.useRef)(false);
    var fieldRegistry = (0, $acw62.useRef)({});
    (0, $acw62.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $acw62.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $acw62.useRef)({
        values: (0, $chB0Q.default)(props.initialValues),
        errors: (0, $chB0Q.default)(props.initialErrors) || emptyErrors,
        touched: (0, $chB0Q.default)(props.initialTouched) || emptyTouched,
        status: (0, $chB0Q.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $acw62.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $acw62.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $acw62.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === "ValidationError") resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $acw62.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $acw62.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $acw62.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $cCVp3.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: "SET_ISVALIDATING",
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
                dispatch({
                    type: "SET_ERRORS",
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $acw62.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $acw62.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: "RESET_FORM",
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $acw62.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: "SET_ERRORS",
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: "SET_TOUCHED",
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $acw62.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: "SET_STATUS",
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: "SET_FIELD_ERROR",
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: "SET_ISVALIDATING",
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: "SET_ISVALIDATING",
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: "SET_FIELD_ERROR",
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: "SET_ISVALIDATING",
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $acw62.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $acw62.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: "SET_TOUCHED",
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $acw62.useCallback)(function(errors) {
        dispatch({
            type: "SET_ERRORS",
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: "SET_VALUES",
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $acw62.useCallback)(function(field, value) {
        dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: "SET_FIELD_VALUE",
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $acw62.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: "SET_FIELD_TOUCHED",
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $acw62.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $acw62.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: "SET_FORMIK_STATE",
            payload: stateOrCb
        });
        else dispatch({
            type: "SET_FORMIK_STATE",
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $acw62.useCallback)(function(status) {
        dispatch({
            type: "SET_STATUS",
            payload: status
        });
    }, []);
    var setSubmitting = (0, $acw62.useCallback)(function(isSubmitting) {
        dispatch({
            type: "SET_ISSUBMITTING",
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: "SUBMIT_ATTEMPT"
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: "SUBMIT_SUCCESS"
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: "SUBMIT_FAILURE"
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: "SUBMIT_FAILURE"
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $acw62.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $acw62.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $acw62.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === "checkbox") {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === "radio") {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === "select" && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $acw62.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $acw62.useMemo)(function() {
        return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $acw62.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $acw62.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $acw62.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? "validateSync" : "validate"](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $3rtvu.default)(value)) return prepareDataForValidation(value);
            else return value !== "" ? value : undefined;
        });
        else if ((0, $3rtvu.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== "" ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === "undefined") {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $cCVp3.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $cCVp3.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === "boolean") return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == "true" || valueProp == "false") return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function useEventCallback(fn) {
    var ref = (0, $acw62.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $acw62.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $acw62.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $9RYKL.default)(false);
    var fieldHelpers = (0, $acw62.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $acw62.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === "string") {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $acw62.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || "input";
    if (typeof asElement === "string") {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $acw62.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $acw62.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : "#";
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $acw62.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = "Form";
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== "function") // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || "Component";
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $acw62.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $acw62.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $acw62.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $acw62.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $9RYKL.default)(false);
            return (0, $acw62.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || "Component"; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === "function" ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $chB0Q.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $acw62.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? (0, $acw62.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $acw62.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $acw62.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $acw62.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $9RYKL.default)(false);
        !!(component && render) && (0, $9RYKL.default)(false);
        !!(is && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(component && children && isFunction(children)) && (0, $9RYKL.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $9RYKL.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === "string") {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $acw62.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $acw62.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || "input";
        if (typeof asElement === "string") {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $acw62.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $acw62.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $acw62.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("cCVp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $93158fb633685272$export$2e2bcd8739ae039);
var $93158fb633685272$var$isMergeableObject = function isMergeableObject(value) {
    return $93158fb633685272$var$isNonNullObject(value) && !$93158fb633685272$var$isSpecial(value);
};
function $93158fb633685272$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $93158fb633685272$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $93158fb633685272$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $93158fb633685272$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $93158fb633685272$var$REACT_ELEMENT_TYPE = $93158fb633685272$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $93158fb633685272$var$isReactElement(value) {
    return value.$$typeof === $93158fb633685272$var$REACT_ELEMENT_TYPE;
}
function $93158fb633685272$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $93158fb633685272$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $93158fb633685272$var$deepmerge($93158fb633685272$var$emptyTarget(value), value, options) : value;
}
function $93158fb633685272$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $93158fb633685272$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $93158fb633685272$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $93158fb633685272$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $93158fb633685272$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $93158fb633685272$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $93158fb633685272$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $93158fb633685272$var$mergeObject(target, source, options);
}
$93158fb633685272$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $93158fb633685272$var$deepmerge(prev, next, options);
    }, {});
};
var $93158fb633685272$var$deepmerge_1 = $93158fb633685272$var$deepmerge;
var $93158fb633685272$export$2e2bcd8739ae039 = $93158fb633685272$var$deepmerge_1;

});

parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});


parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});


parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = "[object Arguments]", $bc81bf84e8d65dab$var$arrayTag = "[object Array]", $bc81bf84e8d65dab$var$boolTag = "[object Boolean]", $bc81bf84e8d65dab$var$dateTag = "[object Date]", $bc81bf84e8d65dab$var$errorTag = "[object Error]", $bc81bf84e8d65dab$var$funcTag = "[object Function]", $bc81bf84e8d65dab$var$genTag = "[object GeneratorFunction]", $bc81bf84e8d65dab$var$mapTag = "[object Map]", $bc81bf84e8d65dab$var$numberTag = "[object Number]", $bc81bf84e8d65dab$var$objectTag = "[object Object]", $bc81bf84e8d65dab$var$regexpTag = "[object RegExp]", $bc81bf84e8d65dab$var$setTag = "[object Set]", $bc81bf84e8d65dab$var$stringTag = "[object String]", $bc81bf84e8d65dab$var$symbolTag = "[object Symbol]", $bc81bf84e8d65dab$var$weakMapTag = "[object WeakMap]";
var $bc81bf84e8d65dab$var$arrayBufferTag = "[object ArrayBuffer]", $bc81bf84e8d65dab$var$dataViewTag = "[object DataView]", $bc81bf84e8d65dab$var$float32Tag = "[object Float32Array]", $bc81bf84e8d65dab$var$float64Tag = "[object Float64Array]", $bc81bf84e8d65dab$var$int8Tag = "[object Int8Array]", $bc81bf84e8d65dab$var$int16Tag = "[object Int16Array]", $bc81bf84e8d65dab$var$int32Tag = "[object Int32Array]", $bc81bf84e8d65dab$var$uint8Tag = "[object Uint8Array]", $bc81bf84e8d65dab$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bc81bf84e8d65dab$var$uint16Tag = "[object Uint16Array]", $bc81bf84e8d65dab$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype["delete"] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype["delete"] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), "Map");
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp("^" + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = "[object AsyncFunction]", $397b12740d7995ef$var$funcTag = "[object Function]", $397b12740d7995ef$var$genTag = "[object GeneratorFunction]", $397b12740d7995ef$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)["__core-js_shared__"];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype["delete"] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $lSo3Y.default),
        "map": new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        "string": new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype["delete"] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, "create");
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, "callee") && !$44fca59879666c41$var$propertyIsEnumerable.call(value, "callee");
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});


parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = "[object Arguments]", $a51ff94e4fd33486$var$arrayTag = "[object Array]", $a51ff94e4fd33486$var$boolTag = "[object Boolean]", $a51ff94e4fd33486$var$dateTag = "[object Date]", $a51ff94e4fd33486$var$errorTag = "[object Error]", $a51ff94e4fd33486$var$funcTag = "[object Function]", $a51ff94e4fd33486$var$mapTag = "[object Map]", $a51ff94e4fd33486$var$numberTag = "[object Number]", $a51ff94e4fd33486$var$objectTag = "[object Object]", $a51ff94e4fd33486$var$regexpTag = "[object RegExp]", $a51ff94e4fd33486$var$setTag = "[object Set]", $a51ff94e4fd33486$var$stringTag = "[object String]", $a51ff94e4fd33486$var$weakMapTag = "[object WeakMap]";
var $a51ff94e4fd33486$var$arrayBufferTag = "[object ArrayBuffer]", $a51ff94e4fd33486$var$dataViewTag = "[object DataView]", $a51ff94e4fd33486$var$float32Tag = "[object Float32Array]", $a51ff94e4fd33486$var$float64Tag = "[object Float64Array]", $a51ff94e4fd33486$var$int8Tag = "[object Int8Array]", $a51ff94e4fd33486$var$int16Tag = "[object Int16Array]", $a51ff94e4fd33486$var$int32Tag = "[object Int32Array]", $a51ff94e4fd33486$var$uint8Tag = "[object Uint8Array]", $a51ff94e4fd33486$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a51ff94e4fd33486$var$uint16Tag = "[object Uint16Array]", $a51ff94e4fd33486$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});


parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = "[object Map]", $34aa59a61c7ccccb$var$objectTag = "[object Object]", $34aa59a61c7ccccb$var$promiseTag = "[object Promise]", $34aa59a61c7ccccb$var$setTag = "[object Set]", $34aa59a61c7ccccb$var$weakMapTag = "[object WeakMap]";
var $34aa59a61c7ccccb$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), "DataView");
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), "Promise");
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), "Set");
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), "WeakMap");
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7103088c29fc4f0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = "[object Boolean]", $d8c6c80dd3650253$var$dateTag = "[object Date]", $d8c6c80dd3650253$var$mapTag = "[object Map]", $d8c6c80dd3650253$var$numberTag = "[object Number]", $d8c6c80dd3650253$var$regexpTag = "[object RegExp]", $d8c6c80dd3650253$var$setTag = "[object Set]", $d8c6c80dd3650253$var$stringTag = "[object String]", $d8c6c80dd3650253$var$symbolTag = "[object Symbol]";
var $d8c6c80dd3650253$var$arrayBufferTag = "[object ArrayBuffer]", $d8c6c80dd3650253$var$dataViewTag = "[object DataView]", $d8c6c80dd3650253$var$float32Tag = "[object Float32Array]", $d8c6c80dd3650253$var$float64Tag = "[object Float64Array]", $d8c6c80dd3650253$var$int8Tag = "[object Int8Array]", $d8c6c80dd3650253$var$int16Tag = "[object Int16Array]", $d8c6c80dd3650253$var$int32Tag = "[object Int32Array]", $d8c6c80dd3650253$var$uint8Tag = "[object Uint8Array]", $d8c6c80dd3650253$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d8c6c80dd3650253$var$uint16Tag = "[object Uint16Array]", $d8c6c80dd3650253$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("ai2Pb", function(module, exports) {
"use strict";
var $77ddc6be16b1d7de$var$isArray = Array.isArray;
var $77ddc6be16b1d7de$var$keyList = Object.keys;
var $77ddc6be16b1d7de$var$hasProp = Object.prototype.hasOwnProperty;
var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
function $77ddc6be16b1d7de$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $77ddc6be16b1d7de$var$isArray(a), arrB = $77ddc6be16b1d7de$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $77ddc6be16b1d7de$var$keyList(a);
        length = keys.length;
        if (length !== $77ddc6be16b1d7de$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$77ddc6be16b1d7de$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("hNIl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5967d89366f433$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $cf5967d89366f433$var$clone(value) {
    return (0, $gbpSA.default)(value, $cf5967d89366f433$var$CLONE_SYMBOLS_FLAG);
}
var $cf5967d89366f433$export$2e2bcd8739ae039 = $cf5967d89366f433$var$clone;

});

parcelRegister("58lCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bce775629368657$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $jXStN = parcelRequire("jXStN");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");

var $6D9Aa = parcelRequire("6D9Aa");

var $ft2bY = parcelRequire("ft2bY");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $3bce775629368657$var$toPath(value) {
    if ((0, $hf0C9.default)(value)) return (0, $afgje.default)(value, (0, $ft2bY.default));
    return (0, $1WN0o.default)(value) ? [
        value
    ] : (0, $jXStN.default)((0, $6D9Aa.default)((0, $1fnxW.default)(value)));
}
var $3bce775629368657$export$2e2bcd8739ae039 = $3bce775629368657$var$toPath;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});

parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == "string" || (0, $1WN0o.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? "-0" : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});

parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? "" : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + "";
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? "-0" : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});



parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});




parcelRegister("7Asxf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $586207b015d42b2f$export$1e511d4a378977f5, (v) => $586207b015d42b2f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $586207b015d42b2f$export$2e2bcd8739ae039, (v) => $586207b015d42b2f$export$2e2bcd8739ae039 = v);
var $586207b015d42b2f$export$1e511d4a378977f5;
var $586207b015d42b2f$export$2e2bcd8739ae039;
"use strict";
$586207b015d42b2f$export$1e511d4a378977f5 = true;
$586207b015d42b2f$export$2e2bcd8739ae039 = $586207b015d42b2f$var$createWebStorage;

var $586207b015d42b2f$var$_getStorage = $586207b015d42b2f$var$_interopRequireDefault((parcelRequire("kagwK")));
function $586207b015d42b2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $586207b015d42b2f$var$createWebStorage(type) {
    var storage = (0, $586207b015d42b2f$var$_getStorage.default)(type);
    return {
        getItem: function getItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.getItem(key));
            });
        },
        setItem: function setItem(key, item) {
            return new Promise(function(resolve, reject) {
                resolve(storage.setItem(key, item));
            });
        },
        removeItem: function removeItem(key) {
            return new Promise(function(resolve, reject) {
                resolve(storage.removeItem(key));
            });
        }
    };
}

});
parcelRegister("kagwK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eae18fc1294d0f44$export$1e511d4a378977f5, (v) => $eae18fc1294d0f44$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eae18fc1294d0f44$export$2e2bcd8739ae039, (v) => $eae18fc1294d0f44$export$2e2bcd8739ae039 = v);
var $eae18fc1294d0f44$export$1e511d4a378977f5;
var $eae18fc1294d0f44$export$2e2bcd8739ae039;
"use strict";
$eae18fc1294d0f44$export$1e511d4a378977f5 = true;
$eae18fc1294d0f44$export$2e2bcd8739ae039 = $eae18fc1294d0f44$var$getStorage;
function $eae18fc1294d0f44$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $eae18fc1294d0f44$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $eae18fc1294d0f44$var$_typeof(obj);
}
function $eae18fc1294d0f44$var$noop() {}
var $eae18fc1294d0f44$var$noopStorage = {
    getItem: $eae18fc1294d0f44$var$noop,
    setItem: $eae18fc1294d0f44$var$noop,
    removeItem: $eae18fc1294d0f44$var$noop
};
function $eae18fc1294d0f44$var$hasStorage(storageType) {
    if ((typeof self === "undefined" ? "undefined" : $eae18fc1294d0f44$var$_typeof(self)) !== "object" || !(storageType in self)) return false;
    try {
        var storage = self[storageType];
        var testKey = "redux-persist ".concat(storageType, " test");
        storage.setItem(testKey, "test");
        storage.getItem(testKey);
        storage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
}
function $eae18fc1294d0f44$var$getStorage(type) {
    var storageType = "".concat(type, "Storage");
    if ($eae18fc1294d0f44$var$hasStorage(storageType)) return self[storageType];
    else return $eae18fc1294d0f44$var$noopStorage;
}

});


var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
/**
 * React Router DOM v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


/**
 * @remix-run/router v1.20.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $1d34d5c4a288b213$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$export$30d21fd6d7295f52(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $1d34d5c4a288b213$export$4051a07651545597(data, init) {
    return new $1d34d5c4a288b213$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$1d34d5c4a288b213$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $1d34d5c4a288b213$var$findNearestBoundary(matches).route.id,
            {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($1d34d5c4a288b213$var$isErrorResult(result) && $1d34d5c4a288b213$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: updatedMatches || matches
        }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $1d34d5c4a288b213$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $1d34d5c4a288b213$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($1d34d5c4a288b213$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $1d34d5c4a288b213$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $1d34d5c4a288b213$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $1d34d5c4a288b213$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $1d34d5c4a288b213$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                response: $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $1d34d5c4a288b213$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($1d34d5c4a288b213$var$isDataStrategyResult(e) && $1d34d5c4a288b213$var$isResponse(e.result)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $1d34d5c4a288b213$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategy || $1d34d5c4a288b213$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($1d34d5c4a288b213$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $1d34d5c4a288b213$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $1d34d5c4a288b213$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $1d34d5c4a288b213$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $1d34d5c4a288b213$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$1d34d5c4a288b213$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $1d34d5c4a288b213$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $1d34d5c4a288b213$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $1d34d5c4a288b213$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $1d34d5c4a288b213$var$ResultType.data,
                result: undefined
            });
        };
        return $1d34d5c4a288b213$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $1d34d5c4a288b213$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (type === $1d34d5c4a288b213$var$ResultType.error) return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $1d34d5c4a288b213$var$ResultType.error) {
        if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $1d34d5c4a288b213$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown data() to ErrorResponse instances
            result = new $1d34d5c4a288b213$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: result,
            statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($1d34d5c4a288b213$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $1d34d5c4a288b213$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $1d34d5c4a288b213$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $1d34d5c4a288b213$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $1d34d5c4a288b213$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $1d34d5c4a288b213$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $1d34d5c4a288b213$var$ResultType.data || result.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isRedirectDataStrategyResultResult(result) {
    return $1d34d5c4a288b213$var$isResponse(result.result) && $1d34d5c4a288b213$var$redirectStatusCodes.has(result.result.status);
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $1d34d5c4a288b213$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.27.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, (0, $1d34d5c4a288b213$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : "_data" in promise ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $11492dca620dcaa5$exports[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $acw62.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $040dbb9c344a508d$var$MemoizedDataRoutes = /*#__PURE__*/ $acw62.memo($040dbb9c344a508d$var$DataRoutes);
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $701b6c0516155145$exports = {};
"use strict";

$701b6c0516155145$exports = (parcelRequire("iZZ9K"));


var $55388fc2f116d4d7$var$__defProp = Object.defineProperty;
var $55388fc2f116d4d7$var$__defProps = Object.defineProperties;
var $55388fc2f116d4d7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $55388fc2f116d4d7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $55388fc2f116d4d7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $55388fc2f116d4d7$var$__defNormalProp = (obj, key, value)=>key in obj ? $55388fc2f116d4d7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $55388fc2f116d4d7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($55388fc2f116d4d7$var$__hasOwnProp.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    if ($55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(b))if ($55388fc2f116d4d7$var$__propIsEnum.call(b, prop)) $55388fc2f116d4d7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $55388fc2f116d4d7$var$__spreadProps = (a, b)=>$55388fc2f116d4d7$var$__defProps(a, $55388fc2f116d4d7$var$__getOwnPropDescs(b));
var $55388fc2f116d4d7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($55388fc2f116d4d7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $55388fc2f116d4d7$var$__getOwnPropSymbols) {
        for (var prop of $55388fc2f116d4d7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $55388fc2f116d4d7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $55388fc2f116d4d7$var$IS_REACT_19 = /* @__PURE__ */ $acw62.version.startsWith("19");
var $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($55388fc2f116d4d7$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $55388fc2f116d4d7$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $55388fc2f116d4d7$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $55388fc2f116d4d7$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $55388fc2f116d4d7$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $55388fc2f116d4d7$var$ForwardRef = $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE;
var $55388fc2f116d4d7$var$Memo = $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
function $55388fc2f116d4d7$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE || type === $55388fc2f116d4d7$var$REACT_PROFILER_TYPE || type === $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE || type === $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE || type === $55388fc2f116d4d7$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $55388fc2f116d4d7$var$REACT_LAZY_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_MEMO_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $55388fc2f116d4d7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $55388fc2f116d4d7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $55388fc2f116d4d7$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $55388fc2f116d4d7$var$REACT_FRAGMENT_TYPE:
                    case $55388fc2f116d4d7$var$REACT_PROFILER_TYPE:
                    case $55388fc2f116d4d7$var$REACT_STRICT_MODE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_TYPE:
                    case $55388fc2f116d4d7$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE:
                            case $55388fc2f116d4d7$var$REACT_FORWARD_REF_TYPE:
                            case $55388fc2f116d4d7$var$REACT_LAZY_TYPE:
                            case $55388fc2f116d4d7$var$REACT_MEMO_TYPE:
                                return object;
                            case $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $55388fc2f116d4d7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $55388fc2f116d4d7$var$isContextConsumer(object) {
    return $55388fc2f116d4d7$var$IS_REACT_19 ? $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONSUMER_TYPE : $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_CONTEXT_TYPE;
}
function $55388fc2f116d4d7$var$isMemo(object) {
    return $55388fc2f116d4d7$var$typeOf(object) === $55388fc2f116d4d7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $55388fc2f116d4d7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $55388fc2f116d4d7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $55388fc2f116d4d7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $55388fc2f116d4d7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $55388fc2f116d4d7$var$verify(mapStateToProps, "mapStateToProps");
    $55388fc2f116d4d7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $55388fc2f116d4d7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $55388fc2f116d4d7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $55388fc2f116d4d7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $55388fc2f116d4d7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $55388fc2f116d4d7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $55388fc2f116d4d7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $55388fc2f116d4d7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$55388fc2f116d4d7$var$isPlainObject(value)) $55388fc2f116d4d7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $55388fc2f116d4d7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $55388fc2f116d4d7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $55388fc2f116d4d7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $55388fc2f116d4d7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $55388fc2f116d4d7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $55388fc2f116d4d7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $55388fc2f116d4d7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $55388fc2f116d4d7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues($55388fc2f116d4d7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $55388fc2f116d4d7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$55388fc2f116d4d7$var$defaultMergeProps : typeof mergeProps === "function" ? $55388fc2f116d4d7$var$wrapMergePropsFunc(mergeProps) : $55388fc2f116d4d7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $55388fc2f116d4d7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $55388fc2f116d4d7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $55388fc2f116d4d7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $55388fc2f116d4d7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $55388fc2f116d4d7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $55388fc2f116d4d7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $55388fc2f116d4d7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $55388fc2f116d4d7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $55388fc2f116d4d7$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $55388fc2f116d4d7$var$isDOM = /* @__PURE__ */ $55388fc2f116d4d7$var$canUseDOM();
var $55388fc2f116d4d7$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $55388fc2f116d4d7$var$isReactNative = /* @__PURE__ */ $55388fc2f116d4d7$var$isRunningInReactNative();
var $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect = ()=>$55388fc2f116d4d7$var$isDOM || $55388fc2f116d4d7$var$isReactNative ? $acw62.useLayoutEffect : $acw62.useEffect;
var $55388fc2f116d4d7$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $55388fc2f116d4d7$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $55388fc2f116d4d7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $55388fc2f116d4d7$export$d36bdfa510afb180(objA, objB) {
    if ($55388fc2f116d4d7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$55388fc2f116d4d7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $55388fc2f116d4d7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $55388fc2f116d4d7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $55388fc2f116d4d7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $55388fc2f116d4d7$var$TYPE_STATICS = {
    [$55388fc2f116d4d7$var$ForwardRef]: $55388fc2f116d4d7$var$FORWARD_REF_STATICS,
    [$55388fc2f116d4d7$var$Memo]: $55388fc2f116d4d7$var$MEMO_STATICS
};
function $55388fc2f116d4d7$var$getStatics(component) {
    if ($55388fc2f116d4d7$var$isMemo(component)) return $55388fc2f116d4d7$var$MEMO_STATICS;
    return $55388fc2f116d4d7$var$TYPE_STATICS[component["$$typeof"]] || $55388fc2f116d4d7$var$REACT_STATICS;
}
var $55388fc2f116d4d7$var$defineProperty = Object.defineProperty;
var $55388fc2f116d4d7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $55388fc2f116d4d7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $55388fc2f116d4d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $55388fc2f116d4d7$var$getPrototypeOf = Object.getPrototypeOf;
var $55388fc2f116d4d7$var$objectPrototype = Object.prototype;
function $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($55388fc2f116d4d7$var$objectPrototype) {
            const inheritedComponent = $55388fc2f116d4d7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $55388fc2f116d4d7$var$objectPrototype) $55388fc2f116d4d7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $55388fc2f116d4d7$var$getOwnPropertyNames(sourceComponent);
        if ($55388fc2f116d4d7$var$getOwnPropertySymbols) keys = keys.concat($55388fc2f116d4d7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $55388fc2f116d4d7$var$getStatics(targetComponent);
        const sourceStatics = $55388fc2f116d4d7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$55388fc2f116d4d7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $55388fc2f116d4d7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $55388fc2f116d4d7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $55388fc2f116d4d7$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $55388fc2f116d4d7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $55388fc2f116d4d7$var$getContext() {
    var _a;
    if (!$acw62.createContext) return {};
    const contextMap = (_a = $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey]) != null ? _a : $55388fc2f116d4d7$var$gT[$55388fc2f116d4d7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($acw62.createContext);
    if (!realContext) {
        realContext = $acw62.createContext(null);
        contextMap.set($acw62.createContext, realContext);
    }
    return realContext;
}
var $55388fc2f116d4d7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $55388fc2f116d4d7$var$getContext();
// src/components/connect.tsx
var $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $55388fc2f116d4d7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $55388fc2f116d4d7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $55388fc2f116d4d7$var$strictEqual(a, b) {
    return a === b;
}
var $55388fc2f116d4d7$var$hasWarnedAboutDeprecatedPureOption = false;
function $55388fc2f116d4d7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $55388fc2f116d4d7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $55388fc2f116d4d7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $55388fc2f116d4d7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $55388fc2f116d4d7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $55388fc2f116d4d7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $55388fc2f116d4d7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $acw62.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $55388fc2f116d4d7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $acw62.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $acw62.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $acw62.useMemo(()=>{
                return $55388fc2f116d4d7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $acw62.useMemo(()=>{
                if (!shouldHandleStateChanges) return $55388fc2f116d4d7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $55388fc2f116d4d7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $acw62.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $acw62.useRef(void 0);
            const lastWrapperProps = $acw62.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $acw62.useRef(void 0);
            const renderIsScheduled = $acw62.useRef(false);
            const isMounted = $acw62.useRef(false);
            const latestSubscriptionCallbackError = $acw62.useRef(void 0);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $acw62.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $acw62.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $55388fc2f116d4d7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffectWithArgs($55388fc2f116d4d7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $acw62.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $acw62.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $acw62.createElement(WrappedComponent, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $acw62.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $acw62.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $acw62.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $acw62.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $acw62.createElement(Connect, $55388fc2f116d4d7$var$__spreadProps($55388fc2f116d4d7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $55388fc2f116d4d7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $55388fc2f116d4d7$export$64605811ab45167f = $55388fc2f116d4d7$var$connect;
// src/components/Provider.tsx
function $55388fc2f116d4d7$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $acw62.useMemo(()=>{
        const subscription = $55388fc2f116d4d7$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $acw62.useMemo(()=>store.getState(), [
        store
    ]);
    $55388fc2f116d4d7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $55388fc2f116d4d7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $acw62.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $55388fc2f116d4d7$export$2881499e37b75b9a = $55388fc2f116d4d7$var$Provider;
// src/hooks/useReduxContext.ts
function $55388fc2f116d4d7$var$createReduxContextHook(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $acw62.useContext(context);
        return contextValue;
    };
}
var $55388fc2f116d4d7$var$useReduxContext = /* @__PURE__ */ $55388fc2f116d4d7$var$createReduxContextHook();
// src/hooks/useStore.ts
function $55388fc2f116d4d7$export$671dba69185d0304(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : // @ts-ignore
    $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $55388fc2f116d4d7$export$6ccbb43953eebf8 = /* @__PURE__ */ $55388fc2f116d4d7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $55388fc2f116d4d7$export$bc9b55530897c558(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$export$6ccbb43953eebf8 : $55388fc2f116d4d7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $55388fc2f116d4d7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $55388fc2f116d4d7$export$bc9b55530897c558();
var $55388fc2f116d4d7$var$refEquality = (a, b)=>a === b;
function $55388fc2f116d4d7$export$2b53f90d2bd1cbfb(context = $55388fc2f116d4d7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $55388fc2f116d4d7$export$cc80c08dc91f1c00 ? $55388fc2f116d4d7$var$useReduxContext : $55388fc2f116d4d7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $55388fc2f116d4d7$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $acw62.useRef(true);
        const wrappedSelector = $acw62.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $701b6c0516155145$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $acw62.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $55388fc2f116d4d7$export$2105062e25df4afe = /* @__PURE__ */ $55388fc2f116d4d7$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $55388fc2f116d4d7$export$712ea50be43a7858 = $55388fc2f116d4d7$var$defaultNoopBatch;


// src/utils/formatProdErrorMessage.ts
function $d2bed10dff9b4968$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $d2bed10dff9b4968$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $d2bed10dff9b4968$var$symbol_observable_default = $d2bed10dff9b4968$var$$$observable;
// src/utils/actionTypes.ts
var $d2bed10dff9b4968$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $d2bed10dff9b4968$var$ActionTypes = {
    INIT: `@@redux/INIT${$d2bed10dff9b4968$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$d2bed10dff9b4968$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$d2bed10dff9b4968$var$randomString()}`
};
var $d2bed10dff9b4968$export$4219e499db7ca678 = $d2bed10dff9b4968$var$ActionTypes;
// src/utils/isPlainObject.ts
function $d2bed10dff9b4968$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $d2bed10dff9b4968$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($d2bed10dff9b4968$var$isDate(val)) return "date";
    if ($d2bed10dff9b4968$var$isError(val)) return "error";
    const constructorName = $d2bed10dff9b4968$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $d2bed10dff9b4968$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $d2bed10dff9b4968$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $d2bed10dff9b4968$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $d2bed10dff9b4968$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(1));
        return enhancer($d2bed10dff9b4968$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(action)) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$d2bed10dff9b4968$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$d2bed10dff9b4968$var$symbol_observable_default]: observable
    };
    return store;
}
function $d2bed10dff9b4968$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $d2bed10dff9b4968$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $d2bed10dff9b4968$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $d2bed10dff9b4968$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d2bed10dff9b4968$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$d2bed10dff9b4968$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d2bed10dff9b4968$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $d2bed10dff9b4968$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $d2bed10dff9b4968$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(13));
    });
}
function $d2bed10dff9b4968$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $d2bed10dff9b4968$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $d2bed10dff9b4968$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $d2bed10dff9b4968$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $d2bed10dff9b4968$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $d2bed10dff9b4968$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $d2bed10dff9b4968$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($d2bed10dff9b4968$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $d2bed10dff9b4968$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $d2bed10dff9b4968$export$b956e38827fca970(action) {
    return $d2bed10dff9b4968$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $b9146244dc19043a$var$__defProp = Object.defineProperty;
var $b9146244dc19043a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b9146244dc19043a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b9146244dc19043a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b9146244dc19043a$var$__defNormalProp = (obj, key, value)=>key in obj ? $b9146244dc19043a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b9146244dc19043a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b9146244dc19043a$var$__hasOwnProp.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    if ($b9146244dc19043a$var$__getOwnPropSymbols) {
        for (var prop of $b9146244dc19043a$var$__getOwnPropSymbols(b))if ($b9146244dc19043a$var$__propIsEnum.call(b, prop)) $b9146244dc19043a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $b9146244dc19043a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $b9146244dc19043a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $b9146244dc19043a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $b9146244dc19043a$var$errors = [];
function $b9146244dc19043a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $b9146244dc19043a$var$getPrototypeOf = Object.getPrototypeOf;
function $b9146244dc19043a$export$541ac630993a4c84(value) {
    return !!value && !!value[$b9146244dc19043a$var$DRAFT_STATE];
}
function $b9146244dc19043a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $b9146244dc19043a$var$isPlainObject(value) || Array.isArray(value) || !!value[$b9146244dc19043a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$b9146244dc19043a$export$6ee2082928bcb0ee]) || $b9146244dc19043a$var$isMap(value) || $b9146244dc19043a$var$isSet(value);
}
var $b9146244dc19043a$var$objectCtorString = Object.prototype.constructor.toString();
function $b9146244dc19043a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $b9146244dc19043a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $b9146244dc19043a$var$objectCtorString;
}
function $b9146244dc19043a$export$22e8af3f75a010e3(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(15, value);
    return value[$b9146244dc19043a$var$DRAFT_STATE].base_;
}
function $b9146244dc19043a$var$each(obj, iter) {
    if ($b9146244dc19043a$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $b9146244dc19043a$var$getArchtype(thing) {
    const state = thing[$b9146244dc19043a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $b9146244dc19043a$var$isMap(thing) ? 2 /* Map */  : $b9146244dc19043a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $b9146244dc19043a$var$has(thing, prop) {
    return $b9146244dc19043a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $b9146244dc19043a$var$get(thing, prop) {
    return $b9146244dc19043a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $b9146244dc19043a$var$set(thing, propOrOldValue, value) {
    const t = $b9146244dc19043a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $b9146244dc19043a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b9146244dc19043a$var$isMap(target) {
    return target instanceof Map;
}
function $b9146244dc19043a$var$isSet(target) {
    return target instanceof Set;
}
function $b9146244dc19043a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $b9146244dc19043a$var$shallowCopy(base, strict) {
    if ($b9146244dc19043a$var$isMap(base)) return new Map(base);
    if ($b9146244dc19043a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $b9146244dc19043a$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$b9146244dc19043a$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($b9146244dc19043a$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $b9146244dc19043a$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $b9146244dc19043a$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $b9146244dc19043a$export$792f3d81ea979f55(obj, deep = false) {
    if ($b9146244dc19043a$var$isFrozen(obj) || $b9146244dc19043a$export$541ac630993a4c84(obj) || !$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
    if ($b9146244dc19043a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $b9146244dc19043a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$b9146244dc19043a$export$792f3d81ea979f55(value, true));
    return obj;
}
function $b9146244dc19043a$var$dontMutateFrozenCollections() {
    $b9146244dc19043a$var$die(2);
}
function $b9146244dc19043a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $b9146244dc19043a$var$plugins = {};
function $b9146244dc19043a$var$getPlugin(pluginKey) {
    const plugin = $b9146244dc19043a$var$plugins[pluginKey];
    if (!plugin) $b9146244dc19043a$var$die(0, pluginKey);
    return plugin;
}
function $b9146244dc19043a$var$loadPlugin(pluginKey, implementation) {
    if (!$b9146244dc19043a$var$plugins[pluginKey]) $b9146244dc19043a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $b9146244dc19043a$var$currentScope;
function $b9146244dc19043a$var$getCurrentScope() {
    return $b9146244dc19043a$var$currentScope;
}
function $b9146244dc19043a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $b9146244dc19043a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $b9146244dc19043a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $b9146244dc19043a$var$revokeScope(scope) {
    $b9146244dc19043a$var$leaveScope(scope);
    scope.drafts_.forEach($b9146244dc19043a$var$revokeDraft);
    scope.drafts_ = null;
}
function $b9146244dc19043a$var$leaveScope(scope) {
    if (scope === $b9146244dc19043a$var$currentScope) $b9146244dc19043a$var$currentScope = scope.parent_;
}
function $b9146244dc19043a$var$enterScope(immer2) {
    return $b9146244dc19043a$var$currentScope = $b9146244dc19043a$var$createScope($b9146244dc19043a$var$currentScope, immer2);
}
function $b9146244dc19043a$var$revokeDraft(draft) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $b9146244dc19043a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$b9146244dc19043a$var$DRAFT_STATE].modified_) {
            $b9146244dc19043a$var$revokeScope(scope);
            $b9146244dc19043a$var$die(4);
        }
        if ($b9146244dc19043a$export$16e3aed3edb85946(result)) {
            result = $b9146244dc19043a$var$finalize(scope, result);
            if (!scope.parent_) $b9146244dc19043a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $b9146244dc19043a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$b9146244dc19043a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $b9146244dc19043a$var$finalize(scope, baseDraft, []);
    $b9146244dc19043a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $b9146244dc19043a$export$45b790e32b2810ee ? result : void 0;
}
function $b9146244dc19043a$var$finalize(rootScope, value, path) {
    if ($b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    if (!state) {
        $b9146244dc19043a$var$each(value, (key, childValue)=>$b9146244dc19043a$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $b9146244dc19043a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $b9146244dc19043a$var$each(resultEach, (key, childValue)=>$b9146244dc19043a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $b9146244dc19043a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $b9146244dc19043a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $b9146244dc19043a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($b9146244dc19043a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$b9146244dc19043a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $b9146244dc19043a$var$finalize(rootScope, childValue, path);
        $b9146244dc19043a$var$set(targetObject, prop, res);
        if ($b9146244dc19043a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($b9146244dc19043a$export$16e3aed3edb85946(childValue) && !$b9146244dc19043a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $b9146244dc19043a$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $b9146244dc19043a$var$maybeFreeze(rootScope, childValue);
    }
}
function $b9146244dc19043a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $b9146244dc19043a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $b9146244dc19043a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $b9146244dc19043a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $b9146244dc19043a$var$objectTraps = {
    get (state, prop) {
        if (prop === $b9146244dc19043a$var$DRAFT_STATE) return state;
        const source = $b9146244dc19043a$var$latest(state);
        if (!$b9146244dc19043a$var$has(source, prop)) return $b9146244dc19043a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
        if (value === $b9146244dc19043a$var$peek(state.base_, prop)) {
            $b9146244dc19043a$var$prepareCopy(state);
            return state.copy_[prop] = $b9146244dc19043a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $b9146244dc19043a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($b9146244dc19043a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $b9146244dc19043a$var$getDescriptorFromProto($b9146244dc19043a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $b9146244dc19043a$var$peek($b9146244dc19043a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$b9146244dc19043a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($b9146244dc19043a$var$is(value, current2) && (value !== void 0 || $b9146244dc19043a$var$has(state.base_, prop))) return true;
            $b9146244dc19043a$var$prepareCopy(state);
            $b9146244dc19043a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($b9146244dc19043a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $b9146244dc19043a$var$prepareCopy(state);
            $b9146244dc19043a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $b9146244dc19043a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $b9146244dc19043a$var$die(11);
    },
    getPrototypeOf (state) {
        return $b9146244dc19043a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $b9146244dc19043a$var$die(12);
    }
};
var $b9146244dc19043a$var$arrayTraps = {};
$b9146244dc19043a$var$each($b9146244dc19043a$var$objectTraps, (key, fn)=>{
    $b9146244dc19043a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$b9146244dc19043a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $b9146244dc19043a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$b9146244dc19043a$var$arrayTraps.set = function(state, prop, value) {
    return $b9146244dc19043a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $b9146244dc19043a$var$peek(draft, prop) {
    const state = draft[$b9146244dc19043a$var$DRAFT_STATE];
    const source = state ? $b9146244dc19043a$var$latest(state) : draft;
    return source[prop];
}
function $b9146244dc19043a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $b9146244dc19043a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $b9146244dc19043a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $b9146244dc19043a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $b9146244dc19043a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $b9146244dc19043a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $b9146244dc19043a$var$markChanged(state.parent_);
    }
}
function $b9146244dc19043a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $b9146244dc19043a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $b9146244dc19043a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $b9146244dc19043a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $b9146244dc19043a$var$die(7);
            let result;
            if ($b9146244dc19043a$export$16e3aed3edb85946(base)) {
                const scope = $b9146244dc19043a$var$enterScope(this);
                const proxy = $b9146244dc19043a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $b9146244dc19043a$var$revokeScope(scope);
                    else $b9146244dc19043a$var$leaveScope(scope);
                }
                $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
                return $b9146244dc19043a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $b9146244dc19043a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $b9146244dc19043a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $b9146244dc19043a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $b9146244dc19043a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(base)) $b9146244dc19043a$var$die(8);
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) base = $b9146244dc19043a$export$97aac956da55dae9(base);
        const scope = $b9146244dc19043a$var$enterScope(this);
        const proxy = $b9146244dc19043a$var$createProxy(base, void 0);
        proxy[$b9146244dc19043a$var$DRAFT_STATE].isManual_ = true;
        $b9146244dc19043a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$b9146244dc19043a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $b9146244dc19043a$var$die(9);
        const { scope_: scope } = state;
        $b9146244dc19043a$var$usePatchesInScope(scope, patchListener);
        return $b9146244dc19043a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $b9146244dc19043a$var$getPlugin("Patches").applyPatches_;
        if ($b9146244dc19043a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $b9146244dc19043a$var$createProxy(value, parent) {
    const draft = $b9146244dc19043a$var$isMap(value) ? $b9146244dc19043a$var$getPlugin("MapSet").proxyMap_(value, parent) : $b9146244dc19043a$var$isSet(value) ? $b9146244dc19043a$var$getPlugin("MapSet").proxySet_(value, parent) : $b9146244dc19043a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $b9146244dc19043a$export$97aac956da55dae9(value) {
    if (!$b9146244dc19043a$export$541ac630993a4c84(value)) $b9146244dc19043a$var$die(10, value);
    return $b9146244dc19043a$var$currentImpl(value);
}
function $b9146244dc19043a$var$currentImpl(value) {
    if (!$b9146244dc19043a$export$16e3aed3edb85946(value) || $b9146244dc19043a$var$isFrozen(value)) return value;
    const state = value[$b9146244dc19043a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $b9146244dc19043a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $b9146244dc19043a$var$shallowCopy(value, true);
    $b9146244dc19043a$var$each(copy, (key, childValue)=>{
        $b9146244dc19043a$var$set(copy, key, $b9146244dc19043a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $b9146244dc19043a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $b9146244dc19043a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $b9146244dc19043a$var$get(base_, key);
            const value = $b9146244dc19043a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $b9146244dc19043a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $b9146244dc19043a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $b9146244dc19043a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $b9146244dc19043a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $b9146244dc19043a$var$die(errorOffset + 3);
                base = $b9146244dc19043a$var$get(base, p);
                if (typeof base !== "object") $b9146244dc19043a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $b9146244dc19043a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $b9146244dc19043a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $b9146244dc19043a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$b9146244dc19043a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($b9146244dc19043a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($b9146244dc19043a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($b9146244dc19043a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($b9146244dc19043a$var$has(obj, $b9146244dc19043a$export$6ee2082928bcb0ee)) cloned[$b9146244dc19043a$export$6ee2082928bcb0ee] = obj[$b9146244dc19043a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($b9146244dc19043a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $b9146244dc19043a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $b9146244dc19043a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$b9146244dc19043a$var$latest(state).has(key) || $b9146244dc19043a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareMapCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $b9146244dc19043a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            $b9146244dc19043a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $b9146244dc19043a$var$latest(state).get(key);
            if (state.finalized_ || !$b9146244dc19043a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $b9146244dc19043a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$b9146244dc19043a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $b9146244dc19043a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $b9146244dc19043a$var$latest(this[$b9146244dc19043a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $b9146244dc19043a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($b9146244dc19043a$var$latest(state).size) {
                prepareSetCopy(state);
                $b9146244dc19043a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$b9146244dc19043a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($b9146244dc19043a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($b9146244dc19043a$export$16e3aed3edb85946(value)) {
                    const draft = $b9146244dc19043a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $b9146244dc19043a$var$die(3, JSON.stringify($b9146244dc19043a$var$latest(state)));
    }
    $b9146244dc19043a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $b9146244dc19043a$var$immer = new $b9146244dc19043a$export$aaadc6ff0f822719();
var $b9146244dc19043a$export$b46cabe22e78bc00 = $b9146244dc19043a$var$immer.produce;
var $b9146244dc19043a$export$4da66d41c9492c78 = $b9146244dc19043a$var$immer.produceWithPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$573f26f60825c493 = $b9146244dc19043a$var$immer.setAutoFreeze.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$333ce65961cbe047 = $b9146244dc19043a$var$immer.setUseStrictShallowCopy.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$a8b8e03e6bbe5473 = $b9146244dc19043a$var$immer.applyPatches.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$3c3214997190395f = $b9146244dc19043a$var$immer.createDraft.bind($b9146244dc19043a$var$immer);
var $b9146244dc19043a$export$c60f5e69c521b528 = $b9146244dc19043a$var$immer.finishDraft.bind($b9146244dc19043a$var$immer);
function $b9146244dc19043a$export$c05b21e3257751e5(value) {
    return value;
}
function $b9146244dc19043a$export$20f911b3f8cf0b74(value) {
    return value;
}


var $375276bea32f9eda$var$__defProp = Object.defineProperty;
var $375276bea32f9eda$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $375276bea32f9eda$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $375276bea32f9eda$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $375276bea32f9eda$var$__defNormalProp = (obj, key, value)=>key in obj ? $375276bea32f9eda$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $375276bea32f9eda$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($375276bea32f9eda$var$__hasOwnProp.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    if ($375276bea32f9eda$var$__getOwnPropSymbols) {
        for (var prop of $375276bea32f9eda$var$__getOwnPropSymbols(b))if ($375276bea32f9eda$var$__propIsEnum.call(b, prop)) $375276bea32f9eda$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $375276bea32f9eda$var$__publicField = (obj, key, value)=>{
    $375276bea32f9eda$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $375276bea32f9eda$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $375276bea32f9eda$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $375276bea32f9eda$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $375276bea32f9eda$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($375276bea32f9eda$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $375276bea32f9eda$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $375276bea32f9eda$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $375276bea32f9eda$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $375276bea32f9eda$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $375276bea32f9eda$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $375276bea32f9eda$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $375276bea32f9eda$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $375276bea32f9eda$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, $375276bea32f9eda$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $375276bea32f9eda$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $375276bea32f9eda$var$$REVISION = 0;
var $375276bea32f9eda$var$CURRENT_TRACKER = null;
var $375276bea32f9eda$var$Cell = class {
    constructor(initialValue, isEqual = $375276bea32f9eda$var$tripleEq){
        $375276bea32f9eda$var$__publicField(this, "revision", $375276bea32f9eda$var$$REVISION);
        $375276bea32f9eda$var$__publicField(this, "_value");
        $375276bea32f9eda$var$__publicField(this, "_lastValue");
        $375276bea32f9eda$var$__publicField(this, "_isEqual", $375276bea32f9eda$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$375276bea32f9eda$var$$REVISION;
    }
};
function $375276bea32f9eda$var$tripleEq(a, b) {
    return a === b;
}
var $375276bea32f9eda$var$TrackingCache = class {
    constructor(fn){
        $375276bea32f9eda$var$__publicField(this, "_cachedValue");
        $375276bea32f9eda$var$__publicField(this, "_cachedRevision", -1);
        $375276bea32f9eda$var$__publicField(this, "_deps", []);
        $375276bea32f9eda$var$__publicField(this, "hits", 0);
        $375276bea32f9eda$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $375276bea32f9eda$var$CURRENT_TRACKER;
            $375276bea32f9eda$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $375276bea32f9eda$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $375276bea32f9eda$var$CURRENT_TRACKER == null || $375276bea32f9eda$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $375276bea32f9eda$var$getValue(cell) {
    if (!(cell instanceof $375276bea32f9eda$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $375276bea32f9eda$var$setValue(storage, value) {
    if (!(storage instanceof $375276bea32f9eda$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $375276bea32f9eda$var$createCell(initialValue, isEqual = $375276bea32f9eda$var$tripleEq) {
    return new $375276bea32f9eda$var$Cell(initialValue, isEqual);
}
function $375276bea32f9eda$var$createCache(fn) {
    $375276bea32f9eda$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $375276bea32f9eda$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $375276bea32f9eda$var$neverEq = (a, b)=>false;
function $375276bea32f9eda$var$createTag() {
    return $375276bea32f9eda$var$createCell(null, $375276bea32f9eda$var$neverEq);
}
function $375276bea32f9eda$var$dirtyTag(tag, value) {
    $375276bea32f9eda$var$setValue(tag, value);
}
var $375276bea32f9eda$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $375276bea32f9eda$var$createTag();
    $375276bea32f9eda$var$getValue(tag);
};
var $375276bea32f9eda$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $375276bea32f9eda$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $375276bea32f9eda$var$REDUX_PROXY_LABEL = Symbol();
var $375276bea32f9eda$var$nextId = 0;
var $375276bea32f9eda$var$proto = Object.getPrototypeOf({});
var $375276bea32f9eda$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy(this, $375276bea32f9eda$var$objectProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $375276bea32f9eda$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $375276bea32f9eda$var$createNode(childValue);
                if (childNode.tag) $375276bea32f9eda$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $375276bea32f9eda$var$createTag();
                    tag.value = childValue;
                }
                $375276bea32f9eda$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $375276bea32f9eda$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $375276bea32f9eda$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $375276bea32f9eda$var$__publicField(this, "proxy", new Proxy([
            this
        ], $375276bea32f9eda$var$arrayProxyHandler));
        $375276bea32f9eda$var$__publicField(this, "tag", $375276bea32f9eda$var$createTag());
        $375276bea32f9eda$var$__publicField(this, "tags", {});
        $375276bea32f9eda$var$__publicField(this, "children", {});
        $375276bea32f9eda$var$__publicField(this, "collectionTag", null);
        $375276bea32f9eda$var$__publicField(this, "id", $375276bea32f9eda$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $375276bea32f9eda$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $375276bea32f9eda$var$consumeCollection(node);
        return $375276bea32f9eda$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $375276bea32f9eda$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $375276bea32f9eda$var$objectProxyHandler.has(node, prop);
    }
};
function $375276bea32f9eda$var$createNode(value) {
    if (Array.isArray(value)) return new $375276bea32f9eda$var$ArrayTreeNode(value);
    return new $375276bea32f9eda$var$ObjectTreeNode(value);
}
function $375276bea32f9eda$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $375276bea32f9eda$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $375276bea32f9eda$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $375276bea32f9eda$var$dirtyCollection(node);
            $375276bea32f9eda$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $375276bea32f9eda$var$updateNode(childNode, newChildValue);
        else {
            $375276bea32f9eda$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $375276bea32f9eda$var$deleteNode(node) {
    if (node.tag) $375276bea32f9eda$var$dirtyTag(node.tag, null);
    $375276bea32f9eda$var$dirtyCollection(node);
    for(const key in node.tags)$375276bea32f9eda$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$375276bea32f9eda$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $375276bea32f9eda$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $375276bea32f9eda$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $375276bea32f9eda$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $375276bea32f9eda$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $375276bea32f9eda$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $375276bea32f9eda$export$3f025202a230c6dd = (a, b)=>a === b;
function $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $375276bea32f9eda$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $375276bea32f9eda$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $375276bea32f9eda$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $375276bea32f9eda$var$createSingletonCache(comparator) : $375276bea32f9eda$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $375276bea32f9eda$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $375276bea32f9eda$export$c8f9cf88d9fdee55(func) {
    const node = $375276bea32f9eda$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $375276bea32f9eda$var$createCacheKeyComparator($375276bea32f9eda$export$3f025202a230c6dd);
    const cache = $375276bea32f9eda$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $375276bea32f9eda$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $375276bea32f9eda$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $375276bea32f9eda$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $375276bea32f9eda$var$StrongRef;
var $375276bea32f9eda$var$UNTERMINATED = 0;
var $375276bea32f9eda$var$TERMINATED = 1;
function $375276bea32f9eda$var$createCacheNode() {
    return {
        s: $375276bea32f9eda$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $375276bea32f9eda$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $375276bea32f9eda$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $375276bea32f9eda$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $375276bea32f9eda$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $375276bea32f9eda$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $375276bea32f9eda$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $375276bea32f9eda$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $375276bea32f9eda$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $375276bea32f9eda$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $375276bea32f9eda$var$__spreadValues($375276bea32f9eda$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $375276bea32f9eda$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $375276bea32f9eda$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $375276bea32f9eda$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $375276bea32f9eda$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $375276bea32f9eda$export$595d22ed68ca2841 = /* @__PURE__ */ $375276bea32f9eda$export$5943f4447f6ef248($375276bea32f9eda$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $375276bea32f9eda$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $375276bea32f9eda$export$595d22ed68ca2841)=>{
    $375276bea32f9eda$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$375276bea32f9eda$export$75979cfcd91bf38f
});


// src/index.ts
function $44400fc0fe63e7bd$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $44400fc0fe63e7bd$export$dd164f5517779f15 = $44400fc0fe63e7bd$var$createThunkMiddleware();
var $44400fc0fe63e7bd$export$16d06542a1949d9e = $44400fc0fe63e7bd$var$createThunkMiddleware;


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


var $d91034f47eb948f2$var$__defProp = Object.defineProperty;
var $d91034f47eb948f2$var$__defProps = Object.defineProperties;
var $d91034f47eb948f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d91034f47eb948f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d91034f47eb948f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d91034f47eb948f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d91034f47eb948f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d91034f47eb948f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d91034f47eb948f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d91034f47eb948f2$var$__hasOwnProp.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    if ($d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(b))if ($d91034f47eb948f2$var$__propIsEnum.call(b, prop)) $d91034f47eb948f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d91034f47eb948f2$var$__spreadProps = (a, b)=>$d91034f47eb948f2$var$__defProps(a, $d91034f47eb948f2$var$__getOwnPropDescs(b));
var $d91034f47eb948f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d91034f47eb948f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d91034f47eb948f2$var$__getOwnPropSymbols) {
        for (var prop of $d91034f47eb948f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d91034f47eb948f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d91034f47eb948f2$var$__publicField = (obj, key, value)=>$d91034f47eb948f2$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $d91034f47eb948f2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $375276bea32f9eda$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $b9146244dc19043a$export$541ac630993a4c84)(value) ? (0, $b9146244dc19043a$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $d91034f47eb948f2$export$a5d3c27355e35910 = /* @__PURE__ */ $d91034f47eb948f2$export$aab6de9e3dbb1473((0, $375276bea32f9eda$export$8402dc26d96f6902));
var $d91034f47eb948f2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $d2bed10dff9b4968$export$f672e0b6f7222cd7;
    return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $d91034f47eb948f2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $d91034f47eb948f2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(0));
            return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $d91034f47eb948f2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $d91034f47eb948f2$var$hasMatchFunction(action);
}
function $d91034f47eb948f2$export$ebd532f9034651f3(action) {
    return (0, $d2bed10dff9b4968$export$b956e38827fca970)(action) && Object.keys(action).every($d91034f47eb948f2$var$isValidKey);
}
function $d91034f47eb948f2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $d91034f47eb948f2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $d91034f47eb948f2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $d91034f47eb948f2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $d91034f47eb948f2$var$freezeDraftable(val) {
    return (0, $b9146244dc19043a$export$16e3aed3edb85946)(val) ? (0, $b9146244dc19043a$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $d91034f47eb948f2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $d91034f47eb948f2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $d91034f47eb948f2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $d91034f47eb948f2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $d91034f47eb948f2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $d91034f47eb948f2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $d91034f47eb948f2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $d91034f47eb948f2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(val);
}
function $d91034f47eb948f2$export$ada5dca0b571bc7(value, path = "", isSerializable = $d91034f47eb948f2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $d91034f47eb948f2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $d91034f47eb948f2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $d91034f47eb948f2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$d91034f47eb948f2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $d91034f47eb948f2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $d91034f47eb948f2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $d91034f47eb948f2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $d91034f47eb948f2$export$1908877435b1d5e9();
        if (thunk) {
            if ($d91034f47eb948f2$var$isBoolean(thunk)) middlewareArray.push((0, $44400fc0fe63e7bd$export$dd164f5517779f15));
            else middlewareArray.push((0, $44400fc0fe63e7bd$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $d91034f47eb948f2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $d91034f47eb948f2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$d91034f47eb948f2$export$8fb31c0f05df007b]: true
            }
        });
var $d91034f47eb948f2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $d91034f47eb948f2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $d91034f47eb948f2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $d91034f47eb948f2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$d91034f47eb948f2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $d91034f47eb948f2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $d91034f47eb948f2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($d91034f47eb948f2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $d91034f47eb948f2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $d91034f47eb948f2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $d2bed10dff9b4968$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducer);
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $d91034f47eb948f2$var$composeWithDevTools($d91034f47eb948f2$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $d2bed10dff9b4968$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $d91034f47eb948f2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $d91034f47eb948f2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $d91034f47eb948f2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $d91034f47eb948f2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $d91034f47eb948f2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($d91034f47eb948f2$var$isStateFunction(initialState)) getInitialState = ()=>$d91034f47eb948f2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $d91034f47eb948f2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $b9146244dc19043a$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $b9146244dc19043a$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $b9146244dc19043a$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $d91034f47eb948f2$var$matches = (matcher, action)=>{
    if ($d91034f47eb948f2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $d91034f47eb948f2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$d91034f47eb948f2$var$matches(matcher, action));
    };
}
function $d91034f47eb948f2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $d91034f47eb948f2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $d91034f47eb948f2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$872dec21e9a69476()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $d91034f47eb948f2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $d91034f47eb948f2$export$9dd1fb32974da385($d91034f47eb948f2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $d91034f47eb948f2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $d91034f47eb948f2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$d91034f47eb948f2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$d91034f47eb948f2$var$isAsyncThunkArray(asyncThunks)) return $d91034f47eb948f2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $d91034f47eb948f2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $d91034f47eb948f2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $d91034f47eb948f2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $d91034f47eb948f2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $d91034f47eb948f2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $d91034f47eb948f2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $d91034f47eb948f2$var$__publicField(this, "_type");
    }
};
var $d91034f47eb948f2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $d91034f47eb948f2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $d91034f47eb948f2$var$externalAbortMessage = "External signal was aborted";
var $d91034f47eb948f2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $d91034f47eb948f2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $d91034f47eb948f2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $d91034f47eb948f2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($d91034f47eb948f2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($d91034f47eb948f2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($d91034f47eb948f2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $d91034f47eb948f2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $d91034f47eb948f2$var$RejectWithValue) throw result;
                                if (result instanceof $d91034f47eb948f2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $d91034f47eb948f2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($d91034f47eb948f2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $d91034f47eb948f2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $d91034f47eb948f2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $d91034f47eb948f2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $d91034f47eb948f2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $d91034f47eb948f2$export$343355ed40c51c46 = {
    [$d91034f47eb948f2$var$asyncThunkSymbol]: $d91034f47eb948f2$export$6abd22dc03e5063f
};
var $d91034f47eb948f2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($d91034f47eb948f2$export$23a094319a4b586 || {});
function $d91034f47eb948f2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $d91034f47eb948f2$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$d91034f47eb948f2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(11));
        typeof $cfae44f0dfdf62c0$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($d91034f47eb948f2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $d91034f47eb948f2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $d91034f47eb948f2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $d91034f47eb948f2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $d91034f47eb948f2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $d91034f47eb948f2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $d91034f47eb948f2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $d91034f47eb948f2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $d91034f47eb948f2$var$wrapSelector(selector, selectState, ()=>$d91034f47eb948f2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $d91034f47eb948f2$var$__spreadProps($d91034f47eb948f2$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $d91034f47eb948f2$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $d91034f47eb948f2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $d91034f47eb948f2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $d91034f47eb948f2$export$affdea4146de9cf5();
function $d91034f47eb948f2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $d91034f47eb948f2$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $d91034f47eb948f2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $d91034f47eb948f2$export$309c7a02b0b0bc62(type, prepareCallback) : $d91034f47eb948f2$export$309c7a02b0b0bc62(type));
}
function $d91034f47eb948f2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $d91034f47eb948f2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $d91034f47eb948f2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $d91034f47eb948f2$var$noop,
        pending: pending || $d91034f47eb948f2$var$noop,
        rejected: rejected || $d91034f47eb948f2$var$noop,
        settled: settled || $d91034f47eb948f2$var$noop
    });
}
function $d91034f47eb948f2$var$noop() {}
// src/entities/entity_state.ts
function $d91034f47eb948f2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($d91034f47eb948f2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $d91034f47eb948f2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $d91034f47eb948f2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $d91034f47eb948f2$var$isDraftTyped = (0, $b9146244dc19043a$export$541ac630993a4c84);
function $d91034f47eb948f2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $d91034f47eb948f2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $d91034f47eb948f2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $d91034f47eb948f2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($d91034f47eb948f2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $b9146244dc19043a$export$b46cabe22e78bc00)(state, runMutator);
    };
}
function $d91034f47eb948f2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $d91034f47eb948f2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $d91034f47eb948f2$var$getCurrent(value) {
    return (0, $b9146244dc19043a$export$541ac630993a4c84)(value) ? (0, $b9146244dc19043a$export$97aac956da55dae9)(value) : value;
}
function $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $d91034f47eb948f2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $d91034f47eb948f2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $d91034f47eb948f2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$d91034f47eb948f2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $d91034f47eb948f2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably),
        removeOne: $d91034f47eb948f2$var$createStateOperator(removeOneMutably),
        removeMany: $d91034f47eb948f2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $d91034f47eb948f2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $d91034f47eb948f2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $d91034f47eb948f2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $d91034f47eb948f2$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($d91034f47eb948f2$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $d91034f47eb948f2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $d91034f47eb948f2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $d91034f47eb948f2$var$getCurrent(state.entities);
        const currentIds = $d91034f47eb948f2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $d91034f47eb948f2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $d91034f47eb948f2$var$createStateOperator(addOneMutably),
        updateOne: $d91034f47eb948f2$var$createStateOperator(updateOneMutably),
        upsertOne: $d91034f47eb948f2$var$createStateOperator(upsertOneMutably),
        setOne: $d91034f47eb948f2$var$createStateOperator(setOneMutably),
        setMany: $d91034f47eb948f2$var$createStateOperator(setManyMutably),
        setAll: $d91034f47eb948f2$var$createStateOperator(setAllMutably),
        addMany: $d91034f47eb948f2$var$createStateOperator(addManyMutably),
        updateMany: $d91034f47eb948f2$var$createStateOperator(updateManyMutably),
        upsertMany: $d91034f47eb948f2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $d91034f47eb948f2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $d91034f47eb948f2$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $d91034f47eb948f2$var$createSortedStateAdapter(selectId, sortComparer) : $d91034f47eb948f2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $d91034f47eb948f2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $d91034f47eb948f2$var$createSelectorsFactory();
    return $d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues($d91034f47eb948f2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $d91034f47eb948f2$var$task = "task";
var $d91034f47eb948f2$var$listener = "listener";
var $d91034f47eb948f2$var$completed = "completed";
var $d91034f47eb948f2$var$cancelled = "cancelled";
var $d91034f47eb948f2$var$taskCancelled = `task-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$taskCompleted = `task-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$var$listenerCancelled = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$cancelled}`;
var $d91034f47eb948f2$var$listenerCompleted = `${$d91034f47eb948f2$var$listener}-${$d91034f47eb948f2$var$completed}`;
var $d91034f47eb948f2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $d91034f47eb948f2$var$__publicField(this, "name", "TaskAbortError");
        $d91034f47eb948f2$var$__publicField(this, "message");
        this.message = `${$d91034f47eb948f2$var$task} ${$d91034f47eb948f2$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $d91034f47eb948f2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($d91034f47eb948f2$export$378fa86b259c0280(32));
};
var $d91034f47eb948f2$var$noop2 = ()=>{};
var $d91034f47eb948f2$var$catchRejection = (promise, onError = $d91034f47eb948f2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $d91034f47eb948f2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $d91034f47eb948f2$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $d91034f47eb948f2$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $d91034f47eb948f2$export$cb1bdac908fed7f(reason);
    }
};
function $d91034f47eb948f2$var$raceWithSignal(signal, promise) {
    let cleanup = $d91034f47eb948f2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $d91034f47eb948f2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $d91034f47eb948f2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $d91034f47eb948f2$var$noop2;
    });
}
var $d91034f47eb948f2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $d91034f47eb948f2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $d91034f47eb948f2$var$createPause = (signal)=>{
    return (promise)=>{
        return $d91034f47eb948f2$var$catchRejection($d91034f47eb948f2$var$raceWithSignal(signal, promise).then((output)=>{
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        }));
    };
};
var $d91034f47eb948f2$var$createDelay = (signal)=>{
    const pause = $d91034f47eb948f2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $d91034f47eb948f2$var$assign } = Object;
var $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN = {};
var $d91034f47eb948f2$var$alm = "listenerMiddleware";
var $d91034f47eb948f2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$d91034f47eb948f2$var$addAbortSignalListener(parentAbortSignal, ()=>$d91034f47eb948f2$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $d91034f47eb948f2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $d91034f47eb948f2$var$runTask(async ()=>{
            $d91034f47eb948f2$var$validateActive(parentAbortSignal);
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $d91034f47eb948f2$var$createPause(childAbortController.signal),
                delay: $d91034f47eb948f2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $d91034f47eb948f2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($d91034f47eb948f2$var$noop2));
        return {
            result: $d91034f47eb948f2$var$createPause(parentAbortSignal)(result),
            cancel () {
                $d91034f47eb948f2$var$abortControllerWithReason(childAbortController, $d91034f47eb948f2$var$taskCancelled);
            }
        };
    };
};
var $d91034f47eb948f2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $d91034f47eb948f2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $d91034f47eb948f2$var$raceWithSignal(signal, Promise.race(promises));
            $d91034f47eb948f2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$d91034f47eb948f2$var$catchRejection(take(predicate, timeout));
};
var $d91034f47eb948f2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $d91034f47eb948f2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($d91034f47eb948f2$export$378fa86b259c0280(21));
    $d91034f47eb948f2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $d91034f47eb948f2$var$createListenerEntry = /* @__PURE__ */ $d91034f47eb948f2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $d91034f47eb948f2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($d91034f47eb948f2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$d91034f47eb948f2$var$createListenerEntry
});
var $d91034f47eb948f2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $d91034f47eb948f2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $d91034f47eb948f2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
    });
};
var $d91034f47eb948f2$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($d91034f47eb948f2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $d91034f47eb948f2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $d91034f47eb948f2$export$f03a6b845d3fb58b = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/add`), {
    withTypes: ()=>$d91034f47eb948f2$export$f03a6b845d3fb58b
});
var $d91034f47eb948f2$export$b1b8022855fb2b71 = /* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/removeAll`);
var $d91034f47eb948f2$export$b03e9483f936dccb = /* @__PURE__ */ $d91034f47eb948f2$var$assign(/* @__PURE__ */ $d91034f47eb948f2$export$309c7a02b0b0bc62(`${$d91034f47eb948f2$var$alm}/remove`), {
    withTypes: ()=>$d91034f47eb948f2$export$b03e9483f936dccb
});
var $d91034f47eb948f2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$d91034f47eb948f2$var$alm}/error`, ...args);
};
var $d91034f47eb948f2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $d91034f47eb948f2$var$defaultErrorHandler } = middlewareOptions;
    $d91034f47eb948f2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options)) != null ? _a : $d91034f47eb948f2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $d91034f47eb948f2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $d91034f47eb948f2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $d91034f47eb948f2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $d91034f47eb948f2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $d91034f47eb948f2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $d91034f47eb948f2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $d91034f47eb948f2$var$createDelay(internalTaskController.signal),
                pause: $d91034f47eb948f2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $d91034f47eb948f2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $d91034f47eb948f2$var$abortControllerWithReason(controller, $d91034f47eb948f2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $d91034f47eb948f2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $d91034f47eb948f2$export$cb1bdac908fed7f)) $d91034f47eb948f2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $d91034f47eb948f2$var$abortControllerWithReason(internalTaskController, $d91034f47eb948f2$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $d91034f47eb948f2$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $d2bed10dff9b4968$export$b956e38827fca970)(action)) return next(action);
                if ($d91034f47eb948f2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($d91034f47eb948f2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($d91034f47eb948f2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $d91034f47eb948f2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $d91034f47eb948f2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $d91034f47eb948f2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $d91034f47eb948f2$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $d91034f47eb948f2$export$4bb1606a79445586 = ()=>{
    const instanceId = $d91034f47eb948f2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($d91034f47eb948f2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $d91034f47eb948f2$var$getOrInsertComputed(middlewareMap, middleware2, $d91034f47eb948f2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$d91034f47eb948f2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $d2bed10dff9b4968$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $d91034f47eb948f2$export$9dd1fb32974da385(withMiddleware, $d91034f47eb948f2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $d91034f47eb948f2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $d91034f47eb948f2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$d91034f47eb948f2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $d91034f47eb948f2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $d91034f47eb948f2$var$isStateProxy = (value)=>!!value && !!value[$d91034f47eb948f2$var$ORIGINAL_STATE];
var $d91034f47eb948f2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $d91034f47eb948f2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$d91034f47eb948f2$var$getOrInsertComputed($d91034f47eb948f2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $d91034f47eb948f2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $d91034f47eb948f2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($d91034f47eb948f2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $d91034f47eb948f2$var$original = (state)=>{
    if (!$d91034f47eb948f2$var$isStateProxy(state)) throw new Error($d91034f47eb948f2$export$378fa86b259c0280(25));
    return state[$d91034f47eb948f2$var$ORIGINAL_STATE];
};
var $d91034f47eb948f2$var$emptyObject = {};
var $d91034f47eb948f2$var$noopReducer = (state = $d91034f47eb948f2$var$emptyObject)=>state;
function $d91034f47eb948f2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($d91034f47eb948f2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducerMap) : $d91034f47eb948f2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $cfae44f0dfdf62c0$exports;
            return combinedReducer;
        }
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($d91034f47eb948f2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $d91034f47eb948f2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $d91034f47eb948f2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $80a1af099823683c$var$API_URL = "https://bestflix-api.onrender.com/".replace(/\/+$/, "");
async function $80a1af099823683c$var$request(path, options = {}) {
    try {
        const res = await fetch(`${$80a1af099823683c$var$API_URL}${path}`, {
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            ...options
        });
        const text = await res.text();
        let data = null;
        if (text) try {
            data = JSON.parse(text);
        } catch  {
            data = {
                message: text
            };
        }
        if (!res.ok) {
            const message = data?.message || res.statusText || `Request failed (${res.status})`;
            const err = new Error(message);
            err.status = res.status;
            err.details = data;
            throw err;
        }
        return data;
    } catch (error) {
        if (error?.name === "TypeError" || error?.message?.includes("fetch")) {
            const err = new Error(`Unable to reach the backend at ${$80a1af099823683c$var$API_URL}. Check that it is running and that CORS allows your frontend origin.`);
            err.status = 0;
            err.cause = error;
            throw err;
        }
        throw error;
    }
}
async function $80a1af099823683c$export$2c8ff0cf56ad97c4({ Email: Email, Password: Password }) {
    return $80a1af099823683c$var$request(`/api/auth/login`, {
        method: "POST",
        body: JSON.stringify({
            email: Email,
            password: Password
        })
    });
}
async function $80a1af099823683c$export$5f19683c868a137a({ Email: Email, Password: Password, username: username }) {
    return $80a1af099823683c$var$request(`/api/auth/signup`, {
        method: "POST",
        body: JSON.stringify({
            email: Email,
            password: Password,
            username: username
        })
    });
}
async function $80a1af099823683c$export$93839588c4ddd79f() {
    return $80a1af099823683c$var$request(`/api/auth/logout`, {
        method: "POST"
    });
}
async function $80a1af099823683c$export$edd2e45ee3d19d0e(userId, updates) {
    return $80a1af099823683c$var$request(`/api/users/${userId}`, {
        method: "PUT",
        body: JSON.stringify(updates)
    });
}
async function $80a1af099823683c$export$7b5b72c577e59db(userId) {
    return $80a1af099823683c$var$request(`/api/users/${userId}`, {
        method: "DELETE"
    });
}
async function $80a1af099823683c$export$ffc3b27e25a738e4(userId) {
    return $80a1af099823683c$var$request(`/api/favorites/${userId}`, {
        method: "GET"
    });
}
async function $80a1af099823683c$export$ddb053c3dc411a1a({ userId: userId, movieId: movieId }) {
    return $80a1af099823683c$var$request(`/api/favorites`, {
        method: "POST",
        body: JSON.stringify({
            user_id: userId,
            movie_id: movieId
        })
    });
}
async function $80a1af099823683c$export$a879b9ec68c84a75({ userId: userId, movieId: movieId }) {
    return $80a1af099823683c$var$request(`/api/favorites`, {
        method: "DELETE",
        body: JSON.stringify({
            user_id: userId,
            movie_id: movieId
        })
    });
}
var $80a1af099823683c$export$2e2bcd8739ae039 = {
    loginApi: $80a1af099823683c$export$2c8ff0cf56ad97c4,
    signupApi: $80a1af099823683c$export$5f19683c868a137a,
    logoutApi: $80a1af099823683c$export$93839588c4ddd79f,
    updateUserApi: $80a1af099823683c$export$edd2e45ee3d19d0e,
    deleteUserApi: $80a1af099823683c$export$7b5b72c577e59db,
    fetchFavoritesApi: $80a1af099823683c$export$ffc3b27e25a738e4,
    addFavoriteApi: $80a1af099823683c$export$ddb053c3dc411a1a,
    removeFavoriteApi: $80a1af099823683c$export$a879b9ec68c84a75
};


const $70709e160bcc9047$export$596d806903d1f59e = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("user/login", async ({ Email: Email, Password: Password }, { rejectWithValue: rejectWithValue })=>{
    try {
        const data = await (0, $80a1af099823683c$export$2c8ff0cf56ad97c4)({
            Email: Email,
            Password: Password
        });
        return {
            user: data.user,
            token: data.token || data.access_token
        };
    } catch (err) {
        return rejectWithValue(err.message || "Login failed");
    }
});
const $70709e160bcc9047$export$a3610b7739f1b17f = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("user/updateUser", async ({ userId: userId, updates: updates }, { rejectWithValue: rejectWithValue })=>{
    try {
        const data = await (0, $80a1af099823683c$export$edd2e45ee3d19d0e)(userId, updates);
        return data;
    } catch (err) {
        return rejectWithValue(err.message || "Update failed");
    }
});
const $70709e160bcc9047$export$61b56d6536837ca9 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("user/deleteUser", async (userId, { rejectWithValue: rejectWithValue })=>{
    try {
        await (0, $80a1af099823683c$export$7b5b72c577e59db)(userId);
        return {
            userId: userId
        };
    } catch (err) {
        return rejectWithValue(err.message || "Delete failed");
    }
});
const $70709e160bcc9047$var$userSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "user",
    initialState: {
        user: null,
        token: null,
        status: "idle",
        error: null
    },
    reducers: {
        setUser: (state, action)=>{
            state.user = action.payload.user;
            state.token = action.payload.token;
        },
        logout: (state)=>{
            state.user = null;
            state.token = null;
            state.status = "idle";
            state.error = null;
        },
        clearError: (state)=>{
            state.error = null;
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($70709e160bcc9047$export$596d806903d1f59e.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($70709e160bcc9047$export$596d806903d1f59e.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.user = action.payload.user;
            state.token = action.payload.token;
        }).addCase($70709e160bcc9047$export$596d806903d1f59e.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        })// Add update user
        .addCase($70709e160bcc9047$export$a3610b7739f1b17f.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($70709e160bcc9047$export$a3610b7739f1b17f.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.user = action.payload; // updated user object
        }).addCase($70709e160bcc9047$export$a3610b7739f1b17f.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        })// Add delete user
        .addCase($70709e160bcc9047$export$61b56d6536837ca9.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($70709e160bcc9047$export$61b56d6536837ca9.fulfilled, (state)=>{
            state.status = "succeeded";
            state.user = null;
            state.token = null;
        }).addCase($70709e160bcc9047$export$61b56d6536837ca9.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        });
    }
});
const { setUser: $70709e160bcc9047$export$8b6bb3dd62a01be2, logout: $70709e160bcc9047$export$a0973bcfe11b05c9, clearError: $70709e160bcc9047$export$a15ba4bdf59dacc9 } = $70709e160bcc9047$var$userSlice.actions;
var $70709e160bcc9047$export$2e2bcd8739ae039 = $70709e160bcc9047$var$userSlice.reducer;


var $60313e3b9e75c852$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $60313e3b9e75c852$exports) {
        classNames.default = classNames;
        $60313e3b9e75c852$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

"use client";
const $626bd95fa485b758$export$666ad80b5007f835 = [
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $626bd95fa485b758$export$ff817e17bad2e091 = "xs";
const $626bd95fa485b758$var$ThemeContext = /*#__PURE__*/ $acw62.createContext({
    prefixes: {},
    breakpoints: $626bd95fa485b758$export$666ad80b5007f835,
    minBreakpoint: $626bd95fa485b758$export$ff817e17bad2e091
});
const { Consumer: $626bd95fa485b758$export$b631efc24e9d5e2f, Provider: $626bd95fa485b758$var$Provider } = $626bd95fa485b758$var$ThemeContext;
function $626bd95fa485b758$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $626bd95fa485b758$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $626bd95fa485b758$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $acw62.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($626bd95fa485b758$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $626bd95fa485b758$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $626bd95fa485b758$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return breakpoints;
}
function $626bd95fa485b758$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return minBreakpoint;
}
function $626bd95fa485b758$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $acw62.useContext)($626bd95fa485b758$var$ThemeContext);
    return dir === "rtl";
}
function $626bd95fa485b758$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === "string") opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? "ref" : "innerRef" } = opts;
    const Wrapped = /*#__PURE__*/ $acw62.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $626bd95fa485b758$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $626bd95fa485b758$export$2e2bcd8739ae039 = $626bd95fa485b758$var$ThemeProvider;



"use client";
function $6a906738aa440808$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "col");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === "object" && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $6a906738aa440808$var$Col = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = "div", bsPrefix: bsPrefix, spans: spans }] = $6a906738aa440808$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, !spans.length && bsPrefix)
    });
});
$6a906738aa440808$var$Col.displayName = "Col";
var $6a906738aa440808$export$2e2bcd8739ae039 = $6a906738aa440808$var$Col;



var $acw62 = parcelRequire("acw62");


"use client";
const $49d9d24d620fa26d$var$Container = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "container");
    const suffix = typeof fluid === "string" ? `-${fluid}` : "-fluid";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$49d9d24d620fa26d$var$Container.displayName = "Container";
var $49d9d24d620fa26d$export$2e2bcd8739ae039 = $49d9d24d620fa26d$var$Container;



var $acw62 = parcelRequire("acw62");


"use client";
const $c770a015764ac03c$var$Row = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "row");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === "object") ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$c770a015764ac03c$var$Row.displayName = "Row";
var $c770a015764ac03c$export$2e2bcd8739ae039 = $c770a015764ac03c$var$Row;





var $acw62 = parcelRequire("acw62");

var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



"use client";
const $29b2d2ddf65676f3$var$CardBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-body");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$29b2d2ddf65676f3$var$CardBody.displayName = "CardBody";
var $29b2d2ddf65676f3$export$2e2bcd8739ae039 = $29b2d2ddf65676f3$var$CardBody;



var $acw62 = parcelRequire("acw62");



"use client";
const $3a525b42d7f3b597$var$CardFooter = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-footer");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$3a525b42d7f3b597$var$CardFooter.displayName = "CardFooter";
var $3a525b42d7f3b597$export$2e2bcd8739ae039 = $3a525b42d7f3b597$var$CardFooter;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
"use client";
const $5eb077b72b2eb187$var$context = /*#__PURE__*/ $acw62.createContext(null);
$5eb077b72b2eb187$var$context.displayName = "CardHeaderContext";
var $5eb077b72b2eb187$export$2e2bcd8739ae039 = $5eb077b72b2eb187$var$context;



"use client";
const $9a9f027adafde870$var$CardHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-header");
    const contextValue = (0, $acw62.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5eb077b72b2eb187$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix)
        })
    });
});
$9a9f027adafde870$var$CardHeader.displayName = "CardHeader";
var $9a9f027adafde870$export$2e2bcd8739ae039 = $9a9f027adafde870$var$CardHeader;




var $acw62 = parcelRequire("acw62");


"use client";
const $d7330f2b9423c4ea$var$CardImg = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = "img", ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-img");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$d7330f2b9423c4ea$var$CardImg.displayName = "CardImg";
var $d7330f2b9423c4ea$export$2e2bcd8739ae039 = $d7330f2b9423c4ea$var$CardImg;



var $acw62 = parcelRequire("acw62");



"use client";
const $e061719421ea7037$var$CardImgOverlay = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-img-overlay");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$e061719421ea7037$var$CardImgOverlay.displayName = "CardImgOverlay";
var $e061719421ea7037$export$2e2bcd8739ae039 = $e061719421ea7037$var$CardImgOverlay;



var $acw62 = parcelRequire("acw62");



"use client";
const $f699749ca3cc3e98$var$CardLink = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "a", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-link");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$f699749ca3cc3e98$var$CardLink.displayName = "CardLink";
var $f699749ca3cc3e98$export$2e2bcd8739ae039 = $f699749ca3cc3e98$var$CardLink;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $31af5e1d0c3b3c37$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ $acw62.forwardRef((p, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(p.className, className)
        }));



"use client";
const $c82dc004881f9e7b$var$DivStyledAsH6 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h6");
const $c82dc004881f9e7b$var$CardSubtitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $c82dc004881f9e7b$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-subtitle");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$c82dc004881f9e7b$var$CardSubtitle.displayName = "CardSubtitle";
var $c82dc004881f9e7b$export$2e2bcd8739ae039 = $c82dc004881f9e7b$var$CardSubtitle;



var $acw62 = parcelRequire("acw62");



"use client";
const $c5bbe089badf3410$var$CardText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "p", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$c5bbe089badf3410$var$CardText.displayName = "CardText";
var $c5bbe089badf3410$export$2e2bcd8739ae039 = $c5bbe089badf3410$var$CardText;



var $acw62 = parcelRequire("acw62");




"use client";
const $657d8b8404bcef88$var$DivStyledAsH5 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h5");
const $657d8b8404bcef88$var$CardTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $657d8b8404bcef88$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card-title");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$657d8b8404bcef88$var$CardTitle.displayName = "CardTitle";
var $657d8b8404bcef88$export$2e2bcd8739ae039 = $657d8b8404bcef88$var$CardTitle;



"use client";
const $7f9683b4f5c2a43f$var$Card = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "card");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29b2d2ddf65676f3$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$7f9683b4f5c2a43f$var$Card.displayName = "Card";
var $7f9683b4f5c2a43f$export$2e2bcd8739ae039 = Object.assign($7f9683b4f5c2a43f$var$Card, {
    Img: (0, $d7330f2b9423c4ea$export$2e2bcd8739ae039),
    Title: (0, $657d8b8404bcef88$export$2e2bcd8739ae039),
    Subtitle: (0, $c82dc004881f9e7b$export$2e2bcd8739ae039),
    Body: (0, $29b2d2ddf65676f3$export$2e2bcd8739ae039),
    Link: (0, $f699749ca3cc3e98$export$2e2bcd8739ae039),
    Text: (0, $c5bbe089badf3410$export$2e2bcd8739ae039),
    Header: (0, $9a9f027adafde870$export$2e2bcd8739ae039),
    Footer: (0, $3a525b42d7f3b597$export$2e2bcd8739ae039),
    ImgOverlay: (0, $e061719421ea7037$export$2e2bcd8739ae039)
});



const $cc3cd34d8ac3cec0$export$c6ede3bfc40c5e4b = ({ user: user, email: email })=>{
    const userName = user ? String(user) : "";
    const userInitial = userName ? userName.charAt(0).toUpperCase() : "?";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
        className: "user-info-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Header, {
                className: "user-info-header",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "My Profile"
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                className: "user-info-body",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "user-avatar-container",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "user-avatar",
                            children: userInitial
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "user-info-text",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Text, {
                                className: "card-text-user",
                                children: userName
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Text, {
                                className: "card-text-email",
                                children: email
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$cc3cd34d8ac3cec0$export$c6ede3bfc40c5e4b.propTypes = {
    user: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    email: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $acw62 = parcelRequire("acw62");
var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;


var $b7f5460541b42e0f$var$noop = function noop() {};
function $b7f5460541b42e0f$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $b7f5460541b42e0f$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$b7f5460541b42e0f$export$26cbf8c37e721e67(prop)] = $b7f5460541b42e0f$var$noop;
        var handler;
    });
    return propTypes;
}
function $b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $b7f5460541b42e0f$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b7f5460541b42e0f$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== "function" || component.prototype && component.prototype.isReactComponent);
}


function $5809a50e160ad91a$var$_toPropertyKey(arg) {
    var key = $5809a50e160ad91a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5809a50e160ad91a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5809a50e160ad91a$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    var _useState = (0, $acw62.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $5809a50e160ad91a$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
            $b7f5460541b42e0f$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($5809a50e160ad91a$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $5809a50e160ad91a$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}



var $acw62 = parcelRequire("acw62");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $a2318047db3e7b05$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $a2318047db3e7b05$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || "Component";
    var canAcceptRef = $b7f5460541b42e0f$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($b7f5460541b42e0f$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$b7f5460541b42e0f$export$12ae2baa35bd9b8b(props, key) && $b7f5460541b42e0f$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$b7f5460541b42e0f$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    (0, $c8a186e1757974bb$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $b7f5460541b42e0f$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UncontrolledComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $a2318047db3e7b05$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $a2318047db3e7b05$export$2e2bcd8739ae039(newComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ab80f0daa08f2134$var$useCommittedRef(value) {
    const ref = (0, $acw62.useRef)(value);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ab80f0daa08f2134$export$2e2bcd8739ae039 = $ab80f0daa08f2134$var$useCommittedRef;


function $9cc831e7fe1726fc$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    return (0, $acw62.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}




var $acw62 = parcelRequire("acw62");




"use client";
const $4fdceeff8a5914bf$var$DivStyledAsH4 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h4");
$4fdceeff8a5914bf$var$DivStyledAsH4.displayName = "DivStyledAsH4";
const $4fdceeff8a5914bf$var$AlertHeading = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $4fdceeff8a5914bf$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "alert-heading");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$4fdceeff8a5914bf$var$AlertHeading.displayName = "AlertHeading";
var $4fdceeff8a5914bf$export$2e2bcd8739ae039 = $4fdceeff8a5914bf$var$AlertHeading;



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $6ee4f2c1aea3527b$export$2e2bcd8739ae039() {
    return (0, $acw62.useState)(null);
}





var $acw62 = parcelRequire("acw62");

function $eaba49a725115ef9$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(listener);
    (0, $acw62.useEffect)(()=>{
        const target = typeof eventTarget === "function" ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $acw62 = parcelRequire("acw62");
function $3e423f2a0d715058$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $acw62.useCallback)(()=>document, []);
    return (0, $eaba49a725115ef9$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $acw62 = parcelRequire("acw62");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $6fd76678a314d183$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $acw62.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $6fd76678a314d183$export$2e2bcd8739ae039 = $6fd76678a314d183$var$useInterval;



var $acw62 = parcelRequire("acw62");

function $198f6e47917f30c6$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $ab80f0daa08f2134$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $acw62.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $198f6e47917f30c6$export$2e2bcd8739ae039 = $198f6e47917f30c6$var$useRafInterval;



var $acw62 = parcelRequire("acw62");
function $b720ce9b20d786bc$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $acw62.useState)(initialState);
    const updater = (0, $acw62.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === "function") setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $44ebbbe01160f4fd$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $b720ce9b20d786bc$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $acw62 = parcelRequire("acw62");
function $ed7e9ace1ce49d9f$export$2e2bcd8739ae039() {
    const mounted = (0, $acw62.useRef)(true);
    const isMounted = (0, $acw62.useRef)(()=>mounted.current);
    (0, $acw62.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $acw62 = parcelRequire("acw62");
function $97a3f3bdcb91cb9e$export$2e2bcd8739ae039(value) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $acw62 = parcelRequire("acw62");
function $80508bd696338b90$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $acw62.useState)({
        image: null,
        error: null
    });
    (0, $acw62.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === "string") {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener("load", onLoad);
        image.addEventListener("error", onError);
        return ()=>{
            image.removeEventListener("load", onLoad);
            image.removeEventListener("error", onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $63565b817d447aae$var$isReactNative = typeof $parcel$global !== "undefined" && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === "ReactNative";
const $63565b817d447aae$var$isDOM = typeof document !== "undefined";
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $63565b817d447aae$export$2e2bcd8739ae039 = $63565b817d447aae$var$isDOM || $63565b817d447aae$var$isReactNative ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);


const $a420e6fa685a8a6f$var$targetMap = new WeakMap();
let $a420e6fa685a8a6f$var$resizeObserver;
function $a420e6fa685a8a6f$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $a420e6fa685a8a6f$var$resizeObserver = $a420e6fa685a8a6f$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $a420e6fa685a8a6f$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $a420e6fa685a8a6f$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $acw62.useState)(null);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $a420e6fa685a8a6f$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $a420e6fa685a8a6f$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $a420e6fa685a8a6f$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}





var $acw62 = parcelRequire("acw62");

const $0522fa2e4977c358$var$_excluded = [
    "as",
    "disabled"
];
function $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0522fa2e4977c358$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
function $0522fa2e4977c358$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = "a";
        else tagName = "button";
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === "button") return [
        {
            type: type || "button",
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === "a" && $0522fa2e4977c358$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === " ") {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === "a") {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = "#");
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : "button",
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === "a" ? target : undefined,
            "aria-disabled": !disabled ? undefined : disabled,
            rel: tagName === "a" ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $0522fa2e4977c358$var$Button = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $0522fa2e4977c358$var$_objectWithoutPropertiesLoose(_ref, $0522fa2e4977c358$var$_excluded);
    const [buttonProps, { tagName: Component }] = $0522fa2e4977c358$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$0522fa2e4977c358$var$Button.displayName = "Button";
var $0522fa2e4977c358$export$2e2bcd8739ae039 = $0522fa2e4977c358$var$Button;



const $a02c1087963bbb34$var$_excluded = [
    "onKeyDown"
];
function $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a02c1087963bbb34$export$72369ab2cc99204b(href) {
    return !href || href.trim() === "#";
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a02c1087963bbb34$var$Anchor = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a02c1087963bbb34$var$_objectWithoutPropertiesLoose(_ref, $a02c1087963bbb34$var$_excluded);
    const [buttonProps] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: "a"
    }, props));
    const handleKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a02c1087963bbb34$export$72369ab2cc99204b(props.href) || props.role === "button") return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a02c1087963bbb34$var$Anchor.displayName = "Anchor";
var $a02c1087963bbb34$export$2e2bcd8739ae039 = $a02c1087963bbb34$var$Anchor;




"use client";
const $8710e0c5b76ea92e$var$AlertLink = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "alert-link");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$8710e0c5b76ea92e$var$AlertLink.displayName = "AlertLink";
var $8710e0c5b76ea92e$export$2e2bcd8739ae039 = $8710e0c5b76ea92e$var$AlertLink;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");

var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);


var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



var $acw62 = parcelRequire("acw62");
function $a36e95ee292bed8b$export$806fcc22e55e107d(e) {
    return e.code === "Escape" || e.keyCode === 27;
}
function $a36e95ee292bed8b$export$13e065f3a74cfe36() {
    const parts = $acw62.version.split(".");
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $fcf05e248574eb57$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $da31306d5140b746$export$2e2bcd8739ae039(node) {
    var doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $9d0d2e2a013bac9c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $da31306d5140b746$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $9f2c378a21ca2430$var$rUpper = /([A-Z])/g;
function $9f2c378a21ca2430$export$2e2bcd8739ae039(string) {
    return string.replace($9f2c378a21ca2430$var$rUpper, "-$1").toLowerCase();
}


var $09bdad49a6503060$var$msPattern = /^ms-/;
function $09bdad49a6503060$export$2e2bcd8739ae039(string) {
    return (0, $9f2c378a21ca2430$export$2e2bcd8739ae039)(string).replace($09bdad49a6503060$var$msPattern, "-ms-");
}


var $c8af0fa0e8553220$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $c8af0fa0e8553220$export$2e2bcd8739ae039(value) {
    return !!(value && $c8af0fa0e8553220$var$supportedTransforms.test(value));
}


function $1d31c226dae4138f$var$style(node, property) {
    var css = "";
    var transforms = "";
    if (typeof property === "string") return node.style.getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property)) || (0, $9d0d2e2a013bac9c$export$2e2bcd8739ae039)(node).getPropertyValue((0, $09bdad49a6503060$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $09bdad49a6503060$export$2e2bcd8739ae039)(key));
        else if ((0, $c8af0fa0e8553220$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $09bdad49a6503060$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $1d31c226dae4138f$export$2e2bcd8739ae039 = $1d31c226dae4138f$var$style;



/* eslint-disable no-return-assign */ var $55986f7b0f69fd17$export$2e2bcd8739ae039 = !!(typeof window !== "undefined" && window.document && window.document.createElement);


var $28419dce7921d430$export$63fefd044b2bc624 = false;
var $28419dce7921d430$export$a614c6b395900f69 = false;
try {
    var $28419dce7921d430$var$options = {
        get passive () {
            return $28419dce7921d430$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $28419dce7921d430$export$a614c6b395900f69 = $28419dce7921d430$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $55986f7b0f69fd17$export$2e2bcd8739ae039) {
        window.addEventListener("test", $28419dce7921d430$var$options, $28419dce7921d430$var$options);
        window.removeEventListener("test", $28419dce7921d430$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $28419dce7921d430$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== "boolean" && !$28419dce7921d430$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$28419dce7921d430$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $28419dce7921d430$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $28419dce7921d430$export$2e2bcd8739ae039 = $28419dce7921d430$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $59fd23e4cc6020bf$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== "boolean" ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $59fd23e4cc6020bf$export$2e2bcd8739ae039 = $59fd23e4cc6020bf$var$removeEventListener;


function $5ce0a80dcc778636$var$listen(node, eventName, handler, options) {
    (0, $28419dce7921d430$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $59fd23e4cc6020bf$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $5ce0a80dcc778636$export$2e2bcd8739ae039 = $5ce0a80dcc778636$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $d690caf237d1909f$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent("HTMLEvents");
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $3966a04026e86a49$var$parseDuration(node) {
    var str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, "transitionDuration") || "";
    var mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $d690caf237d1909f$export$2e2bcd8739ae039)(element, "transitionend", true);
    }, duration + padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $3966a04026e86a49$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $3966a04026e86a49$var$parseDuration(element) || 0;
    var removeEmulate = $3966a04026e86a49$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(element, "transitionend", handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $f251260f6a38a977$var$parseDuration(node, property) {
    const str = (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(node, property) || "";
    const mult = str.indexOf("ms") === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $f251260f6a38a977$export$2e2bcd8739ae039(element, handler) {
    const duration = $f251260f6a38a977$var$parseDuration(element, "transitionDuration");
    const delay = $f251260f6a38a977$var$parseDuration(element, "transitionDelay");
    const remove = (0, $3966a04026e86a49$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $02f7800ef44133eb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $9d58c39545e3cedc$var$toFnRef = (ref)=>!ref || typeof ref === "function" ? ref : (value)=>{
        ref.current = value;
    };
function $9d58c39545e3cedc$export$c9058316764c140e(refA, refB) {
    const a = $9d58c39545e3cedc$var$toFnRef(refA);
    const b = $9d58c39545e3cedc$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $9d58c39545e3cedc$var$useMergedRefs(refA, refB) {
    return (0, $acw62.useMemo)(()=>$9d58c39545e3cedc$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $9d58c39545e3cedc$export$2e2bcd8739ae039 = $9d58c39545e3cedc$var$useMergedRefs;



function $75718871ab216e51$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && "setState" in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $5e18c3cbbc2321dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0fef977f04119bf5$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $5e18c3cbbc2321dd$export$2e2bcd8739ae039 = $5e18c3cbbc2321dd$var$TransitionWrapper;



const $588ffbaaa8a325aa$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $588ffbaaa8a325aa$var$Fade = /*#__PURE__*/ $acw62.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $acw62.useCallback)((node, isAppearing)=>{
        (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    const { major: major } = (0, $a36e95ee292bed8b$export$13e065f3a74cfe36)();
    const childRef = major >= 19 ? children.props.ref : children.ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: childRef,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("fade", className, children.props.className, $588ffbaaa8a325aa$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$588ffbaaa8a325aa$var$Fade.displayName = "Fade";
var $588ffbaaa8a325aa$export$2e2bcd8739ae039 = $588ffbaaa8a325aa$var$Fade;




var $acw62 = parcelRequire("acw62");


const $52ed202a4f01c477$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        "white"
    ])
};
const $52ed202a4f01c477$var$CloseButton = /*#__PURE__*/ $acw62.forwardRef(({ className: className, variant: variant, "aria-label": ariaLabel = "Close", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))("btn-close", variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$52ed202a4f01c477$var$CloseButton.displayName = "CloseButton";
$52ed202a4f01c477$var$CloseButton.propTypes = $52ed202a4f01c477$var$propTypes;
var $52ed202a4f01c477$export$2e2bcd8739ae039 = $52ed202a4f01c477$var$CloseButton;



"use client";
const $9091c2598933ffd8$var$Alert = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = "Close alert", closeVariant: closeVariant, className: className, children: children, variant: variant = "primary", onClose: onClose, dismissible: dismissible, transition: transition = (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: "onClose"
    });
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "alert");
    const handleClose = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$9091c2598933ffd8$var$Alert.displayName = "Alert";
var $9091c2598933ffd8$export$2e2bcd8739ae039 = Object.assign($9091c2598933ffd8$var$Alert, {
    Link: (0, $8710e0c5b76ea92e$export$2e2bcd8739ae039),
    Heading: (0, $4fdceeff8a5914bf$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");



"use client";
const $4ed343d4b409b2f2$var$Button = /*#__PURE__*/ $acw62.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = "primary", size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "btn");
    const [buttonProps, { tagName: tagName }] = (0, $0522fa2e4977c358$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, active && "active", variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && "disabled")
    });
});
$4ed343d4b409b2f2$var$Button.displayName = "Button";
var $4ed343d4b409b2f2$export$2e2bcd8739ae039 = $4ed343d4b409b2f2$var$Button;




var $acw62 = parcelRequire("acw62");


/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $70a5c1c5c22ba944$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== "function") throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-ignore
            acc.apply(this, args);
            // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $70a5c1c5c22ba944$export$2e2bcd8739ae039 = $70a5c1c5c22ba944$var$createChainedFunction;





const $6225d171b822135d$var$MARGINS = {
    height: [
        "marginTop",
        "marginBottom"
    ],
    width: [
        "marginLeft",
        "marginRight"
    ]
};
function $6225d171b822135d$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $6225d171b822135d$var$MARGINS[dimension];
    return value + // @ts-ignore
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-ignore
    parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $6225d171b822135d$var$collapseStyles = {
    [(0, $0fef977f04119bf5$export$84cbff306f539230)]: "collapse",
    [(0, $0fef977f04119bf5$export$4aacc83d4d59139f)]: "collapsing",
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "collapsing",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "collapse show"
};
const $6225d171b822135d$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = "height", in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $6225d171b822135d$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === "function" ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = "0";
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $02f7800ef44133eb$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $acw62.useMemo)(()=>(0, $70a5c1c5c22ba944$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: children.ref,
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, $6225d171b822135d$var$collapseStyles[state], computedDimension === "width" && "collapse-horizontal")
            })
    });
});
var // @ts-ignore
$6225d171b822135d$export$2e2bcd8739ae039 = $6225d171b822135d$var$Collapse;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $1c272c8c9427e0c0$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $1c272c8c9427e0c0$var$Feedback = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = "div", className: className, type: type = "valid", tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, `${type}-${tooltip ? "tooltip" : "feedback"}`)
    }));
$1c272c8c9427e0c0$var$Feedback.displayName = "Feedback";
$1c272c8c9427e0c0$var$Feedback.propTypes = $1c272c8c9427e0c0$var$propTypes;
var $1c272c8c9427e0c0$export$2e2bcd8739ae039 = $1c272c8c9427e0c0$var$Feedback;




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
"use client";
// TODO
const $870809e0939c9f82$var$FormContext = /*#__PURE__*/ $acw62.createContext({});
var $870809e0939c9f82$export$2e2bcd8739ae039 = $870809e0939c9f82$var$FormContext;




"use client";
const $7164fecb4f365c4a$var$FormCheckInput = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = "checkbox", isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-input");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$7164fecb4f365c4a$var$FormCheckInput.displayName = "FormCheckInput";
var $7164fecb4f365c4a$export$2e2bcd8739ae039 = $7164fecb4f365c4a$var$FormCheckInput;




var $acw62 = parcelRequire("acw62");



"use client";
const $b0aba1aace6996b7$var$FormCheckLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check-label");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b0aba1aace6996b7$var$FormCheckLabel.displayName = "FormCheckLabel";
var $b0aba1aace6996b7$export$2e2bcd8739ae039 = $b0aba1aace6996b7$var$FormCheckLabel;





var $acw62 = parcelRequire("acw62");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $d3ae4136892dd278$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $acw62.Children.map(children, (child)=>/*#__PURE__*/ $acw62.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $d3ae4136892dd278$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $acw62.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $d3ae4136892dd278$export$500fd6099226ffae(children, type) {
    return $acw62.Children.toArray(children).some((child)=>/*#__PURE__*/ $acw62.isValidElement(child) && child.type === type);
}



"use client";
const $87df01720ec94e93$var$FormCheck = /*#__PURE__*/ $acw62.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = "", type: type = "checkbox", label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = "input", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-check");
    bsSwitchPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsSwitchPrefix, "form-switch");
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    const innerFormContext = (0, $acw62.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $d3ae4136892dd278$export$500fd6099226ffae)(children, (0, $b0aba1aace6996b7$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7164fecb4f365c4a$export$2e2bcd8739ae039), {
        ...props,
        type: type === "switch" ? "checkbox" : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === "switch" && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0aba1aace6996b7$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c272c8c9427e0c0$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$87df01720ec94e93$var$FormCheck.displayName = "FormCheck";
var $87df01720ec94e93$export$2e2bcd8739ae039 = Object.assign($87df01720ec94e93$var$FormCheck, {
    Input: (0, $7164fecb4f365c4a$export$2e2bcd8739ae039),
    Label: (0, $b0aba1aace6996b7$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
var $ebfc6adce9fdacf8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ebfc6adce9fdacf8$exports = $ebfc6adce9fdacf8$var$warning;






"use client";
const $3023ede31d3d1660$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "input", ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-control");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === "color" && `${bsPrefix}-color`, isValid && "is-valid", isInvalid && "is-invalid")
    });
});
$3023ede31d3d1660$var$FormControl.displayName = "FormControl";
var $3023ede31d3d1660$export$2e2bcd8739ae039 = Object.assign($3023ede31d3d1660$var$FormControl, {
    Feedback: $1c272c8c9427e0c0$export$2e2bcd8739ae039
});



var $acw62 = parcelRequire("acw62");



"use client";
const $3d8877fa5535421d$var$FormFloating = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$3d8877fa5535421d$var$FormFloating.displayName = "FormFloating";
var $3d8877fa5535421d$export$2e2bcd8739ae039 = $3d8877fa5535421d$var$FormFloating;



var $acw62 = parcelRequire("acw62");


const $5d8599dc34b64b39$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    const context = (0, $acw62.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $870809e0939c9f82$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$5d8599dc34b64b39$var$FormGroup.displayName = "FormGroup";
var $5d8599dc34b64b39$export$2e2bcd8739ae039 = $5d8599dc34b64b39$var$FormGroup;




var $acw62 = parcelRequire("acw62");





"use client";
const $5d7439d74bf97ebc$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "label", bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-label");
    let columnClass = "col-form-label";
    if (typeof column === "string") columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, visuallyHidden && "visually-hidden", column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$5d7439d74bf97ebc$var$FormLabel.displayName = "FormLabel";
var $5d7439d74bf97ebc$export$2e2bcd8739ae039 = $5d7439d74bf97ebc$var$FormLabel;




var $acw62 = parcelRequire("acw62");



"use client";
const $b91a225b00146fdd$var$FormRange = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-range");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$b91a225b00146fdd$var$FormRange.displayName = "FormRange";
var $b91a225b00146fdd$export$2e2bcd8739ae039 = $b91a225b00146fdd$var$FormRange;




var $acw62 = parcelRequire("acw62");



"use client";
const $7b27958f5a457ab6$var$FormSelect = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $acw62.useContext)((0, $870809e0939c9f82$export$2e2bcd8739ae039));
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-select");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$7b27958f5a457ab6$var$FormSelect.displayName = "FormSelect";
var $7b27958f5a457ab6$export$2e2bcd8739ae039 = $7b27958f5a457ab6$var$FormSelect;




var $acw62 = parcelRequire("acw62");


"use client";
const $bd2be22fa282ca4a$var$FormText = /*#__PURE__*/ $acw62.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = "small", muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, muted && "text-muted")
    });
});
$bd2be22fa282ca4a$var$FormText.displayName = "FormText";
var $bd2be22fa282ca4a$export$2e2bcd8739ae039 = $bd2be22fa282ca4a$var$FormText;



var $acw62 = parcelRequire("acw62");


const $fbd36a2b679cb998$var$Switch = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87df01720ec94e93$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fbd36a2b679cb998$var$Switch.displayName = "Switch";
var $fbd36a2b679cb998$export$2e2bcd8739ae039 = Object.assign($fbd36a2b679cb998$var$Switch, {
    Input: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Input,
    Label: (0, $87df01720ec94e93$export$2e2bcd8739ae039).Label
});




var $acw62 = parcelRequire("acw62");



"use client";
const $26b7d75a1da62deb$var$FloatingLabel = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "form-floating");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5d8599dc34b64b39$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$26b7d75a1da62deb$var$FloatingLabel.displayName = "FloatingLabel";
var $26b7d75a1da62deb$export$2e2bcd8739ae039 = $26b7d75a1da62deb$var$FloatingLabel;



const $64675cdb3851f16c$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).elementType
};
const $64675cdb3851f16c$var$Form = /*#__PURE__*/ $acw62.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "form", ...props }, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, validated && "was-validated")
    }));
$64675cdb3851f16c$var$Form.displayName = "Form";
$64675cdb3851f16c$var$Form.propTypes = $64675cdb3851f16c$var$propTypes;
var $64675cdb3851f16c$export$2e2bcd8739ae039 = Object.assign($64675cdb3851f16c$var$Form, {
    Group: (0, $5d8599dc34b64b39$export$2e2bcd8739ae039),
    Control: (0, $3023ede31d3d1660$export$2e2bcd8739ae039),
    Floating: (0, $3d8877fa5535421d$export$2e2bcd8739ae039),
    Check: (0, $87df01720ec94e93$export$2e2bcd8739ae039),
    Switch: $fbd36a2b679cb998$export$2e2bcd8739ae039,
    Label: (0, $5d7439d74bf97ebc$export$2e2bcd8739ae039),
    Text: (0, $bd2be22fa282ca4a$export$2e2bcd8739ae039),
    Range: (0, $b91a225b00146fdd$export$2e2bcd8739ae039),
    Select: (0, $7b27958f5a457ab6$export$2e2bcd8739ae039),
    FloatingLabel: $26b7d75a1da62deb$export$2e2bcd8739ae039
});



var $acw62 = parcelRequire("acw62");


"use client";
const $312515fc7a4c2917$var$Spinner = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = "border", size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", className: className, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "spinner");
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$312515fc7a4c2917$var$Spinner.displayName = "Spinner";
var $312515fc7a4c2917$export$2e2bcd8739ae039 = $312515fc7a4c2917$var$Spinner;



var $7YFi7 = parcelRequire("7YFi7");
var $0a34a21cae127bf5$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $0a34a21cae127bf5$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$0a34a21cae127bf5$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$0a34a21cae127bf5$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$0a34a21cae127bf5$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $0a34a21cae127bf5$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $0a34a21cae127bf5$var$DIGIT_REGEX = /^\d+$/, $0a34a21cae127bf5$var$LEAD_DIGIT_REGEX = /^\d/, $0a34a21cae127bf5$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $0a34a21cae127bf5$var$MAX_CACHE_SIZE = 512;
var $0a34a21cae127bf5$var$pathCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$setCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE), $0a34a21cae127bf5$var$getCache = new $0a34a21cae127bf5$var$Cache($0a34a21cae127bf5$var$MAX_CACHE_SIZE);
var $0a34a21cae127bf5$var$config;
$0a34a21cae127bf5$exports = {
    Cache: $0a34a21cae127bf5$var$Cache,
    split: $0a34a21cae127bf5$var$split,
    normalizePath: $0a34a21cae127bf5$var$normalizePath,
    setter: function(path) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$setCache.get(path) || $0a34a21cae127bf5$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $0a34a21cae127bf5$var$normalizePath(path);
        return $0a34a21cae127bf5$var$getCache.get(path) || $0a34a21cae127bf5$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($0a34a21cae127bf5$var$isQuoted(part) || $0a34a21cae127bf5$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $0a34a21cae127bf5$var$forEach(Array.isArray(path) ? path : $0a34a21cae127bf5$var$split(path), cb, thisArg);
    }
};
function $0a34a21cae127bf5$var$normalizePath(path) {
    return $0a34a21cae127bf5$var$pathCache.get(path) || $0a34a21cae127bf5$var$pathCache.set(path, $0a34a21cae127bf5$var$split(path).map(function(part) {
        return part.replace($0a34a21cae127bf5$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $0a34a21cae127bf5$var$split(path) {
    return path.match($0a34a21cae127bf5$var$SPLIT_REGEX) || [
        ""
    ];
}
function $0a34a21cae127bf5$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($0a34a21cae127bf5$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $0a34a21cae127bf5$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $0a34a21cae127bf5$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $0a34a21cae127bf5$var$hasLeadingNumber(part) {
    return part.match($0a34a21cae127bf5$var$LEAD_DIGIT_REGEX) && !part.match($0a34a21cae127bf5$var$DIGIT_REGEX);
}
function $0a34a21cae127bf5$var$hasSpecialChars(part) {
    return $0a34a21cae127bf5$var$SPEC_CHAR_REGEX.test(part);
}
function $0a34a21cae127bf5$var$shouldBeQuoted(part) {
    return !$0a34a21cae127bf5$var$isQuoted(part) && ($0a34a21cae127bf5$var$hasLeadingNumber(part) || $0a34a21cae127bf5$var$hasSpecialChars(part));
}


var $d2ed6e977f19f182$exports = {};
const $d2ed6e977f19f182$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $d2ed6e977f19f182$var$words = (str)=>str.match($d2ed6e977f19f182$var$reWords) || [];
const $d2ed6e977f19f182$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $d2ed6e977f19f182$var$join = (str, d)=>$d2ed6e977f19f182$var$words(str).join(d).toLowerCase();
const $d2ed6e977f19f182$var$camelCase = (str)=>$d2ed6e977f19f182$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $d2ed6e977f19f182$var$pascalCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$camelCase(str));
const $d2ed6e977f19f182$var$snakeCase = (str)=>$d2ed6e977f19f182$var$join(str, "_");
const $d2ed6e977f19f182$var$kebabCase = (str)=>$d2ed6e977f19f182$var$join(str, "-");
const $d2ed6e977f19f182$var$sentenceCase = (str)=>$d2ed6e977f19f182$var$upperFirst($d2ed6e977f19f182$var$join(str, " "));
const $d2ed6e977f19f182$var$titleCase = (str)=>$d2ed6e977f19f182$var$words(str).map($d2ed6e977f19f182$var$upperFirst).join(" ");
$d2ed6e977f19f182$exports = {
    words: $d2ed6e977f19f182$var$words,
    upperFirst: $d2ed6e977f19f182$var$upperFirst,
    camelCase: $d2ed6e977f19f182$var$camelCase,
    pascalCase: $d2ed6e977f19f182$var$pascalCase,
    snakeCase: $d2ed6e977f19f182$var$snakeCase,
    kebabCase: $d2ed6e977f19f182$var$kebabCase,
    sentenceCase: $d2ed6e977f19f182$var$sentenceCase,
    titleCase: $d2ed6e977f19f182$var$titleCase
};


var $a2cee144eac47a21$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $a2cee144eac47a21$exports = function(edges) {
    return $a2cee144eac47a21$var$toposort($a2cee144eac47a21$var$uniqueNodes(edges), edges);
};
$a2cee144eac47a21$exports.array = $a2cee144eac47a21$var$toposort;
function $a2cee144eac47a21$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $a2cee144eac47a21$var$makeOutgoingEdges(edges), nodesHash = $a2cee144eac47a21$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $a2cee144eac47a21$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $a2cee144eac47a21$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $a2cee144eac47a21$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $cda9d0e1103d595f$var$toString = Object.prototype.toString;
const $cda9d0e1103d595f$var$errorToString = Error.prototype.toString;
const $cda9d0e1103d595f$var$regExpToString = RegExp.prototype.toString;
const $cda9d0e1103d595f$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $cda9d0e1103d595f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $cda9d0e1103d595f$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $cda9d0e1103d595f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $cda9d0e1103d595f$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $cda9d0e1103d595f$var$symbolToString.call(val).replace($cda9d0e1103d595f$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $cda9d0e1103d595f$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $cda9d0e1103d595f$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $cda9d0e1103d595f$var$regExpToString.call(val);
    return null;
}
function $cda9d0e1103d595f$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $cda9d0e1103d595f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $cda9d0e1103d595f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $cda9d0e1103d595f$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $cda9d0e1103d595f$var$_Symbol$toStringTag, $cda9d0e1103d595f$var$_Symbol$hasInstance, $cda9d0e1103d595f$var$_Symbol$toStringTag2;
let $cda9d0e1103d595f$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$cda9d0e1103d595f$var$_Symbol$toStringTag = Symbol.toStringTag;
class $cda9d0e1103d595f$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $cda9d0e1103d595f$var$toArray(errorOrErrors).forEach((err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$cda9d0e1103d595f$var$_Symbol$hasInstance = Symbol.hasInstance;
$cda9d0e1103d595f$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $cda9d0e1103d595f$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($cda9d0e1103d595f$var$strReg, (_, key)=>$cda9d0e1103d595f$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $cda9d0e1103d595f$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$cda9d0e1103d595f$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cda9d0e1103d595f$export$2191b9da168c6cf0);
    }
    static [$cda9d0e1103d595f$var$_Symbol$hasInstance](inst) {
        return $cda9d0e1103d595f$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $cda9d0e1103d595f$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $cda9d0e1103d595f$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $cda9d0e1103d595f$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $cda9d0e1103d595f$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $cda9d0e1103d595f$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $cda9d0e1103d595f$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $cda9d0e1103d595f$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $cda9d0e1103d595f$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$cda9d0e1103d595f$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $cda9d0e1103d595f$export$2191b9da168c6cf0.formatError($cda9d0e1103d595f$var$mixed.notType, params);
    }
};
var $cda9d0e1103d595f$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $cda9d0e1103d595f$var$mixed,
    string: $cda9d0e1103d595f$var$string,
    number: $cda9d0e1103d595f$var$number,
    date: $cda9d0e1103d595f$var$date,
    object: $cda9d0e1103d595f$var$object,
    array: $cda9d0e1103d595f$var$array,
    boolean: $cda9d0e1103d595f$var$boolean,
    tuple: $cda9d0e1103d595f$var$tuple
});
const $cda9d0e1103d595f$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $cda9d0e1103d595f$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $cda9d0e1103d595f$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
}
const $cda9d0e1103d595f$var$prefixes = {
    context: "$",
    value: "."
};
function $cda9d0e1103d595f$export$eff4d24c3ff7876e(key, options) {
    return new $cda9d0e1103d595f$var$Reference(key, options);
}
class $cda9d0e1103d595f$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $cda9d0e1103d595f$var$prefixes.context;
        this.isValue = this.key[0] === $cda9d0e1103d595f$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $cda9d0e1103d595f$var$prefixes.context : this.isValue ? $cda9d0e1103d595f$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $0a34a21cae127bf5$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$cda9d0e1103d595f$var$Reference.prototype.__isYupRef = true;
const $cda9d0e1103d595f$var$isAbsent = (value)=>value == null;
function $cda9d0e1103d595f$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $cda9d0e1103d595f$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $cda9d0e1103d595f$export$2191b9da168c6cf0($cda9d0e1103d595f$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $cda9d0e1103d595f$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $cda9d0e1103d595f$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $0a34a21cae127bf5$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $cda9d0e1103d595f$export$cfedb76369cc7782(obj, path, value, context) {
    return $cda9d0e1103d595f$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $cda9d0e1103d595f$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($cda9d0e1103d595f$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $cda9d0e1103d595f$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $cda9d0e1103d595f$var$clone(src, seen = new Map()) {
    if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $cda9d0e1103d595f$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($cda9d0e1103d595f$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $cda9d0e1103d595f$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $cda9d0e1103d595f$var$ReferenceSet();
        this._blacklist = new $cda9d0e1103d595f$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $cda9d0e1103d595f$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $cda9d0e1103d595f$var$isAbsent(result)) return result;
            let formattedValue = $cda9d0e1103d595f$export$5790025c6e6c2ba6(value);
            let formattedResult = $cda9d0e1103d595f$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $cda9d0e1103d595f$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($cda9d0e1103d595f$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $cda9d0e1103d595f$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $cda9d0e1103d595f$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $cda9d0e1103d595f$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $cda9d0e1103d595f$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $cda9d0e1103d595f$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $cda9d0e1103d595f$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $cda9d0e1103d595f$var$toArray(keys).map((key)=>new $cda9d0e1103d595f$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $cda9d0e1103d595f$var$Condition(deps, options) : $cda9d0e1103d595f$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $cda9d0e1103d595f$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $cda9d0e1103d595f$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $cda9d0e1103d595f$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$cda9d0e1103d595f$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $cda9d0e1103d595f$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$cda9d0e1103d595f$export$19342e026b58ebb7.prototype[alias] = $cda9d0e1103d595f$export$19342e026b58ebb7.prototype.notOneOf;
const $cda9d0e1103d595f$var$returnsTrue = ()=>true;
function $cda9d0e1103d595f$export$9b30b6294c1449a8(spec) {
    return new $cda9d0e1103d595f$export$1e88358c94ddec71(spec);
}
class $cda9d0e1103d595f$export$1e88358c94ddec71 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $cda9d0e1103d595f$var$returnsTrue
        }, spec));
    }
}
$cda9d0e1103d595f$export$9b30b6294c1449a8.prototype = $cda9d0e1103d595f$export$1e88358c94ddec71.prototype;
function $cda9d0e1103d595f$export$87b259aa03e3d267() {
    return new $cda9d0e1103d595f$export$c7980688f11e1f49();
}
class $cda9d0e1103d595f$export$c7980688f11e1f49 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $cda9d0e1103d595f$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $cda9d0e1103d595f$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$cda9d0e1103d595f$export$87b259aa03e3d267.prototype = $cda9d0e1103d595f$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $cda9d0e1103d595f$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $cda9d0e1103d595f$var$parseIsoDate(date) {
    const struct = $cda9d0e1103d595f$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $cda9d0e1103d595f$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $cda9d0e1103d595f$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $cda9d0e1103d595f$var$toNumber(regexResult[1]),
        month: $cda9d0e1103d595f$var$toNumber(regexResult[2], 1) - 1,
        day: $cda9d0e1103d595f$var$toNumber(regexResult[3], 1),
        hour: $cda9d0e1103d595f$var$toNumber(regexResult[4]),
        minute: $cda9d0e1103d595f$var$toNumber(regexResult[5]),
        second: $cda9d0e1103d595f$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $cda9d0e1103d595f$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $cda9d0e1103d595f$var$toNumber(regexResult[10]),
        minuteOffset: $cda9d0e1103d595f$var$toNumber(regexResult[11])
    };
}
function $cda9d0e1103d595f$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $cda9d0e1103d595f$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $cda9d0e1103d595f$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $cda9d0e1103d595f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $cda9d0e1103d595f$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $cda9d0e1103d595f$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $cda9d0e1103d595f$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $cda9d0e1103d595f$var$rIsoDateTime = new RegExp(`${$cda9d0e1103d595f$var$yearMonthDay}T${$cda9d0e1103d595f$var$hourMinuteSecond}(\\.\\d+)?${$cda9d0e1103d595f$var$zOrOffset}$`);
let $cda9d0e1103d595f$var$isTrimmed = (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.trim();
let $cda9d0e1103d595f$var$objStringTag = ({}).toString();
function $cda9d0e1103d595f$export$22b082955e083ec3() {
    return new $cda9d0e1103d595f$export$49bf8b2ede5138eb();
}
class $cda9d0e1103d595f$export$49bf8b2ede5138eb extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $cda9d0e1103d595f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $cda9d0e1103d595f$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $cda9d0e1103d595f$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $cda9d0e1103d595f$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $cda9d0e1103d595f$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $cda9d0e1103d595f$var$string.email) {
        return this.matches($cda9d0e1103d595f$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $cda9d0e1103d595f$var$string.url) {
        return this.matches($cda9d0e1103d595f$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $cda9d0e1103d595f$var$string.uuid) {
        return this.matches($cda9d0e1103d595f$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($cda9d0e1103d595f$var$rIsoDateTime, {
            name: "datetime",
            message: message || $cda9d0e1103d595f$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $cda9d0e1103d595f$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $cda9d0e1103d595f$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $cda9d0e1103d595f$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $cda9d0e1103d595f$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $cda9d0e1103d595f$var$isTrimmed
        });
    }
    lowercase(message = $cda9d0e1103d595f$var$string.lowercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $cda9d0e1103d595f$var$string.uppercase) {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$cda9d0e1103d595f$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$cda9d0e1103d595f$export$22b082955e083ec3.prototype = $cda9d0e1103d595f$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $cda9d0e1103d595f$var$isNaN$1 = (value)=>value != +value;
function $cda9d0e1103d595f$export$98e628dec113755e() {
    return new $cda9d0e1103d595f$export$f192ec5e9228ab19();
}
class $cda9d0e1103d595f$export$f192ec5e9228ab19 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$cda9d0e1103d595f$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $cda9d0e1103d595f$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $cda9d0e1103d595f$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $cda9d0e1103d595f$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $cda9d0e1103d595f$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $cda9d0e1103d595f$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $cda9d0e1103d595f$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$cda9d0e1103d595f$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$cda9d0e1103d595f$export$98e628dec113755e.prototype = $cda9d0e1103d595f$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $cda9d0e1103d595f$var$invalidDate = new Date("");
let $cda9d0e1103d595f$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $cda9d0e1103d595f$export$324d90190a8b822a() {
    return new $cda9d0e1103d595f$export$18ec3cc5a157503f();
}
class $cda9d0e1103d595f$export$18ec3cc5a157503f extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: "date",
            check (v) {
                return $cda9d0e1103d595f$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $cda9d0e1103d595f$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$cda9d0e1103d595f$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $cda9d0e1103d595f$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $cda9d0e1103d595f$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$cda9d0e1103d595f$export$18ec3cc5a157503f.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
$cda9d0e1103d595f$export$324d90190a8b822a.prototype = $cda9d0e1103d595f$export$18ec3cc5a157503f.prototype;
$cda9d0e1103d595f$export$324d90190a8b822a.INVALID_DATE = $cda9d0e1103d595f$var$invalidDate;
// @ts-expect-error
function $cda9d0e1103d595f$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $0a34a21cae127bf5$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($cda9d0e1103d595f$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($cda9d0e1103d595f$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($a2cee144eac47a21$exports))).array(Array.from(nodes), edges).reverse();
}
function $cda9d0e1103d595f$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $cda9d0e1103d595f$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $cda9d0e1103d595f$var$findIndex(keys, a) - $cda9d0e1103d595f$var$findIndex(keys, b);
    };
}
const $cda9d0e1103d595f$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $cda9d0e1103d595f$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $cda9d0e1103d595f$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $cda9d0e1103d595f$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($cda9d0e1103d595f$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $cda9d0e1103d595f$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $0a34a21cae127bf5$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $0a34a21cae127bf5$exports.getter)((0, $0a34a21cae127bf5$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $cda9d0e1103d595f$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $cda9d0e1103d595f$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $cda9d0e1103d595f$var$defaultSort = $cda9d0e1103d595f$var$sortByKeyOrder([]);
function $cda9d0e1103d595f$export$be5493f9613cbbe(spec) {
    return new $cda9d0e1103d595f$export$18b4fc70ec7eccf8(spec);
}
class $cda9d0e1103d595f$export$18b4fc70ec7eccf8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $cda9d0e1103d595f$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $cda9d0e1103d595f$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $cda9d0e1103d595f$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$cda9d0e1103d595f$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $cda9d0e1103d595f$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $cda9d0e1103d595f$var$sortFields(shape, excludedEdges);
        next._sortErrors = $cda9d0e1103d595f$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $cda9d0e1103d595f$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $0a34a21cae127bf5$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($cda9d0e1103d595f$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    noUnknown(noAllow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $cda9d0e1103d595f$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $cda9d0e1103d595f$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $d2ed6e977f19f182$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $d2ed6e977f19f182$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$be5493f9613cbbe.prototype = $cda9d0e1103d595f$export$18b4fc70ec7eccf8.prototype;
function $cda9d0e1103d595f$export$2f23118c22fb2630(type) {
    return new $cda9d0e1103d595f$export$4347112b8447a7d(type);
}
class $cda9d0e1103d595f$export$4347112b8447a7d extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($cda9d0e1103d595f$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $cda9d0e1103d595f$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $cda9d0e1103d595f$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $cda9d0e1103d595f$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $cda9d0e1103d595f$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$cda9d0e1103d595f$export$2f23118c22fb2630.prototype = $cda9d0e1103d595f$export$4347112b8447a7d.prototype;
// @ts-ignore
function $cda9d0e1103d595f$export$65e3907585753458(schemas) {
    return new $cda9d0e1103d595f$export$411c3b3687e8ecc8(schemas);
}
class $cda9d0e1103d595f$export$411c3b3687e8ecc8 extends $cda9d0e1103d595f$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($cda9d0e1103d595f$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$cda9d0e1103d595f$export$65e3907585753458.prototype = $cda9d0e1103d595f$export$411c3b3687e8ecc8.prototype;
function $cda9d0e1103d595f$export$488013bae63b21da(builder) {
    return new $cda9d0e1103d595f$var$Lazy(builder);
}
class $cda9d0e1103d595f$var$Lazy {
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$cda9d0e1103d595f$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $cda9d0e1103d595f$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $cda9d0e1103d595f$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $cda9d0e1103d595f$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $cda9d0e1103d595f$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$cda9d0e1103d595f$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}


// basic rules for validation - optional
const $31f69c40c2db9b92$var$validationSchema = {
    Username: $cda9d0e1103d595f$export$22b082955e083ec3().max(15, "Must be 15 characters or less").matches(/^[a-zA-Z0-9]+$/, "Username can only contain letters and numbers"),
    Password: $cda9d0e1103d595f$export$22b082955e083ec3().min(8, "Must be at least 8 characters").matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{4,}$/, "Password must contain at least 1 lowercase, 1 uppercase, 1 number and 1 special character."),
    Email: $cda9d0e1103d595f$export$22b082955e083ec3().email("Please enter valid email").required("Email is required"),
    Birthday: $cda9d0e1103d595f$export$324d90190a8b822a()
};
const $31f69c40c2db9b92$export$8a10dbd3e2b5e8cb = $cda9d0e1103d595f$export$be5493f9613cbbe({
    ...$31f69c40c2db9b92$var$validationSchema,
    Username: $31f69c40c2db9b92$var$validationSchema.Username.required("Username is required"),
    Email: $31f69c40c2db9b92$var$validationSchema.Email.required("Email is required"),
    Password: $31f69c40c2db9b92$var$validationSchema.Password.required("Password is required")
});
const $31f69c40c2db9b92$export$3b31dd58dceb0fbf = $cda9d0e1103d595f$export$be5493f9613cbbe($31f69c40c2db9b92$var$validationSchema);






const $bb9c14523224b6be$export$75543167ef08d8e5 = ({ setUser: setUser, onUpdateSuccess: onUpdateSuccess, onDeleteAccount: onDeleteAccount, isDeleting: isDeleting })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const user = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user.user);
    const [error, setError] = (0, $acw62.useState)("");
    const [success, setSuccess] = (0, $acw62.useState)(false);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const [showForm, setShowForm] = (0, $acw62.useState)(false);
    async function handleSubmit(values, { setSubmitting: setSubmitting, resetForm: resetForm }) {
        setLoading(true);
        setError("");
        try {
            console.log("Submitting values:", values);
            const updatedUser = await dispatch((0, $70709e160bcc9047$export$a3610b7739f1b17f)({
                userId: user.id,
                updates: values
            })).unwrap();
            setUser(updatedUser);
            setSuccess(true);
            resetForm();
            setTimeout(()=>{
                setSuccess(false);
                setShowForm(false);
            }, 3000);
            if (onUpdateSuccess) onUpdateSuccess(updatedUser);
        } catch (error) {
            setError("Failed to update user. Please try again.");
            console.error("Error updating user:", error);
        } finally{
            setLoading(false);
            setSubmitting(false);
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
            className: "user-update-card",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Header, {
                    className: "card-header d-flex align-items-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                        children: "Update your info"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6225d171b822135d$export$2e2bcd8739ae039), {
                    in: showForm,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                            className: "user-update-body",
                            children: [
                                error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                                    variant: "danger",
                                    className: "mb-3",
                                    children: error
                                }),
                                success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                                    variant: "success",
                                    className: "mb-3",
                                    children: "Update successful!"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                                    initialValues: {
                                        Username: "",
                                        Password: "",
                                        Email: ""
                                    },
                                    validationSchema: (0, $31f69c40c2db9b92$export$3b31dd58dceb0fbf),
                                    onSubmit: handleSubmit,
                                    children: ({ isSubmitting: isSubmitting, touched: touched, errors: errors })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                                            className: "update-form",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                                            htmlFor: "Username",
                                                            children: "Username"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                                            as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                                            id: "Username",
                                                            name: "Username",
                                                            type: "text",
                                                            placeholder: "Enter new username",
                                                            isInvalid: touched.Username && errors.Username,
                                                            autoComplete: "off"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                                            name: "Username",
                                                            component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control.Feedback,
                                                            type: "invalid"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                                            htmlFor: "Password",
                                                            children: "Password"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                                            as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                                            id: "Password",
                                                            name: "Password",
                                                            type: "password",
                                                            placeholder: "At least 8 characters or more",
                                                            isInvalid: touched.Password && errors.Password,
                                                            autoComplete: "off"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                                            name: "Password",
                                                            component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control.Feedback,
                                                            type: "invalid"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                                    className: "mb-3",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                                            htmlFor: "Email",
                                                            children: "Email"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                                            as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                                            id: "Email",
                                                            name: "Email",
                                                            type: "text",
                                                            placeholder: "Enter a new email",
                                                            isInvalid: touched.Email && errors.Email,
                                                            autoComplete: "off"
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                                            name: "Email",
                                                            component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control.Feedback,
                                                            type: "invalid"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                                    className: "update-user-button btn-primary",
                                                    type: "submit",
                                                    disabled: isSubmitting || loading,
                                                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $312515fc7a4c2917$export$2e2bcd8739ae039), {
                                                        animation: "border",
                                                        size: "sm"
                                                    }) : "Update"
                                                })
                                            ]
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                    variant: "danger",
                                    size: "sm",
                                    onClick: onDeleteAccount,
                                    disabled: isDeleting,
                                    className: "delete-account-btn",
                                    children: isDeleting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $312515fc7a4c2917$export$2e2bcd8739ae039), {
                                        animation: "border",
                                        size: "sm"
                                    }) : "Delete Account"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Footer, {
                    className: "text-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "d-flex flex-column align-items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                            variant: "link",
                            className: "toggle-form-btn",
                            onClick: ()=>setShowForm(!showForm),
                            "aria-expanded": showForm,
                            children: showForm ? "Hide" : "Click to update your info"
                        })
                    })
                })
            ]
        })
    });
};
$bb9c14523224b6be$export$75543167ef08d8e5.propTypes = {
    setUser: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    onUpdateSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
};





var $acw62 = parcelRequire("acw62");



const $d6e7616fb515f23c$export$75540b765a62d935 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("favorites/fetchFavorites", async (userId, { rejectWithValue: rejectWithValue })=>{
    try {
        const data = await (0, $80a1af099823683c$export$ffc3b27e25a738e4)(userId);
        const favorites = Array.isArray(data) ? data.map((fav)=>({
                id: fav.id,
                movie_id: fav.movie_id,
                user_id: fav.user_id
            })) : [];
        return favorites;
    } catch (err) {
        return rejectWithValue(err.message || "Failed to fetch favorites");
    }
});
const $d6e7616fb515f23c$export$534047ff6928d638 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("favorites/addFavorite", async ({ userId: userId, movieId: movieId }, { rejectWithValue: rejectWithValue })=>{
    try {
        const fav = await (0, $80a1af099823683c$export$ddb053c3dc411a1a)({
            userId: userId,
            movieId: movieId
        });
        return {
            id: fav?.id,
            movie_id: fav?.movie_id,
            user_id: fav?.user_id
        };
    } catch (err) {
        return rejectWithValue(err.message || "Failed to add favorite");
    }
});
const $d6e7616fb515f23c$export$c864b852e8fdde9a = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("favorites/removeFavorite", async ({ userId: userId, movieId: movieId }, { rejectWithValue: rejectWithValue })=>{
    try {
        await (0, $80a1af099823683c$export$a879b9ec68c84a75)({
            userId: userId,
            movieId: movieId
        });
        return {
            movieId: movieId
        };
    } catch (err) {
        return rejectWithValue(err.message || "Failed to remove favorite");
    }
});
const $d6e7616fb515f23c$var$favoritesSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "favorites",
    initialState: {
        items: [],
        status: "idle",
        error: null
    },
    reducers: {
        clearFavorites: (state)=>{
            state.items = [];
        }
    },
    extraReducers: (builder)=>{
        builder.addCase($d6e7616fb515f23c$export$75540b765a62d935.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($d6e7616fb515f23c$export$75540b765a62d935.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.items = action.payload;
        }).addCase($d6e7616fb515f23c$export$75540b765a62d935.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        }).addCase($d6e7616fb515f23c$export$534047ff6928d638.fulfilled, (state, action)=>{
            state.items.push(action.payload);
        }).addCase($d6e7616fb515f23c$export$c864b852e8fdde9a.fulfilled, (state, action)=>{
            // Remove the favorite from the items array
            state.items = state.items.filter((fav)=>String(fav.movie_id) !== String(action.payload.movieId));
        });
    }
});
const $d6e7616fb515f23c$export$f5317452364db455 = (state)=>state.favorites.items;
const $d6e7616fb515f23c$export$511775019c6f7e2a = (state)=>state.favorites.status;
const $d6e7616fb515f23c$export$6c009184b6c4c802 = (state)=>state.favorites.error;
const { clearFavorites: $d6e7616fb515f23c$export$892eec7782c4ee17 } = $d6e7616fb515f23c$var$favoritesSlice.actions;
var $d6e7616fb515f23c$export$2e2bcd8739ae039 = $d6e7616fb515f23c$var$favoritesSlice.reducer;



var $acw62 = parcelRequire("acw62");

var $34d57d646d194bf7$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $34d57d646d194bf7$var$_extends() {
    return $34d57d646d194bf7$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $34d57d646d194bf7$var$_extends.apply(null, arguments);
}
function $34d57d646d194bf7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $34d57d646d194bf7$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $34d57d646d194bf7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $34d57d646d194bf7$var$Heart = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "1em" : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = $34d57d646d194bf7$var$_objectWithoutProperties(_ref, $34d57d646d194bf7$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $34d57d646d194bf7$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            "bi",
            "bi-heart",
            className
        ].filter(Boolean).join(" ")
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"
    }));
});
$34d57d646d194bf7$var$Heart.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $34d57d646d194bf7$export$2e2bcd8739ae039 = $34d57d646d194bf7$var$Heart;


var $acw62 = parcelRequire("acw62");

var $0b70724df5702cc1$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0b70724df5702cc1$var$_extends() {
    return $0b70724df5702cc1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0b70724df5702cc1$var$_extends.apply(null, arguments);
}
function $0b70724df5702cc1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0b70724df5702cc1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0b70724df5702cc1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0b70724df5702cc1$var$HeartFill = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "1em" : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = $0b70724df5702cc1$var$_objectWithoutProperties(_ref, $0b70724df5702cc1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $0b70724df5702cc1$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            "bi",
            "bi-heart-fill",
            className
        ].filter(Boolean).join(" ")
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
    }));
});
$0b70724df5702cc1$var$HeartFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $0b70724df5702cc1$export$2e2bcd8739ae039 = $0b70724df5702cc1$var$HeartFill;





const $89233c5a4601a3c2$export$d2ae44ae5a7d01ef = ({ favoriteMovies: favoriteMovies })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const favorites = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.favorites.items);
    const user = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user.user);
    const isFavorite = (movieId)=>favorites.some((fav)=>String(fav.movie_id) === String(movieId));
    const toggleFavorite = async (movieId)=>{
        setIsLoading(true);
        try {
            if (isFavorite(movieId)) await dispatch((0, $d6e7616fb515f23c$export$c864b852e8fdde9a)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
            else await dispatch((0, $d6e7616fb515f23c$export$534047ff6928d638)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
        } catch (error) {
            console.error("Error toggling favorite:", error);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
        className: "favorite-movies-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                    children: "Favorite Movies"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                className: "favorite-movies-body",
                children: !favoriteMovies || favoriteMovies.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "no-favorites-message",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "No favorite movies"
                    })
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "favorite-movies-grid",
                    children: favoriteMovies.map((movie)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "favorite-movie-col",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "favorite-movie-item",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                        to: `/movies/${movie.id}`,
                                        className: "movie-link",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "movie-poster-wrapper",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                                    src: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : "https://placehold.co/300x450?text=Bestflix",
                                                    alt: movie.title,
                                                    className: "movie-poster"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "movie-title-wrapper",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h6", {
                                                    className: "movie-title",
                                                    children: movie.title
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "movie-card__favorite-btn",
                                    onClick: ()=>toggleFavorite(movie.id),
                                    disabled: isLoading,
                                    "aria-label": isFavorite(movie.id) ? "Remove from favorites" : "Add to favorites",
                                    children: isFavorite(movie.id) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b70724df5702cc1$export$2e2bcd8739ae039), {
                                        className: "heart-icon filled"
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34d57d646d194bf7$export$2e2bcd8739ae039), {
                                        className: "heart-icon"
                                    })
                                })
                            ]
                        }, movie.id))
                })
            })
        ]
    });
};






const $945b6b605f7d5172$export$b378b4d12a0dcbde = ({ setUser: setUser, onLoggedOut: onLoggedOut })=>{
    const user = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user.user);
    const favorites = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.favorites.items);
    const movies = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.movies.movies);
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [isDeleting, setIsDeleting] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (user?.id) dispatch((0, $d6e7616fb515f23c$export$75540b765a62d935)(user.id));
    }, [
        user,
        dispatch
    ]);
    const handleUserRemove = async ()=>{
        if (!window.confirm("Are you sure you want to delete your account? This action cannot be undone.")) return;
        setIsDeleting(true);
        try {
            await dispatch((0, $70709e160bcc9047$export$61b56d6536837ca9)(user.id)).unwrap();
            onLoggedOut();
            localStorage.clear();
            alert("Your account has been successfully deleted.");
            navigate("/login", {
                replace: true
            });
        } catch (error) {
            console.error("Error:", error);
            alert("Failed to delete account. Please try again.");
        } finally{
            setIsDeleting(false);
        }
    };
    const handleUpdateUser = async (updates)=>{
        try {
            const updatedUser = await dispatch((0, $70709e160bcc9047$export$a3610b7739f1b17f)({
                userId: user.id,
                updates: updates
            })).unwrap();
            setUser(updatedUser);
            localStorage.setItem("user", JSON.stringify(updatedUser));
        } catch (error) {
            console.error("Error updating user:", error);
            alert("Failed to update user information. Please try again.");
        }
    };
    const favoriteMovies = favorites.map((fav)=>movies.find((m)=>String(m.id) === String(fav.movie_id))).filter(Boolean);
    const displayName = user?.username || user?.Username || user?.email || "User";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        className: "profile-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                className: "justify-content-center mt-4",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        md: 6,
                        className: "user-info",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc3cd34d8ac3cec0$export$c6ede3bfc40c5e4b), {
                            user: displayName,
                            email: user.email
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        md: 6,
                        className: "user-update",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bb9c14523224b6be$export$75543167ef08d8e5), {
                            setUser: setUser,
                            onUpdateSuccess: handleUpdateUser,
                            onDeleteAccount: handleUserRemove,
                            isDeleting: isDeleting
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                    md: 12,
                    className: "favorite-movies",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89233c5a4601a3c2$export$d2ae44ae5a7d01ef), {
                        favoriteMovies: favoriteMovies
                    })
                })
            })
        ]
    });
};
$945b6b605f7d5172$export$b378b4d12a0dcbde.propTypes = {
    setUser: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
    onLoggedOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
};




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");



function $0084afcb87732665$export$3d03cefad97f5c33(propType) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        propType,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            xs: propType,
            sm: propType,
            md: propType,
            lg: propType,
            xl: propType,
            xxl: propType
        })
    ]);
}
function $0084afcb87732665$export$2e2bcd8739ae039(utilityValues, breakpoints = (0, $626bd95fa485b758$export$666ad80b5007f835), minBreakpoint = (0, $626bd95fa485b758$export$ff817e17bad2e091)) {
    const classes = [];
    Object.entries(utilityValues).forEach(([utilName, utilValue])=>{
        if (utilValue != null) {
            if (typeof utilValue === "object") breakpoints.forEach((brkPoint)=>{
                const bpValue = utilValue[brkPoint];
                if (bpValue != null) {
                    const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : "";
                    classes.push(`${utilName}${infix}-${bpValue}`);
                }
            });
            else classes.push(`${utilName}-${utilValue}`);
        }
    });
    return classes;
}



"use client";
const $75fca2d36eb6f6ee$var$Stack = /*#__PURE__*/ $acw62.forwardRef(({ as: Component = "div", bsPrefix: bsPrefix, className: className, direction: direction, gap: gap, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, direction === "horizontal" ? "hstack" : "vstack");
    const breakpoints = (0, $626bd95fa485b758$export$8970c8db816a5863)();
    const minBreakpoint = (0, $626bd95fa485b758$export$d926d6ef38f3fd32)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, ...(0, $0084afcb87732665$export$2e2bcd8739ae039)({
            gap: gap
        }, breakpoints, minBreakpoint))
    });
});
$75fca2d36eb6f6ee$var$Stack.displayName = "Stack";
var $75fca2d36eb6f6ee$export$2e2bcd8739ae039 = $75fca2d36eb6f6ee$var$Stack;


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
function $6227e7ea0d71afb1$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $acw62.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $acw62 = parcelRequire("acw62");
function $63805df80cf3ca43$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $6227e7ea0d71afb1$export$2e2bcd8739ae039)(fn);
    (0, $acw62.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $7da2b291db98759b$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$7da2b291db98759b$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $7da2b291db98759b$var$MAX_DELAY_MS);
}
function $7da2b291db98759b$export$2e2bcd8739ae039() {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $acw62.useRef)();
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $acw62.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $7da2b291db98759b$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $7da2b291db98759b$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}



var $acw62 = parcelRequire("acw62");



const $00e1931a5a411411$var$fadeStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "showing",
    [(0, $0fef977f04119bf5$export$4aacc83d4d59139f)]: "showing show"
};
const $00e1931a5a411411$var$ToastFade = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $00e1931a5a411411$var$fadeStyles
    }));
$00e1931a5a411411$var$ToastFade.displayName = "ToastFade";
var $00e1931a5a411411$export$2e2bcd8739ae039 = $00e1931a5a411411$var$ToastFade;




var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
"use client";
const $ed733ce3364e9053$var$ToastContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose () {}
});
var $ed733ce3364e9053$export$2e2bcd8739ae039 = $ed733ce3364e9053$var$ToastContext;



"use client";
const $30946ad0f37cc61a$var$ToastHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "toast-header");
    const context = (0, $acw62.useContext)((0, $ed733ce3364e9053$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$30946ad0f37cc61a$var$ToastHeader.displayName = "ToastHeader";
var $30946ad0f37cc61a$export$2e2bcd8739ae039 = $30946ad0f37cc61a$var$ToastHeader;



var $acw62 = parcelRequire("acw62");



"use client";
const $ee38f89d3acd2add$var$ToastBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "toast-body");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$ee38f89d3acd2add$var$ToastBody.displayName = "ToastBody";
var $ee38f89d3acd2add$export$2e2bcd8739ae039 = $ee38f89d3acd2add$var$ToastBody;





"use client";
const $6983c81067896c21$var$Toast = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $00e1931a5a411411$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "toast");
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $acw62.useRef)(delay);
    const onCloseRef = (0, $acw62.useRef)(onClose);
    (0, $acw62.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $7da2b291db98759b$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $acw62.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $acw62.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $acw62.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? "show" : "hide")),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed733ce3364e9053$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$6983c81067896c21$var$Toast.displayName = "Toast";
var $6983c81067896c21$export$2e2bcd8739ae039 = Object.assign($6983c81067896c21$var$Toast, {
    Body: (0, $ee38f89d3acd2add$export$2e2bcd8739ae039),
    Header: (0, $30946ad0f37cc61a$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");


"use client";
const $580c88b3c35e61d7$var$positionClasses = {
    "top-start": "top-0 start-0",
    "top-center": "top-0 start-50 translate-middle-x",
    "top-end": "top-0 end-0",
    "middle-start": "top-50 start-0 translate-middle-y",
    "middle-center": "top-50 start-50 translate-middle",
    "middle-end": "top-50 end-0 translate-middle-y",
    "bottom-start": "bottom-0 start-0",
    "bottom-center": "bottom-0 start-50 translate-middle-x",
    "bottom-end": "bottom-0 end-0"
};
const $580c88b3c35e61d7$var$ToastContainer = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "toast-container");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(bsPrefix, position && $580c88b3c35e61d7$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$580c88b3c35e61d7$var$ToastContainer.displayName = "ToastContainer";
var $580c88b3c35e61d7$export$2e2bcd8739ae039 = $580c88b3c35e61d7$var$ToastContainer;






const $078b54a47d6056e3$export$78d497080ea8f89a = ({ genres: genres })=>{
    const { movieId: movieId } = (0, $7939e29d663dd3ed$export$99eaa27ddbbb95ef)();
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const user = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user.user);
    const movies = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.movies.movies);
    const favorites = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.favorites.items);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [toastState, setToastState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        show: false,
        message: "",
        type: "success"
    });
    const movie = movies.find((m)=>m.id === Number(movieId));
    const isFavorite = favorites.some((fav)=>String(fav.movie_id) === String(movieId));
    const handleFavoriteClick = async (e)=>{
        e.preventDefault();
        if (!user?.id) return;
        setIsLoading(true);
        try {
            if (isFavorite) await dispatch((0, $d6e7616fb515f23c$export$c864b852e8fdde9a)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
            else await dispatch((0, $d6e7616fb515f23c$export$534047ff6928d638)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
        } catch (error) {
            console.error("Error toggling favorite:", error);
            setToastState({
                show: true,
                message: "Failed to update favorite status.",
                type: "error"
            });
        } finally{
            setIsLoading(false);
        }
    };
    if (!movies.length) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-center mt-5",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "spinner-border text-light",
                role: "status",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        })
    });
    if (!movie) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center mt-5",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                    className: "text-light",
                    children: "Movie not found"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                    to: "/",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        className: "back-button",
                        children: "Back to Movies"
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        className: "movie-view",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                className: "justify-content-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        md: 12,
                        lg: 12,
                        className: "movie-back-button",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: `/`,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                variant: "secondary",
                                className: "back-button",
                                children: "Back"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        md: 4,
                        lg: 4,
                        className: "mt-3 mb-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
                            className: "movie-view__poster-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Header, {
                                    className: "movie-view__header",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                                            className: "movie-view__title",
                                            children: movie.title
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "movie-view__actions",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                className: "movie-card__favorite-btn",
                                                onClick: handleFavoriteClick,
                                                disabled: isLoading,
                                                "aria-label": isFavorite ? "Remove from favorites" : "Add to favorites",
                                                children: isFavorite ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b70724df5702cc1$export$2e2bcd8739ae039), {
                                                    className: "heart-icon filled"
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34d57d646d194bf7$export$2e2bcd8739ae039), {
                                                    className: "heart-icon"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Img, {
                                    src: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : "https://placehold.co/300x450?text=No+Image",
                                    alt: movie.title,
                                    className: "movie-view__poster-image"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                        md: 8,
                        lg: 8,
                        className: "movie-view__details",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
                            className: "movie-view__details-card",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                                className: "movie-view__body",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $75fca2d36eb6f6ee$export$2e2bcd8739ae039), {
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "movie-view__info-section",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Subtitle, {
                                                    className: "movie-view__subtitle",
                                                    children: "Overview"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "movie-view__text",
                                                    children: movie.overview
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("hr", {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "movie-view__info-section",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Subtitle, {
                                                    className: "movie-view__subtitle",
                                                    children: "Genre"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    className: "movie-view__text",
                                                    children: (()=>{
                                                        const firstGenreId = movie.genre_ids[0];
                                                        const genreObj = genres.find((g)=>g.id === firstGenreId);
                                                        return genreObj ? genreObj.name : "";
                                                    })()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "movie-view__info-section",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Subtitle, {
                                                    className: "movie-view__subtitle",
                                                    children: "Details..."
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                    className: "movie-view__movie-details",
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h4", {
                                                            className: "movie-view__movie-details-rating",
                                                            children: [
                                                                "rating: ",
                                                                movie.vote_average
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                            className: "movie-view__movie-details-release-date",
                                                            children: [
                                                                "release date: ",
                                                                movie.releaseDate
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                            className: "movie-view__movie-details-bio",
                                                            children: movie.directorBio
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $580c88b3c35e61d7$export$2e2bcd8739ae039), {
                position: "bottom-end",
                className: "p-3",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6983c81067896c21$export$2e2bcd8739ae039), {
                    show: toastState.show,
                    onClose: ()=>setToastState((prev)=>({
                                ...prev,
                                show: false
                            })),
                    delay: 3000,
                    autohide: true,
                    bg: toastState.variant,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6983c81067896c21$export$2e2bcd8739ae039).Body, {
                        className: "text-white",
                        children: toastState.message
                    })
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $967999a1a8cec832$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
var $371d31aa64efa655$var$has = Object.prototype.hasOwnProperty;
function $371d31aa64efa655$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($371d31aa64efa655$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $371d31aa64efa655$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $371d31aa64efa655$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === "object") {
                    tmp = $371d31aa64efa655$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$371d31aa64efa655$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === "object") {
            len = 0;
            for(ctor in foo){
                if ($371d31aa64efa655$var$has.call(foo, ctor) && ++len && !$371d31aa64efa655$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$371d31aa64efa655$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $acw62 = parcelRequire("acw62");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $736213cceee2e4cc$var$useSafeState(state) {
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $acw62.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $736213cceee2e4cc$export$2e2bcd8739ae039 = $736213cceee2e4cc$var$useSafeState;



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}



function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};







function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $aa2830a619d3769f$export$8f7491d57c8f97a9 = (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $69d8d7bda7717b01$export$2e2bcd8739ae039),
        (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
        (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
        (0, $e7d7845625089588$export$2e2bcd8739ae039),
        (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
        (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
        (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
        (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039)
    ]
});


const $3e96790ca7bcc44e$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $3e96790ca7bcc44e$var$disabledApplyStylesModifier = {
    name: "applyStyles",
    enabled: false,
    phase: "afterWrite",
    fn: ()=>undefined
};
// until docjs supports type exports...
const $3e96790ca7bcc44e$var$ariaDescribedByModifier = {
    name: "ariaDescribedBy",
    enabled: true,
    phase: "afterWrite",
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ("removeAttribute" in reference) {
                const ids = (reference.getAttribute("aria-describedby") || "").split(",").filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute("aria-describedby");
                else reference.setAttribute("aria-describedby", ids.join(","));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute("role")) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === "tooltip" && "setAttribute" in reference) {
            const ids = reference.getAttribute("aria-describedby");
            if (ids && ids.split(",").indexOf(popper.id) !== -1) return;
            reference.setAttribute("aria-describedby", ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $3e96790ca7bcc44e$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $3e96790ca7bcc44e$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = "bottom", strategy: strategy = "absolute", modifiers: modifiers = $3e96790ca7bcc44e$var$EMPTY_MODIFIERS } = _ref, config = $3e96790ca7bcc44e$var$_objectWithoutPropertiesLoose(_ref, $3e96790ca7bcc44e$var$_excluded);
    const prevModifiers = (0, $acw62.useRef)(modifiers);
    const popperInstanceRef = (0, $acw62.useRef)();
    const update = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $acw62.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $736213cceee2e4cc$export$2e2bcd8739ae039)((0, $acw62.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $acw62.useMemo)(()=>({
            name: "updateStateModifier",
            enabled: true,
            phase: "write",
            requires: [
                "computeStyles"
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $acw62.useMemo)(()=>{
        if (!(0, $371d31aa64efa655$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $3e96790ca7bcc44e$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $aa2830a619d3769f$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $3e96790ca7bcc44e$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $3e96790ca7bcc44e$export$2e2bcd8739ae039 = $3e96790ca7bcc44e$var$usePopper;





var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $bfacdc492f374f5e$var$noop = ()=>{};
function $bfacdc492f374f5e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $bfacdc492f374f5e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $bfacdc492f374f5e$export$347601c75fcd4732 = (ref)=>ref && ("current" in ref ? ref.current : ref);
const $bfacdc492f374f5e$var$InitialTriggerEvents = {
    click: "mousedown",
    mouseup: "mousedown",
    pointerup: "pointerdown"
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $bfacdc492f374f5e$var$useClickOutside(ref, onClickOutside = $bfacdc492f374f5e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = "click" } = {}) {
    const preventMouseClickOutsideRef = (0, $acw62.useRef)(false);
    const waitingForTrigger = (0, $acw62.useRef)(false);
    const handleMouseCapture = (0, $acw62.useCallback)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ebfc6adce9fdacf8$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $bfacdc492f374f5e$var$isModifiedEvent(e) || !$bfacdc492f374f5e$var$isLeftClickEvent(e) || !!(0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $bfacdc492f374f5e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $967999a1a8cec832$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
    });
    const handleMouse = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $acw62.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)($bfacdc492f374f5e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, $bfacdc492f374f5e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ("ontouchstart" in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(el, "mousemove", $bfacdc492f374f5e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $bfacdc492f374f5e$export$2e2bcd8739ae039 = $bfacdc492f374f5e$var$useClickOutside;



const $e8106b249b7a3807$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e8106b249b7a3807$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $e8106b249b7a3807$var$noop;
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if ((0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $acw62.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)((0, $bfacdc492f374f5e$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(doc, "keyup", (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $e8106b249b7a3807$export$2e2bcd8739ae039 = $e8106b249b7a3807$var$useRootClose;





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $0e151397e562aebc$var$Context = /*#__PURE__*/ (0, $acw62.createContext)((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) ? window : undefined);
const $0e151397e562aebc$export$f7d306aeb1cf5fbc = $0e151397e562aebc$var$Context.Provider;
function $0e151397e562aebc$export$2e2bcd8739ae039() {
    return (0, $acw62.useContext)($0e151397e562aebc$var$Context);
}


const $1892253eb6d46162$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $55986f7b0f69fd17$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $fcf05e248574eb57$export$2e2bcd8739ae039)()).body;
    if (typeof ref === "function") ref = ref();
    if (ref && "current" in ref) ref = ref.current;
    if (ref && ("nodeType" in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $1892253eb6d46162$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $acw62.useState)(()=>$1892253eb6d46162$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $acw62.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const nextRef = $1892253eb6d46162$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}


function $d29a438d14321507$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $d29a438d14321507$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $d29a438d14321507$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $d29a438d14321507$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? "fixed" : popperConfig.strategy,
        modifiers: $d29a438d14321507$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}






var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $83a01f83dd44ef33$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $acw62.useRef)(null);
    const hasEnteredRef = (0, $acw62.useRef)(inProp);
    const handleExited = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onExited);
    (0, $acw62.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    const child = /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $83a01f83dd44ef33$export$2e2bcd8739ae039 = $83a01f83dd44ef33$var$NoopTransition;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


const $f822f32dd67fcc9c$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f822f32dd67fcc9c$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $f822f32dd67fcc9c$var$_objectWithoutPropertiesLoose(_ref, $f822f32dd67fcc9c$var$_excluded);
    const { major: major } = (0, $a36e95ee292bed8b$export$13e065f3a74cfe36)();
    const childRef = major >= 19 ? children.props.ref : children.ref;
    const nodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(nodeRef, typeof children === "function" ? null : childRef);
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $acw62.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $acw62.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $acw62.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $acw62.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $acw62.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $acw62.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $acw62.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === "function" ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $3b128d8465760c69$var$_excluded = [
    "component"
];
function $3b128d8465760c69$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $3b128d8465760c69$var$RTGTransition = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $3b128d8465760c69$var$_objectWithoutPropertiesLoose(_ref, $3b128d8465760c69$var$_excluded);
    const transitionProps = (0, $f822f32dd67fcc9c$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $3b128d8465760c69$export$2e2bcd8739ae039 = $3b128d8465760c69$var$RTGTransition;



function $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $acw62.useRef)(null);
    const isInitialRef = (0, $acw62.useRef)(true);
    const handleTransition = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onTransition);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $86d0e8a9dc3b2e91$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $acw62.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $86d0e8a9dc3b2e91$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, children.ref);
    return exited && !inProp ? null : /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ref: combinedRef
    });
}
function $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3b128d8465760c69$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($86d0e8a9dc3b2e91$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $83a01f83dd44ef33$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $93d1afca8879b95a$var$Overlay = /*#__PURE__*/ $acw62.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.container);
    const target = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $acw62.useState)(!props.show);
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(target, rootElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $e8106b249b7a3807$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(child, container) : null;
});
$93d1afca8879b95a$var$Overlay.displayName = "Overlay";
var $93d1afca8879b95a$export$2e2bcd8739ae039 = $93d1afca8879b95a$var$Overlay;






var $acw62 = parcelRequire("acw62");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



"use client";
const $a6e5f9750149a1a0$var$PopoverHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "popover-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$a6e5f9750149a1a0$var$PopoverHeader.displayName = "PopoverHeader";
var $a6e5f9750149a1a0$export$2e2bcd8739ae039 = $a6e5f9750149a1a0$var$PopoverHeader;



var $acw62 = parcelRequire("acw62");



"use client";
const $322d82ade70b4ad6$var$PopoverBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "popover-body");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$322d82ade70b4ad6$var$PopoverBody.displayName = "PopoverBody";
var $322d82ade70b4ad6$export$2e2bcd8739ae039 = $322d82ade70b4ad6$var$PopoverBody;



var $acw62 = parcelRequire("acw62");
class $5be11e4096c49daa$export$34582a676b91ff07 extends $acw62.Component {
}
function $5be11e4096c49daa$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === "left") bsDirection = isRTL ? "end" : "start";
    else if (placement === "right") bsDirection = isRTL ? "start" : "end";
    return bsDirection;
}


function $2773df40e83847cd$export$2e2bcd8739ae039(position = "absolute") {
    return {
        position: position,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
    };
}



"use client";
const $d0df75e22d728968$var$Popover = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "popover");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $322d82ade70b4ad6$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
var $d0df75e22d728968$export$2e2bcd8739ae039 = Object.assign($d0df75e22d728968$var$Popover, {
    Header: (0, $a6e5f9750149a1a0$export$2e2bcd8739ae039),
    Body: (0, $322d82ade70b4ad6$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $acw62 = parcelRequire("acw62");




"use client";
const $0937b8ed541186d0$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, placement: placement = "right", className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "tooltip");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split("-")) || [];
    const bsDirection = (0, $5be11e4096c49daa$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $2773df40e83847cd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0937b8ed541186d0$var$Tooltip.displayName = "Tooltip";
var $0937b8ed541186d0$export$2e2bcd8739ae039 = Object.assign($0937b8ed541186d0$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $5444443f433675a7$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $acw62.useRef)(null);
    const popoverClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "popover");
    const tooltipClass = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "tooltip");
    const offset = (0, $acw62.useMemo)(()=>({
            name: "offset",
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $d0df75e22d728968$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $0937b8ed541186d0$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $fa76858134013112$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r)));
}
const $fa76858134013112$var$Overlay = /*#__PURE__*/ $acw62.forwardRef(({ children: overlay, transition: transition = (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = "top", show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $acw62.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $acw62.useState)(null);
    const [ref, modifiers] = (0, $5444443f433675a7$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $588ffbaaa8a325aa$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93d1afca8879b95a$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $fa76858134013112$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === "function") return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: "show"
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $acw62.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(overlay.props.className, !transition && show && "show"),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$fa76858134013112$var$Overlay.displayName = "Overlay";
var $fa76858134013112$export$2e2bcd8739ae039 = $fa76858134013112$var$Overlay;




"use client";
function $3ec0f3191f4dead1$var$normalizeDelay(delay) {
    return delay && typeof delay === "object" ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $3ec0f3191f4dead1$var$handleMouseOverOut(// eslint-disable-next-line @typescript-eslint/no-shadow
handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $3ec0f3191f4dead1$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
    "click",
    "hover",
    "focus"
]);
const $3ec0f3191f4dead1$var$OverlayTrigger = ({ trigger: trigger = [
    "hover",
    "focus"
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf("auto") !== -1, ...props })=>{
    const triggerNodeRef = (0, $acw62.useRef)(null);
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(triggerNodeRef, children.ref);
    const timeout = (0, $7da2b291db98759b$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $acw62.useRef)("");
    const [show, setShow] = (0, $5809a50e160ad91a$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $3ec0f3191f4dead1$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== "function" ? $acw62.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $75718871ab216e51$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "show";
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "show") setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $acw62.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = "hide";
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === "hide") setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $acw62.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $acw62.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $acw62.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleShow, args, "fromElement");
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $acw62.useCallback)((...args)=>{
        $3ec0f3191f4dead1$var$handleMouseOverOut(handleHide, args, "toElement");
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf("click") !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf("focus") !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf("hover") !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            typeof children === "function" ? children(triggerProps) : /*#__PURE__*/ (0, $acw62.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fa76858134013112$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $3ec0f3191f4dead1$export$2e2bcd8739ae039 = $3ec0f3191f4dead1$var$OverlayTrigger;







const $bd664d6ef1f52408$export$9bd698419030e459 = ({ movie: movie, genres: genres })=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const user = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user.user);
    const favorites = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.favorites.items) || [];
    const movies = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.movies.movies);
    const safeGenres = Array.isArray(genres) ? genres : [];
    const [showTooltip, setShowTooltip] = (0, $acw62.useState)(false);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const isFavorite = favorites.some((fav)=>String(fav.movie_id) === String(movie.id));
    const toggleFavorite = async (movieId)=>{
        if (!user?.id) {
            console.warn("\u26A0\uFE0F Must be logged in");
            setShowTooltip(true);
            return;
        }
        setIsLoading(true);
        try {
            if (isFavorite) await dispatch((0, $d6e7616fb515f23c$export$c864b852e8fdde9a)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
            else await dispatch((0, $d6e7616fb515f23c$export$534047ff6928d638)({
                userId: user.id,
                movieId: movieId
            })).unwrap();
            await dispatch((0, $d6e7616fb515f23c$export$75540b765a62d935)(user.id)).unwrap();
            setShowTooltip(false); // Hide tooltip after action
        // optional: refresh favorites or show toast here
        } catch (error) {
            console.error("\u274C Favorite toggle failed:", error);
        } finally{
            setIsLoading(false);
        }
    };
    const getFirstGenreName = ()=>{
        if (movie?.genre?.name) return movie.genre.name;
        if (!movie.genre_ids || safeGenres.length === 0) return "";
        const firstGenreId = movie.genre_ids[0];
        const genreObj = safeGenres.find((g)=>g.id === firstGenreId);
        return genreObj ? genreObj.name : "";
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
        className: "movie-card",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                to: `/movies/${encodeURIComponent(movie.id)}`,
                className: "movie-card__image-link",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Img, {
                    variant: "top",
                    src: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : "https://placehold.co/300x450?text=No+Image",
                    alt: movie.title,
                    className: "movie-card__image"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                className: "movie-card__content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Text, {
                        className: "movie-card__genre",
                        children: safeGenres.length === 0 && !movie?.genre?.name ? "Loading genre..." : getFirstGenreName()
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "movie-card__title-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Title, {
                                className: "movie-card__title",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: movie.title
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "movie-card__favorite-btn",
                                onClick: ()=>toggleFavorite(movie.id),
                                disabled: isLoading,
                                "aria-label": isFavorite ? "Remove from favorites" : "Add to favorites",
                                children: isFavorite ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0b70724df5702cc1$export$2e2bcd8739ae039), {
                                    className: "heart-icon filled"
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $34d57d646d194bf7$export$2e2bcd8739ae039), {
                                    className: "heart-icon"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ec0f3191f4dead1$export$2e2bcd8739ae039), {
                        placement: "top",
                        overlay: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0937b8ed541186d0$export$2e2bcd8739ae039), {
                            className: "movie-card__description-tooltip",
                            children: movie.overview
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Text, {
                            className: "movie-card__description",
                            children: movie.overview
                        })
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");

var $b6e10067a0e97ca4$exports = {};
$b6e10067a0e97ca4$exports = new URL("bestflix_logotype.c36a031c.svg", import.meta.url).toString();



const $49be892743f19bec$var$AuthLayout = ({ title: title, subtitle: subtitle, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "auth-background",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
            className: "auth-container",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "auth-header mb-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                            className: "auth-welcome",
                            children: "Welcome to "
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "auth-logo-wrapper",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b6e10067a0e97ca4$exports))),
                                    alt: "bestflix logo",
                                    className: "auth-logo"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "auth-slogan",
                                    children: "still a lot to watch"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039), {
                    className: "auth-card shadow-lg",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Body, {
                        className: "auth-card-body",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h4", {
                                className: "auth-title text-center",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7f9683b4f5c2a43f$export$2e2bcd8739ae039).Subtitle, {
                                className: "auth-subtitle text-muted text-center mb-2",
                                children: subtitle
                            }),
                            children
                        ]
                    })
                })
            ]
        })
    });
};
var $49be892743f19bec$export$2e2bcd8739ae039 /*<Container className="login-container">
                    <Container className="header-container">
                        <Row className="justify-content-center">
                            <Col xs={12} sm={8} md={6} lg={4}>
                                <div className="text-end mb-4">
                                    <div className="title-logo-wrapper">
                                        <h2>Welcome to</h2>
                                        <img
                                            src={logo}
                                            alt="bestflix logo"
                                            className="logo-image"
                                            width="250"
                                            height="auto"
                                        />
                                    </div>
                                    <h6>still a lot to watch</h6>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={8} md={6} lg={4}>
                            <Card className="login-card">
                                <div className="title-container">
                                    <Card.Title>Login</Card.Title>
                                    <Card.Subtitle className="text-muted">
                                        Please login to continue
                                    </Card.Subtitle>
                                </div>{" "}
                                <Card.Body>
                                    {error && (
                                        <Alert variant="danger" className="mb-3">
                                            {error}
                                        </Alert>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>*/  = $49be892743f19bec$var$AuthLayout;


const $e82b918e273f1954$export$1582048ca8384970 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { user: user, token: token, status: status, error: error } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user);
    const [email, setEmail] = (0, $acw62.useState)("");
    const [password, setPassword] = (0, $acw62.useState)("");
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    // Redirect to main page after successful login
    (0, $acw62.useEffect)(()=>{
        if (user && token) navigate("/");
    }, [
        user,
        token,
        navigate
    ]);
    const handleSubmit = (event)=>{
        event.preventDefault();
        dispatch((0, $70709e160bcc9047$export$a15ba4bdf59dacc9)());
        dispatch((0, $70709e160bcc9047$export$596d806903d1f59e)({
            Email: email,
            Password: password
        }));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49be892743f19bec$export$2e2bcd8739ae039), {
        title: "Login",
        subtitle: "Please login to continue",
        children: [
            error && status === "failed" && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                variant: "danger",
                className: "mb-3",
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039), {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                        controlId: "formEmail",
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                children: "Email"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                name: "email",
                                type: "email",
                                value: email,
                                onChange: (e)=>setEmail(e.target.value),
                                required: true,
                                minLength: "3",
                                className: "form-control"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                        controlId: "formPassword",
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                children: "Password"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control, {
                                name: "password",
                                type: "password",
                                value: password,
                                onChange: (e)=>setPassword(e.target.value),
                                required: true,
                                minLength: "3",
                                className: "form-control"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "button-container",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                type: "submit",
                                variant: "primary",
                                className: "login-button",
                                disabled: status === "loading",
                                children: status === "loading" ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $312515fc7a4c2917$export$2e2bcd8739ae039), {
                                            as: "span",
                                            animation: "border",
                                            size: "sm",
                                            role: "status",
                                            "aria-hidden": "true",
                                            className: "me-2"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "visually-hidden",
                                            children: "Logging in..."
                                        })
                                    ]
                                }) : "Login"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mb-0",
                                    children: [
                                        "Don't have an account?",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/signup",
                                            className: "signup-link",
                                            onClick: ()=>{
                                                console.log("[LoginView] Sign up link clicked");
                                            },
                                            children: "Sign up"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $7YFi7 = parcelRequire("7YFi7");





const $c219fcfdec4acb71$export$25f3896ea1e09820 = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    const [error, setError] = (0, $acw62.useState)("");
    const [success, setSuccess] = (0, $acw62.useState)(false);
    const getSignupErrorMessage = (err)=>{
        if (err?.status === 409) return "An account with this email already exists. Try logging in instead.";
        if (err?.status === 400) return err.message || "Please check the signup form and try again.";
        if (err?.status === 0) return err.message;
        return err.message || "Signup failed. Please try again.";
    };
    // Form submission handler
    const handleSubmit = async (values, { setSubmitting: setSubmitting, resetForm: resetForm })=>{
        setSubmitting(true);
        setError("");
        setSuccess(false);
        try {
            await (0, $80a1af099823683c$export$5f19683c868a137a)({
                Email: values.Email,
                Password: values.Password,
                username: values.Username
            });
            await dispatch((0, $70709e160bcc9047$export$596d806903d1f59e)({
                Email: values.Email,
                Password: values.Password
            }));
            setSuccess(true);
            resetForm();
            setTimeout(()=>navigate("/"), 2000);
        } catch (err) {
            console.error("Signup error:", err);
            setError(getSignupErrorMessage(err));
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49be892743f19bec$export$2e2bcd8739ae039), {
        title: "Sign Up",
        subtitle: "Create an account",
        children: [
            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                variant: "danger",
                className: "mb-3",
                role: "alert",
                "aria-live": "polite",
                children: error
            }),
            success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9091c2598933ffd8$export$2e2bcd8739ae039), {
                variant: "success",
                className: "mb-3",
                role: "status",
                children: "Signup successful! Redirecting..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Formik), {
                initialValues: {
                    Username: "",
                    Password: "",
                    Email: "",
                    termsAccepted: false
                },
                validationSchema: (0, $31f69c40c2db9b92$export$8a10dbd3e2b5e8cb),
                onSubmit: (values, actions)=>{
                    handleSubmit(values, actions);
                },
                children: ({ isSubmitting: isSubmitting, touched: touched, errors: errors })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7YFi7.Form), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                        htmlFor: "Username",
                                        children: "Username"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                        id: "Username",
                                        name: "Username",
                                        type: "text",
                                        "aria-describedby": "username-error",
                                        isInvalid: touched.Username && errors.Username
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                        name: "Username",
                                        component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Text,
                                        id: "username-error",
                                        className: "text-danger"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                        htmlFor: "Email",
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                        id: "Email",
                                        name: "Email",
                                        type: "email",
                                        isInvalid: touched.Email && errors.Email
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                        name: "Email",
                                        component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Text,
                                        id: "email-error",
                                        className: "text-danger",
                                        "data-testid": "email-error",
                                        style: {
                                            minHeight: 20
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                        htmlFor: "Password",
                                        children: "Password"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                        as: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Control,
                                        id: "Password",
                                        name: "Password",
                                        type: "password",
                                        isInvalid: touched.Password && errors.Password
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                        name: "Password",
                                        component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Text,
                                        id: "password-error",
                                        className: "text-danger",
                                        "data-testid": "password-error"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Group, {
                                className: "form-group mb-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "terms-checkbox",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.Field), {
                                            type: "checkbox",
                                            name: "termsAccepted",
                                            id: "termsAccepted",
                                            className: `form-check-input ${touched.termsAccepted && errors.termsAccepted ? "is-invalid" : ""}`
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $64675cdb3851f16c$export$2e2bcd8739ae039).Label, {
                                            htmlFor: "termsAccepted",
                                            className: "form-check-label ms-2 mt-1",
                                            children: [
                                                "I Agree to the",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                                    to: "/terms",
                                                    className: "terms-link",
                                                    children: "Terms & Conditions"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7YFi7.ErrorMessage), {
                                            name: "termsAccepted",
                                            component: (0, $64675cdb3851f16c$export$2e2bcd8739ae039).Text,
                                            className: "text-danger"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "button-container",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), {
                                    variant: "primary",
                                    type: "submit",
                                    disabled: isSubmitting,
                                    className: "signup-button",
                                    children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $312515fc7a4c2917$export$2e2bcd8739ae039), {
                                                as: "span",
                                                animation: "border",
                                                size: "sm",
                                                role: "status",
                                                "aria-hidden": "true",
                                                className: "me-2"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "visually-hidden",
                                                children: "Signing up..."
                                            })
                                        ]
                                    }) : "Sign Up"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "text-center mt-3",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                    className: "mb-0",
                                    children: [
                                        "Already have an account?",
                                        " ",
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                                            to: "/login",
                                            className: "login-link",
                                            children: "Login"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
            }, "signup-form")
        ]
    });
};




var $572d173155431dc3$exports = {};
"use strict";
Object.defineProperty($572d173155431dc3$exports, "__esModule", {
    value: true
});
$572d173155431dc3$exports.default = $572d173155431dc3$var$all;
var $6bef38e8094f8c50$exports = {};
"use strict";
Object.defineProperty($6bef38e8094f8c50$exports, "__esModule", {
    value: true
});
$6bef38e8094f8c50$exports.default = $6bef38e8094f8c50$var$createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ // Mostly taken from ReactPropTypes.
function $6bef38e8094f8c50$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || "<<anonymous>>";
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            if (isRequired) return new Error("Required " + location + " `" + propFullNameSafe + "` was not specified " + ("in `" + componentNameSafe + "`."));
            return null;
        }
        for(var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)args[_key - 6] = arguments[_key];
        return validate.apply(undefined, [
            props,
            propName,
            componentNameSafe,
            location,
            propFullNameSafe
        ].concat(args));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
$6bef38e8094f8c50$exports = $6bef38e8094f8c50$exports["default"];


var $572d173155431dc3$var$_createChainableTypeChecker2 = $572d173155431dc3$var$_interopRequireDefault($6bef38e8094f8c50$exports);
function $572d173155431dc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $572d173155431dc3$var$all() {
    for(var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++)validators[_key] = arguments[_key];
    function allPropTypes() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var error = null;
        validators.forEach(function(validator) {
            if (error != null) return;
            var result = validator.apply(undefined, args);
            if (result != null) error = result;
        });
        return error;
    }
    return (0, $572d173155431dc3$var$_createChainableTypeChecker2.default)(allPropTypes);
}
$572d173155431dc3$exports = $572d173155431dc3$exports["default"];



var $acw62 = parcelRequire("acw62");

var $01b4fe2088fac58b$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $01b4fe2088fac58b$export$2e2bcd8739ae039(element, selector) {
    return $01b4fe2088fac58b$var$toArray(element.querySelectorAll(selector));
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $9b4016ced1cecfef$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $acw62.useReducer)((state)=>!state, false);
    return dispatch;
}




var $acw62 = parcelRequire("acw62");
const $45c958b882f3532f$var$NavContext = /*#__PURE__*/ $acw62.createContext(null);
$45c958b882f3532f$var$NavContext.displayName = "NavContext";
var $45c958b882f3532f$export$2e2bcd8739ae039 = $45c958b882f3532f$var$NavContext;



var $acw62 = parcelRequire("acw62");
const $9c8dd72e635c1db4$var$SelectableContext = /*#__PURE__*/ $acw62.createContext(null);
const $9c8dd72e635c1db4$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $9c8dd72e635c1db4$export$2e2bcd8739ae039 = $9c8dd72e635c1db4$var$SelectableContext;



var $acw62 = parcelRequire("acw62");
const $b72131d84963b3ba$var$TabContext = /*#__PURE__*/ $acw62.createContext(null);
var $b72131d84963b3ba$export$2e2bcd8739ae039 = $b72131d84963b3ba$var$TabContext;


const $1123d3fd1f42218c$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $1123d3fd1f42218c$export$635202801f9383a0 = `rrUi`;
function $1123d3fd1f42218c$export$5cc3b7b83e34ade7(property) {
    return `${$1123d3fd1f42218c$export$fd7bcb7e9bef4e8a}${property}`;
}
function $1123d3fd1f42218c$export$7776c0a7cd2eb3e0(property) {
    return `${$1123d3fd1f42218c$export$635202801f9383a0}${property}`;
}



var $acw62 = parcelRequire("acw62");







const $31dc5e0f2f162e1f$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $31dc5e0f2f162e1f$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === "tablist") props.role = "tab";
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("event-key")] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props["aria-controls"] = contextControlledId;
    }
    if (props.role === "tab") {
        props["aria-selected"] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props["aria-disabled"] = true;
        }
    }
    props.onClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $31dc5e0f2f162e1f$var$NavItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $31dc5e0f2f162e1f$var$_objectWithoutPropertiesLoose(_ref, $31dc5e0f2f162e1f$var$_excluded);
    const [props, meta] = $31dc5e0f2f162e1f$export$d7a68693710982a(Object.assign({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("active")] = meta.isActive;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$31dc5e0f2f162e1f$var$NavItem.displayName = "NavItem";
var $31dc5e0f2f162e1f$export$2e2bcd8739ae039 = $31dc5e0f2f162e1f$var$NavItem;



const $bdf8c5d517fb941c$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $bdf8c5d517fb941c$var$noop = ()=>{};
const $bdf8c5d517fb941c$var$EVENT_KEY_ATTR = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("event-key");
const $bdf8c5d517fb941c$var$Nav = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $bdf8c5d517fb941c$var$_objectWithoutPropertiesLoose(_ref, $bdf8c5d517fb941c$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $9b4016ced1cecfef$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $acw62.useRef)(false);
    const parentOnSelect = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const tabContext = (0, $acw62.useContext)((0, $b72131d84963b3ba$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || "tablist";
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $acw62.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(currentListNode, `[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector("[aria-selected=true]");
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                nextActiveChild = getNextActiveTab(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $1123d3fd1f42218c$export$7776c0a7cd2eb3e0)("EventKey")] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $acw62.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$bdf8c5d517fb941c$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45c958b882f3532f$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $bdf8c5d517fb941c$var$noop,
                getControllerId: getControllerId || $bdf8c5d517fb941c$var$noop
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$bdf8c5d517fb941c$var$Nav.displayName = "Nav";
var $bdf8c5d517fb941c$export$2e2bcd8739ae039 = Object.assign($bdf8c5d517fb941c$var$Nav, {
    Item: (0, $31dc5e0f2f162e1f$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");
"use client";
// TODO: check
const $46425249d1e44fce$var$context = /*#__PURE__*/ $acw62.createContext(null);
$46425249d1e44fce$var$context.displayName = "NavbarContext";
var $46425249d1e44fce$export$2e2bcd8739ae039 = $46425249d1e44fce$var$context;




var $acw62 = parcelRequire("acw62");



"use client";
const $b38cb042d7fdd569$var$NavItem = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "nav-item");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$b38cb042d7fdd569$var$NavItem.displayName = "NavItem";
var $b38cb042d7fdd569$export$2e2bcd8739ae039 = $b38cb042d7fdd569$var$NavItem;




var $acw62 = parcelRequire("acw62");





"use client";
const $8dc05f39bc918f56$var$NavLink = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "nav-link");
    const [navItemProps, meta] = (0, $31dc5e0f2f162e1f$export$d7a68693710982a)({
        key: (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, disabled && "disabled", meta.isActive && "active")
    });
});
$8dc05f39bc918f56$var$NavLink.displayName = "NavLink";
var $8dc05f39bc918f56$export$2e2bcd8739ae039 = $8dc05f39bc918f56$var$NavLink;



"use client";
const $aa29ebe1e6d9cd49$var$Nav = /*#__PURE__*/ $acw62.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = "div", bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: "onSelect"
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, "nav");
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $acw62.useContext)((0, $5eb077b72b2eb187$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bdf8c5d517fb941c$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$aa29ebe1e6d9cd49$var$Nav.displayName = "Nav";
var $aa29ebe1e6d9cd49$export$2e2bcd8739ae039 = Object.assign($aa29ebe1e6d9cd49$var$Nav, {
    Item: (0, $b38cb042d7fdd569$export$2e2bcd8739ae039),
    Link: (0, $8dc05f39bc918f56$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");


"use client";
const $b5ed781c15448fd9$var$NavbarBrand = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-brand");
    const Component = as || (props.href ? "a" : "span");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix)
    });
});
$b5ed781c15448fd9$var$NavbarBrand.displayName = "NavbarBrand";
var $b5ed781c15448fd9$export$2e2bcd8739ae039 = $b5ed781c15448fd9$var$NavbarBrand;



var $acw62 = parcelRequire("acw62");




"use client";
const $2710431f613a38bf$var$NavbarCollapse = /*#__PURE__*/ $acw62.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-collapse");
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6225d171b822135d$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$2710431f613a38bf$var$NavbarCollapse.displayName = "NavbarCollapse";
var $2710431f613a38bf$export$2e2bcd8739ae039 = $2710431f613a38bf$var$NavbarCollapse;




var $acw62 = parcelRequire("acw62");




"use client";
const $0ecac5fdbe294867$var$NavbarToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = "Toggle navigation", // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "button", onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-toggler");
    const { onToggle: onToggle, expanded: expanded } = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === "button") props.type = "button";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, !expanded && "collapsed"),
        children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$0ecac5fdbe294867$var$NavbarToggle.displayName = "NavbarToggle";
var $0ecac5fdbe294867$export$2e2bcd8739ae039 = $0ecac5fdbe294867$var$NavbarToggle;



var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $93efd0ca86a6ce96$var$matchersByWindow = new WeakMap();
const $93efd0ca86a6ce96$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow) || new Map();
    $93efd0ca86a6ce96$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $93efd0ca86a6ce96$export$2e2bcd8739ae039(query, targetWindow = typeof window === "undefined" ? undefined : window) {
    const mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $acw62.useState)(()=>mql ? mql.matches : false);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        let mql = $93efd0ca86a6ce96$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $93efd0ca86a6ce96$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $acw62 = parcelRequire("acw62");
function $d7a77e47f418a0f8$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === "number") value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === "number") value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === "object") {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $acw62.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === "up" || direction === true) query = and(query, getMinQuery(key));
                if (direction === "down" || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ""), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $93efd0ca86a6ce96$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $d7a77e47f418a0f8$var$useBreakpoint = $d7a77e47f418a0f8$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $d7a77e47f418a0f8$export$2e2bcd8739ae039 = $d7a77e47f418a0f8$var$useBreakpoint;




var $acw62 = parcelRequire("acw62");

function $d26eb8849281a3d4$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $fcf05e248574eb57$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $acw62 = parcelRequire("acw62");







/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $01b2d58e52126803$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $254a0b83be45660e$export$1a88c12b8b979fa0 = (0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("modal-open");
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $254a0b83be45660e$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $01b2d58e52126803$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: "hidden"
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, paddingProp) || "0", 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($254a0b83be45660e$export$1a88c12b8b979fa0, "");
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($254a0b83be45660e$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $254a0b83be45660e$export$2e2bcd8739ae039 = $254a0b83be45660e$var$ModalManager;







const $0173af0e859d9b0f$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $0173af0e859d9b0f$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $0173af0e859d9b0f$var$getManager(window) {
    if (!$0173af0e859d9b0f$var$manager) $0173af0e859d9b0f$var$manager = new (0, $254a0b83be45660e$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $0173af0e859d9b0f$var$manager;
}
function $0173af0e859d9b0f$var$useModalManager(provided) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const modalManager = provided || $0173af0e859d9b0f$var$getManager(window);
    const modal = (0, $acw62.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $acw62.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $0173af0e859d9b0f$var$Modal = /*#__PURE__*/ (0, $acw62.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = "dialog", className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $0173af0e859d9b0f$var$_objectWithoutPropertiesLoose(_ref, $0173af0e859d9b0f$var$_excluded);
    const ownerWindow = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const container = (0, $1892253eb6d46162$export$2e2bcd8739ae039)(containerRef);
    const modal = $0173af0e859d9b0f$var$useModalManager(providedManager);
    const isMounted = (0, $ed7e9ace1ce49d9f$export$2e2bcd8739ae039)();
    const prevShow = (0, $97a3f3bdcb91cb9e$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $acw62.useState)(!show);
    const lastFocusRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $55986f7b0f69fd17$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "keydown", handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $5ce0a80dcc778636$export$2e2bcd8739ae039)(document, "focus", // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $acw62.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $acw62.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $63805df80cf3ca43$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $d26eb8849281a3d4$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $967999a1a8cec832$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $a36e95ee292bed8b$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $acw62.useRef)();
    const removeKeydownListenerRef = (0, $acw62.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        "aria-modal": role === "dialog" ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $acw62.cloneElement(children, {
            role: "document"
        })
    }));
    dialog = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $86d0e8a9dc3b2e91$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).createPortal(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$0173af0e859d9b0f$var$Modal.displayName = "Modal";
var $0173af0e859d9b0f$export$2e2bcd8739ae039 = Object.assign($0173af0e859d9b0f$var$Modal, {
    Manager: (0, $254a0b83be45660e$export$2e2bcd8739ae039)
});




var $acw62 = parcelRequire("acw62");



"use client";
const $ba423bd29b7fa4dc$var$OffcanvasBody = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas-body");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$ba423bd29b7fa4dc$var$OffcanvasBody.displayName = "OffcanvasBody";
var $ba423bd29b7fa4dc$export$2e2bcd8739ae039 = $ba423bd29b7fa4dc$var$OffcanvasBody;




var $acw62 = parcelRequire("acw62");





"use client";
const $48e49b3f9b1ab2a2$var$transitionStyles = {
    [(0, $0fef977f04119bf5$export$df38205c966be359)]: "show",
    [(0, $0fef977f04119bf5$export$78e9e6e3e014d60a)]: "show"
};
const $48e49b3f9b1ab2a2$var$OffcanvasToggling = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5e18c3cbbc2321dd$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $f251260f6a38a977$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: children.ref,
        children: (status, innerProps)=>/*#__PURE__*/ $acw62.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, children.props.className, (status === (0, $0fef977f04119bf5$export$df38205c966be359) || status === (0, $0fef977f04119bf5$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $48e49b3f9b1ab2a2$var$transitionStyles[status])
            })
    });
});
$48e49b3f9b1ab2a2$var$OffcanvasToggling.displayName = "OffcanvasToggling";
var $48e49b3f9b1ab2a2$export$2e2bcd8739ae039 = $48e49b3f9b1ab2a2$var$OffcanvasToggling;



var $acw62 = parcelRequire("acw62");
"use client";
const $ce35488230cbfb2e$var$ModalContext = /*#__PURE__*/ $acw62.createContext({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onHide () {}
});
var $ce35488230cbfb2e$export$2e2bcd8739ae039 = $ce35488230cbfb2e$var$ModalContext;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");




"use client";
const $7ed9ce9ab3e9405e$var$AbstractModalHeader = /*#__PURE__*/ $acw62.forwardRef(({ closeLabel: closeLabel = "Close", closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039));
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $52ed202a4f01c477$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
var $7ed9ce9ab3e9405e$export$2e2bcd8739ae039 = $7ed9ce9ab3e9405e$var$AbstractModalHeader;



"use client";
const $513c4c102e8b60c7$var$OffcanvasHeader = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = "Close", closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7ed9ce9ab3e9405e$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$513c4c102e8b60c7$var$OffcanvasHeader.displayName = "OffcanvasHeader";
var $513c4c102e8b60c7$export$2e2bcd8739ae039 = $513c4c102e8b60c7$var$OffcanvasHeader;



var $acw62 = parcelRequire("acw62");




"use client";
const $0ae39967a5cb8bc6$var$DivStyledAsH5 = (0, $31af5e1d0c3b3c37$export$2e2bcd8739ae039)("h5");
const $0ae39967a5cb8bc6$var$OffcanvasTitle = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $0ae39967a5cb8bc6$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas-title");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$0ae39967a5cb8bc6$var$OffcanvasTitle.displayName = "OffcanvasTitle";
var $0ae39967a5cb8bc6$export$2e2bcd8739ae039 = $0ae39967a5cb8bc6$var$OffcanvasTitle;




function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}




function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



const $f00adc503d5cecaf$var$Selector = {
    FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
    STICKY_CONTENT: ".sticky-top",
    NAVBAR_TOGGLER: ".navbar-toggler"
};
class $f00adc503d5cecaf$var$BootstrapModalManager extends (0, $254a0b83be45660e$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        // @ts-ignore
        element.dataset[prop] = actual;
        (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $1d31c226dae4138f$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(container, "modal-open");
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(container, "modal-open");
        const paddingProp = this.isRTL ? "paddingLeft" : "paddingRight";
        const marginProp = this.isRTL ? "marginLeft" : "marginRight";
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(container, $f00adc503d5cecaf$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $f00adc503d5cecaf$var$sharedManager;
function $f00adc503d5cecaf$export$a03641438014b436(options) {
    if (!$f00adc503d5cecaf$var$sharedManager) $f00adc503d5cecaf$var$sharedManager = new $f00adc503d5cecaf$var$BootstrapModalManager(options);
    return $f00adc503d5cecaf$var$sharedManager;
}
var $f00adc503d5cecaf$export$2e2bcd8739ae039 = $f00adc503d5cecaf$var$BootstrapModalManager;



"use client";
function $ee052f1f156c566d$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48e49b3f9b1ab2a2$export$2e2bcd8739ae039), {
        ...props
    });
}
function $ee052f1f156c566d$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $588ffbaaa8a325aa$export$2e2bcd8739ae039), {
        ...props
    });
}
const $ee052f1f156c566d$var$Offcanvas = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, "aria-labelledby": ariaLabelledby, placement: placement = "start", responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $acw62.useRef)();
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "offcanvas");
    const [showOffcanvas, setShowOffcanvas] = (0, $acw62.useState)(false);
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $d7a77e47f418a0f8$export$2e2bcd8739ae039)(responsive || "xs", "up");
    (0, $acw62.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $acw62.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $f00adc503d5cecaf$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $f00adc503d5cecaf$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = "visible";
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = "";
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $acw62.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce35488230cbfb2e$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0173af0e859d9b0f$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $ee052f1f156c566d$var$DialogTransition,
                    backdropTransition: $ee052f1f156c566d$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$ee052f1f156c566d$var$Offcanvas.displayName = "Offcanvas";
var $ee052f1f156c566d$export$2e2bcd8739ae039 = Object.assign($ee052f1f156c566d$var$Offcanvas, {
    Body: (0, $ba423bd29b7fa4dc$export$2e2bcd8739ae039),
    Header: (0, $513c4c102e8b60c7$export$2e2bcd8739ae039),
    Title: (0, $0ae39967a5cb8bc6$export$2e2bcd8739ae039)
});




"use client";
const $988fd6bed406a062$var$NavbarOffcanvas = /*#__PURE__*/ $acw62.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const handleHide = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee052f1f156c566d$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$988fd6bed406a062$var$NavbarOffcanvas.displayName = "NavbarOffcanvas";
var $988fd6bed406a062$export$2e2bcd8739ae039 = $988fd6bed406a062$var$NavbarOffcanvas;





var $acw62 = parcelRequire("acw62");



"use client";
const $23dd3f990e4b9410$var$NavbarText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "navbar-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$23dd3f990e4b9410$var$NavbarText.displayName = "NavbarText";
var $23dd3f990e4b9410$export$2e2bcd8739ae039 = $23dd3f990e4b9410$var$NavbarText;



"use client";
const $9a5709cde14ebc6a$var$Navbar = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = "light", bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "nav", expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(props, {
        expanded: "onToggle"
    });
    const bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(initialBsPrefix, "navbar");
    const handleCollapse = (0, $acw62.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== "nav") controlledProps.role = "navigation";
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === "string") expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $acw62.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $46425249d1e44fce$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$9a5709cde14ebc6a$var$Navbar.displayName = "Navbar";
var $9a5709cde14ebc6a$export$2e2bcd8739ae039 = Object.assign($9a5709cde14ebc6a$var$Navbar, {
    Brand: (0, $b5ed781c15448fd9$export$2e2bcd8739ae039),
    Collapse: (0, $2710431f613a38bf$export$2e2bcd8739ae039),
    Offcanvas: (0, $988fd6bed406a062$export$2e2bcd8739ae039),
    Text: (0, $23dd3f990e4b9410$export$2e2bcd8739ae039),
    Toggle: (0, $0ecac5fdbe294867$export$2e2bcd8739ae039)
});



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7060bb66c8fa08f7$var$_toPropertyKey(arg) {
    var key = $7060bb66c8fa08f7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7060bb66c8fa08f7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7060bb66c8fa08f7$export$26cbf8c37e721e67(key) {
    return "default" + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7060bb66c8fa08f7$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $acw62.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $acw62.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $acw62.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $7060bb66c8fa08f7$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $7060bb66c8fa08f7$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $7060bb66c8fa08f7$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($7060bb66c8fa08f7$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $7060bb66c8fa08f7$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}







var $acw62 = parcelRequire("acw62");
const $845df35e9a3b7033$var$DropdownContext = /*#__PURE__*/ $acw62.createContext(null);
var $845df35e9a3b7033$export$2e2bcd8739ae039 = $845df35e9a3b7033$var$DropdownContext;



var $acw62 = parcelRequire("acw62");






const $7b01c7ecb51f8572$var$_excluded = [
    "children",
    "usePopper"
];
function $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $7b01c7ecb51f8572$var$noop = ()=>{};
function $7b01c7ecb51f8572$export$133c4d08f3775d64(options = {}) {
    const context = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $6ee4f2c1aea3527b$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $acw62.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $3e96790ca7bcc44e$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $d29a438d14321507$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || "bottom-start",
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $7b01c7ecb51f8572$var$noop,
        "aria-labelledby": toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $bfacdc492f374f5e$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $7b01c7ecb51f8572$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $7b01c7ecb51f8572$var$_objectWithoutPropertiesLoose(_ref, $7b01c7ecb51f8572$var$_excluded);
    const [props, meta] = $7b01c7ecb51f8572$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children(props, meta)
    });
}
$7b01c7ecb51f8572$var$DropdownMenu.displayName = "DropdownMenu";
var /** @component */ $7b01c7ecb51f8572$export$2e2bcd8739ae039 = $7b01c7ecb51f8572$var$DropdownMenu;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $02e50cfe922d2ca9$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute("role")) == null ? void 0 : _el$getAttribute.toLowerCase()) === "menu";
};
const $02e50cfe922d2ca9$var$noop = ()=>{};
function $02e50cfe922d2ca9$export$96df6c7c5036b9a2() {
    const id = (0, $8afd3bdc2bd65163$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $02e50cfe922d2ca9$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $acw62.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $02e50cfe922d2ca9$var$noop,
        onClick: handleClick,
        "aria-expanded": !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $02e50cfe922d2ca9$export$386b1213cf9779d8(menuElement)) props["aria-haspopup"] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $02e50cfe922d2ca9$var$DropdownToggle({ children: children }) {
    const [props, meta] = $02e50cfe922d2ca9$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: children(props, meta)
    });
}
$02e50cfe922d2ca9$var$DropdownToggle.displayName = "DropdownToggle";
var /** @component */ $02e50cfe922d2ca9$export$2e2bcd8739ae039 = $02e50cfe922d2ca9$var$DropdownToggle;



var $acw62 = parcelRequire("acw62");






const $e30823bf64a2218d$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e30823bf64a2218d$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const navContext = (0, $acw62.useContext)((0, $45c958b882f3532f$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $9c8dd72e635c1db4$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            "aria-disabled": disabled || undefined,
            "aria-selected": isActive,
            [(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("dropdown-item")]: ""
        },
        {
            isActive: isActive
        }
    ];
}
const $e30823bf64a2218d$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $0522fa2e4977c358$export$2e2bcd8739ae039) } = _ref, props = $e30823bf64a2218d$var$_objectWithoutPropertiesLoose(_ref, $e30823bf64a2218d$var$_excluded);
    const [dropdownItemProps] = $e30823bf64a2218d$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$e30823bf64a2218d$var$DropdownItem.displayName = "DropdownItem";
var $e30823bf64a2218d$export$2e2bcd8739ae039 = $e30823bf64a2218d$var$DropdownItem;






function $583bd49bf9b8480b$var$useRefWithUpdate() {
    const forceUpdate = (0, $9b4016ced1cecfef$export$2e2bcd8739ae039)();
    const ref = (0, $acw62.useRef)(null);
    const attachRef = (0, $acw62.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $583bd49bf9b8480b$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $1123d3fd1f42218c$export$5cc3b7b83e34ade7)("dropdown-item")}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = "bottom-start", children: children }) {
    const window = (0, $0e151397e562aebc$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $7060bb66c8fa08f7$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $583bd49bf9b8480b$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $97a3f3bdcb91cb9e$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $acw62.useRef)(null);
    const focusInDropdown = (0, $acw62.useRef)(false);
    const onSelectCtx = (0, $acw62.useContext)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039));
    const toggle = (0, $acw62.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, "select");
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $acw62.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $02e50cfe922d2ca9$export$386b1213cf9779d8)(menuRef.current) ? "keyboard" : false;
        if (focusType === false || focusType === "keyboard" && !/^key.+$/.test(type)) return;
        const first = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $acw62.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $acw62.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $01b4fe2088fac58b$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $eaba49a725115ef9$export$2e2bcd8739ae039)((0, $acw62.useCallback)(()=>window.document, [
        window
    ]), "keydown", (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === " " || key !== "Escape" && fromMenu || key === "Escape" && target.type === "search")) return;
        if (!fromMenu && !fromToggle) return;
        if (key === "Tab" && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case "ArrowUp":
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case "ArrowDown":
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case "Tab":
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $28419dce7921d430$export$2e2bcd8739ae039)(target.ownerDocument, "keyup", (e)=>{
                    var _menuRef$current2;
                    if (e.key === "Tab" && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case "Escape":
                if (key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c8dd72e635c1db4$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $845df35e9a3b7033$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$583bd49bf9b8480b$var$Dropdown.displayName = "Dropdown";
$583bd49bf9b8480b$var$Dropdown.Menu = (0, $7b01c7ecb51f8572$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Toggle = (0, $02e50cfe922d2ca9$export$2e2bcd8739ae039);
$583bd49bf9b8480b$var$Dropdown.Item = (0, $e30823bf64a2218d$export$2e2bcd8739ae039);
var $583bd49bf9b8480b$export$2e2bcd8739ae039 = $583bd49bf9b8480b$var$Dropdown;





var $acw62 = parcelRequire("acw62");
"use client";
const $dca786c6a99c4e45$var$DropdownContext = /*#__PURE__*/ $acw62.createContext({});
$dca786c6a99c4e45$var$DropdownContext.displayName = "DropdownContext";
var $dca786c6a99c4e45$export$2e2bcd8739ae039 = $dca786c6a99c4e45$var$DropdownContext;



var $acw62 = parcelRequire("acw62");



"use client";
const $5a4fb33eeda93525$var$DropdownDivider = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "hr", role: role = "separator", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-divider");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$5a4fb33eeda93525$var$DropdownDivider.displayName = "DropdownDivider";
var $5a4fb33eeda93525$export$2e2bcd8739ae039 = $5a4fb33eeda93525$var$DropdownDivider;



var $acw62 = parcelRequire("acw62");



"use client";
const $ec852ac21aa53987$var$DropdownHeader = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "div", role: role = "heading", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-header");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$ec852ac21aa53987$var$DropdownHeader.displayName = "DropdownHeader";
var $ec852ac21aa53987$export$2e2bcd8739ae039 = $ec852ac21aa53987$var$DropdownHeader;




var $acw62 = parcelRequire("acw62");




"use client";
const $c3418d2c4a03af95$var$DropdownItem = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $a02c1087963bbb34$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-item");
    const [dropdownItemProps, meta] = (0, $e30823bf64a2218d$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, meta.isActive && "active", disabled && "disabled")
    });
});
$c3418d2c4a03af95$var$DropdownItem.displayName = "DropdownItem";
var $c3418d2c4a03af95$export$2e2bcd8739ae039 = $c3418d2c4a03af95$var$DropdownItem;



var $acw62 = parcelRequire("acw62");



"use client";
const $29dccf165986723f$var$DropdownItemText = /*#__PURE__*/ $acw62.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = "span", ...props }, ref)=>{
    bsPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-item-text");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, bsPrefix),
        ...props
    });
});
$29dccf165986723f$var$DropdownItemText.displayName = "DropdownItemText";
var $29dccf165986723f$export$2e2bcd8739ae039 = $29dccf165986723f$var$DropdownItemText;




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
"use client";
const $dda4a7e32e3b00d2$var$context = /*#__PURE__*/ $acw62.createContext(null);
$dda4a7e32e3b00d2$var$context.displayName = "InputGroupContext";
var $dda4a7e32e3b00d2$export$2e2bcd8739ae039 = $dda4a7e32e3b00d2$var$context;





parcelRequire("acw62");

function $66831c738b74ab47$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? "top-end" : "top-start";
    const topEnd = isRTL ? "top-start" : "top-end";
    const bottomStart = isRTL ? "bottom-end" : "bottom-start";
    const bottomEnd = isRTL ? "bottom-start" : "bottom-end";
    const leftStart = isRTL ? "right-start" : "left-start";
    const leftEnd = isRTL ? "right-end" : "left-end";
    const rightStart = isRTL ? "left-start" : "right-start";
    const rightEnd = isRTL ? "left-end" : "right-end";
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === "up") placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === "end") placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === "start") placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === "down-centered") placement = "bottom";
    else if (dropDirection === "up-centered") placement = "top";
    return placement;
}
const $5d9daf1899b89eeb$var$DropdownMenu = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = "div", popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $acw62.useContext)((0, $46425249d1e44fce$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-menu");
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $acw62.useContext)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === "object") {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === "start";
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === "end") alignEnd = true;
    }
    const placement = $5d9daf1899b89eeb$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $7b01c7ecb51f8572$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)((0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, "DropdownMenu"), menuProps.ref);
    (0, $63565b817d447aae$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== "string") {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props["x-placement"] = popper.placement;
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            "data-bs-popper": "static"
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, show && "show", alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$5d9daf1899b89eeb$var$DropdownMenu.displayName = "DropdownMenu";
var $5d9daf1899b89eeb$export$2e2bcd8739ae039 = $5d9daf1899b89eeb$var$DropdownMenu;







var $acw62 = parcelRequire("acw62");




"use client";
const $6b03788ed4f0962b$var$DropdownToggle = /*#__PURE__*/ $acw62.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $4ed343d4b409b2f2$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown-toggle");
    const dropdownContext = (0, $acw62.useContext)((0, $845df35e9a3b7033$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $02e50cfe922d2ca9$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $9d58c39545e3cedc$export$2e2bcd8739ae039)(toggleProps.ref, (0, $66831c738b74ab47$export$2e2bcd8739ae039)(ref, "DropdownToggle"));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && "show"),
        ...toggleProps,
        ...props
    });
});
$6b03788ed4f0962b$var$DropdownToggle.displayName = "DropdownToggle";
var $6b03788ed4f0962b$export$2e2bcd8739ae039 = $6b03788ed4f0962b$var$DropdownToggle;






"use client";
const $c111d4db45b07888$var$Dropdown = /*#__PURE__*/ $acw62.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = "down", show: show, className: className, align: align = "start", onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = "div", navbar: _4, autoClose: autoClose = true, ...props } = (0, $5809a50e160ad91a$export$2e2bcd8739ae039)(pProps, {
        show: "onToggle"
    });
    const isInputGroup = (0, $acw62.useContext)((0, $dda4a7e32e3b00d2$export$2e2bcd8739ae039));
    const prefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(bsPrefix, "dropdown");
    const isRTL = (0, $626bd95fa485b758$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === "click";
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === "inside") return source !== "rootClose";
        // autoClose=outside doesn't permit close on select
        if (autoClose === "outside") return source !== "select";
        return true;
    };
    const handleToggle = (0, $9cc831e7fe1726fc$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains("dropdown-toggle");
        if (isToggleButton && meta.source === "mousedown") return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== "keydown" || meta.originalEvent.key === "Escape")) meta.source = "rootClose";
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === "end";
    const placement = (0, $5d9daf1899b89eeb$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $acw62.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        "down-centered": `${prefix}-center`,
        up: "dropup",
        "up-centered": "dropup-center dropup",
        end: "dropend",
        start: "dropstart"
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dca786c6a99c4e45$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $583bd49bf9b8480b$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, show && "show", directionClasses[drop])
            })
        })
    });
});
$c111d4db45b07888$var$Dropdown.displayName = "Dropdown";
var $c111d4db45b07888$export$2e2bcd8739ae039 = Object.assign($c111d4db45b07888$var$Dropdown, {
    Toggle: (0, $6b03788ed4f0962b$export$2e2bcd8739ae039),
    Menu: (0, $5d9daf1899b89eeb$export$2e2bcd8739ae039),
    Item: (0, $c3418d2c4a03af95$export$2e2bcd8739ae039),
    ItemText: (0, $29dccf165986723f$export$2e2bcd8739ae039),
    Divider: (0, $5a4fb33eeda93525$export$2e2bcd8739ae039),
    Header: (0, $ec852ac21aa53987$export$2e2bcd8739ae039)
});




"use client";
const $f1177f84a674945f$var$NavDropdown = /*#__PURE__*/ $acw62.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $626bd95fa485b758$export$7f387860ebffb32c)(undefined, "nav-item");
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c111d4db45b07888$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($60313e3b9e75c852$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $8dc05f39bc918f56$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c111d4db45b07888$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$f1177f84a674945f$var$NavDropdown.displayName = "NavDropdown";
var $f1177f84a674945f$export$2e2bcd8739ae039 = Object.assign($f1177f84a674945f$var$NavDropdown, {
    Item: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Item,
    ItemText: (0, $c111d4db45b07888$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Divider,
    Header: (0, $c111d4db45b07888$export$2e2bcd8739ae039).Header
});




var $acw62 = parcelRequire("acw62");

var $3f749e4f8a631ef9$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $3f749e4f8a631ef9$var$_extends() {
    return $3f749e4f8a631ef9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3f749e4f8a631ef9$var$_extends.apply(null, arguments);
}
function $3f749e4f8a631ef9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3f749e4f8a631ef9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3f749e4f8a631ef9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3f749e4f8a631ef9$var$CaretDownFill = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? "1em" : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, rest = $3f749e4f8a631ef9$var$_objectWithoutProperties(_ref, $3f749e4f8a631ef9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $3f749e4f8a631ef9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            "bi",
            "bi-caret-down-fill",
            className
        ].filter(Boolean).join(" ")
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
    }));
});
$3f749e4f8a631ef9$var$CaretDownFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
};
var $3f749e4f8a631ef9$export$2e2bcd8739ae039 = $3f749e4f8a631ef9$var$CaretDownFill;



parcelRequire("acw62");


const $cd689464ac71cd9a$export$79d13b60110f33be = ({ value: value, onChange: onChange })=>{
    const handleSubmit = (event)=>{
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("form", {
        className: "form__searchbar",
        onSubmit: handleSubmit,
        role: "search",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
            type: "text",
            placeholder: "Search here",
            className: "form-control__searchbar",
            value: value,
            onChange: (event)=>onChange(event.target.value),
            "aria-label": "Search movies"
        })
    });
};
$cd689464ac71cd9a$export$79d13b60110f33be.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
};




const $cdccd31991b06637$export$214ae410b202e65a = ({ user: user, onLoggedOut: onLoggedOut, searchValue: searchValue, onSearchChange: onSearchChange })=>{
    const displayName = user?.username || user?.Username || user?.email || "";
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039), {
        expand: "md",
        className: "navbar",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
            fluid: true,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Brand, {
                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                            to: "/",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b6e10067a0e97ca4$exports))),
                                alt: "bestflix-logo",
                                className: "nav-logo",
                                width: "150",
                                height: "auto"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Toggle, {
                            "aria-controls": "navbar-nav"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a5709cde14ebc6a$export$2e2bcd8739ae039).Collapse, {
                    id: "navbar-nav",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "navbar-content d-flex flex-column flex-md-row w-100",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                                className: "nav-section nav-section--left",
                                children: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: "/login",
                                            children: "Login"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: "/signup",
                                            children: "Signup"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: "/",
                                            children: "Movies"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: "/",
                                            children: "Similar"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039).Link, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: "/",
                                            children: "SurpriseMe"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "nav-section nav-section--center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd689464ac71cd9a$export$79d13b60110f33be), {
                                    value: searchValue,
                                    onChange: onSearchChange
                                })
                            }),
                            user && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aa29ebe1e6d9cd49$export$2e2bcd8739ae039), {
                                className: "nav-section nav-section--right",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f1177f84a674945f$export$2e2bcd8739ae039), {
                                    title: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "user-avatar-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                className: "user-avatar",
                                                children: displayName ? displayName.charAt(0).toUpperCase() : ""
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3f749e4f8a631ef9$export$2e2bcd8739ae039), {
                                                size: 12,
                                                className: "dropdown-caret"
                                            })
                                        ]
                                    }),
                                    id: "user-dropdown",
                                    align: "end",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: `/users/${user.id}`,
                                            children: "Profile"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            as: (0, $040dbb9c344a508d$export$a6c7ac8248d6e38a),
                                            to: `/users/favorites`,
                                            children: "Favorites"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Divider, {}),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f1177f84a674945f$export$2e2bcd8739ae039).Item, {
                                            onClick: onLoggedOut,
                                            children: "Logout"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};



// src/services/movieService.js
/**
 * Fetch movies from the API.
 * @param {string} token - The user's auth token.
 * @returns {Promise<{movies: Array}>}
 * @throws {Error} If fetching movies fails
 */ const $71c09fa806b5b3fd$var$TMDB_API_KEY = "1585c9293160c7571242e67ce226384d";
const $71c09fa806b5b3fd$var$TMDB_BASE_URL = "https://api.themoviedb.org/3";
async function $71c09fa806b5b3fd$export$88181abcadffafee() {
    const response = await fetch(`${$71c09fa806b5b3fd$var$TMDB_BASE_URL}/movie/popular?api_key=${$71c09fa806b5b3fd$var$TMDB_API_KEY}&language=en-US&page=1`);
    if (!response.ok) throw new Error("Failed to fetch movies");
    const data = await response.json();
    return data.results;
}
async function $71c09fa806b5b3fd$export$166939fd352eb839() {
    const response = await fetch(`${$71c09fa806b5b3fd$var$TMDB_BASE_URL}/genre/movie/list?api_key=${$71c09fa806b5b3fd$var$TMDB_API_KEY}&language=en-US`);
    if (!response.ok) throw new Error("Failed to fetch movie genres");
    const data = await response.json();
    return data.genres;
}


const $f34c5fce3312cb42$export$b7cba6db0f594e39 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("movies/fetchMovies", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const movies = await (0, $71c09fa806b5b3fd$export$88181abcadffafee)(); // <- service call
        return movies;
    } catch (err) {
        console.error("\u274C Thunk error:", err.message);
        return rejectWithValue(err.message);
    }
});
const $f34c5fce3312cb42$var$moviesSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "movies",
    initialState: {
        movies: [],
        status: "idle",
        error: null
    },
    reducers: {
    },
    extraReducers: (builder)=>{
        builder.addCase($f34c5fce3312cb42$export$b7cba6db0f594e39.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($f34c5fce3312cb42$export$b7cba6db0f594e39.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.movies = action.payload;
        }).addCase($f34c5fce3312cb42$export$b7cba6db0f594e39.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        });
    }
});
var $f34c5fce3312cb42$export$2e2bcd8739ae039 = $f34c5fce3312cb42$var$moviesSlice.reducer;




const $735c7bbc43965e5c$export$8bb32e571054c769 = (0, $d91034f47eb948f2$export$6abd22dc03e5063f)("genres/fetchGenres", async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const genres = await (0, $71c09fa806b5b3fd$export$166939fd352eb839)(); // <- service call
        return genres;
    } catch (err) {
        console.error("\u274C Thunk error:", err.message);
        return rejectWithValue(err.message);
    }
});
const $735c7bbc43965e5c$var$genreSlice = (0, $d91034f47eb948f2$export$4d8d9bd83c24ae8b)({
    name: "genres",
    initialState: {
        genres: [],
        status: "idle",
        error: null
    },
    extraReducers: (builder)=>{
        builder.addCase($735c7bbc43965e5c$export$8bb32e571054c769.pending, (state)=>{
            state.status = "loading";
            state.error = null;
        }).addCase($735c7bbc43965e5c$export$8bb32e571054c769.fulfilled, (state, action)=>{
            state.status = "succeeded";
            state.genres = action.payload;
        }).addCase($735c7bbc43965e5c$export$8bb32e571054c769.rejected, (state, action)=>{
            state.status = "failed";
            state.error = action.payload;
        });
    }
});
var $735c7bbc43965e5c$export$2e2bcd8739ae039 = $735c7bbc43965e5c$var$genreSlice.reducer;


const $53aa19e059d1ce0f$export$fa32cd27347e212e = ()=>{
    const dispatch = (0, $55388fc2f116d4d7$export$8ad76b76a4c905f8)();
    const { user: user } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.user);
    const [localUser, setUser] = (0, $acw62.useState)(user);
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)("");
    const { movies: movies } = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.movies);
    const genres = (0, $55388fc2f116d4d7$export$2105062e25df4afe)((state)=>state.genres?.genres) || [];
    (0, $acw62.useEffect)(()=>{
        dispatch((0, $f34c5fce3312cb42$export$b7cba6db0f594e39)());
        dispatch((0, $735c7bbc43965e5c$export$8bb32e571054c769)());
    }, [
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        setUser(user);
    }, [
        user
    ]);
    const handleLoggedOut = ()=>{
        dispatch((0, $70709e160bcc9047$export$a0973bcfe11b05c9)());
        localStorage.clear();
    };
    const normalizedQuery = searchQuery.trim().toLowerCase();
    const visibleMovies = normalizedQuery ? movies.filter((movie)=>{
        const title = movie.title?.toLowerCase() || "";
        const overview = movie.overview?.toLowerCase() || "";
        return title.includes(normalizedQuery) || overview.includes(normalizedQuery);
    }) : movies;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            user && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cdccd31991b06637$export$214ae410b202e65a), {
                user: user,
                onLoggedOut: handleLoggedOut,
                searchValue: searchQuery,
                onSearchChange: setSearchQuery
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                    className: "justify-content-md-center",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/login",
                                element: !user?.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e82b918e273f1954$export$1582048ca8384970), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/signup",
                                element: !user?.email ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c219fcfdec4acb71$export$25f3896ea1e09820), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/"
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/movies/:movieId",
                                element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $078b54a47d6056e3$export$78d497080ea8f89a), {
                                    movies: movies,
                                    genres: genres
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/users/:id",
                                element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $945b6b605f7d5172$export$b378b4d12a0dcbde), {
                                    userId: user.id,
                                    onLoggedOut: handleLoggedOut,
                                    setUser: setUser
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: !user ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$444b3ab0cb9aec40), {
                                    to: "/login",
                                    replace: true
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c770a015764ac03c$export$2e2bcd8739ae039), {
                                    className: "justify-content-md-center",
                                    children: visibleMovies.map((movie)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a906738aa440808$export$2e2bcd8739ae039), {
                                            className: "mb-4",
                                            xs: 12,
                                            sm: 6,
                                            md: 4,
                                            lg: 3,
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd664d6ef1f52408$export$9bd698419030e459), {
                                                movie: movie,
                                                genres: genres || []
                                            })
                                        }, movie.id))
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};









var $dc4a47ea750d5f98$export$711117ad6ad27992 = "persist:";
var $dc4a47ea750d5f98$export$2aaee4793dd13a52 = "persist/FLUSH";
var $dc4a47ea750d5f98$export$1647ef958242c4e2 = "persist/REHYDRATE";
var $dc4a47ea750d5f98$export$dd1033c27a16bbd3 = "persist/PAUSE";
var $dc4a47ea750d5f98$export$913fe0e161ed92a2 = "persist/PERSIST";
var $dc4a47ea750d5f98$export$5514fc3b4067675f = "persist/PURGE";
var $dc4a47ea750d5f98$export$51e82cdd7353a0e1 = "persist/REGISTER";
var $dc4a47ea750d5f98$export$363ebe89e6e7aeef = -1;


function $2df6cf986f188332$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $2df6cf986f188332$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2df6cf986f188332$var$_typeof(obj);
}
function $2df6cf986f188332$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2df6cf986f188332$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2df6cf986f188332$var$ownKeys(source, true).forEach(function(key) {
            $2df6cf986f188332$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2df6cf986f188332$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2df6cf986f188332$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df6cf986f188332$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $2df6cf986f188332$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $2df6cf986f188332$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
         // otherwise hard set the new value
        newState[key] = inboundState[key];
    });
    return newState;
}



function $a17e9ce2c74bd9e8$export$2e2bcd8739ae039(config) {
    // defaults
    var blacklist = config.blacklist || null;
    var whitelist = config.whitelist || null;
    var transforms = config.transforms || [];
    var throttle = config.throttle || 0;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var serialize;
    if (config.serialize === false) serialize = function serialize(x) {
        return x;
    };
    else if (typeof config.serialize === "function") serialize = config.serialize;
    else serialize = $a17e9ce2c74bd9e8$var$defaultSerialize;
    var writeFailHandler = config.writeFailHandler || null; // initialize stateful values
    var lastState = {};
    var stagedState = {};
    var keysToProcess = [];
    var timeIterator = null;
    var writePromise = null;
    var update = function update(state) {
        // add any changed keys to the queue
        Object.keys(state).forEach(function(key) {
            if (!passWhitelistBlacklist(key)) return; // is keyspace ignored? noop
            if (lastState[key] === state[key]) return; // value unchanged? noop
            if (keysToProcess.indexOf(key) !== -1) return; // is key already queued? noop
            keysToProcess.push(key); // add key to queue
        }); //if any key is missing in the new state which was present in the lastState,
        //add it for processing too
        Object.keys(lastState).forEach(function(key) {
            if (state[key] === undefined && passWhitelistBlacklist(key) && keysToProcess.indexOf(key) === -1 && lastState[key] !== undefined) keysToProcess.push(key);
        }); // start the time iterator if not running (read: throttle)
        if (timeIterator === null) timeIterator = setInterval(processNextKey, throttle);
        lastState = state;
    };
    function processNextKey() {
        if (keysToProcess.length === 0) {
            if (timeIterator) clearInterval(timeIterator);
            timeIterator = null;
            return;
        }
        var key = keysToProcess.shift();
        var endState = transforms.reduce(function(subState, transformer) {
            return transformer.in(subState, key, lastState);
        }, lastState[key]);
        if (endState !== undefined) try {
            stagedState[key] = serialize(endState);
        } catch (err) {
            console.error("redux-persist/createPersistoid: error serializing state", err);
        }
        else //if the endState is undefined, no need to persist the existing serialized content
        delete stagedState[key];
        if (keysToProcess.length === 0) writeStagedState();
    }
    function writeStagedState() {
        // cleanup any removed keys just before write.
        Object.keys(stagedState).forEach(function(key) {
            if (lastState[key] === undefined) delete stagedState[key];
        });
        writePromise = storage.setItem(storageKey, serialize(stagedState)).catch(onWriteFail);
    }
    function passWhitelistBlacklist(key) {
        if (whitelist && whitelist.indexOf(key) === -1 && key !== "_persist") return false;
        if (blacklist && blacklist.indexOf(key) !== -1) return false;
        return true;
    }
    function onWriteFail(err) {
        // @TODO add fail handlers (typically storage full)
        if (writeFailHandler) writeFailHandler(err);
    }
    var flush = function flush() {
        while(keysToProcess.length !== 0)processNextKey();
        return writePromise || Promise.resolve();
    }; // return `persistoid`
    return {
        update: update,
        flush: flush
    };
} // @NOTE in the future this may be exposed via config
function $a17e9ce2c74bd9e8$var$defaultSerialize(data) {
    return JSON.stringify(data);
}



function $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039(config) {
    var transforms = config.transforms || [];
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    var storage = config.storage;
    var debug = config.debug;
    var deserialize;
    if (config.deserialize === false) deserialize = function deserialize(x) {
        return x;
    };
    else if (typeof config.deserialize === "function") deserialize = config.deserialize;
    else deserialize = $0a2c0a3a61a7a1b9$var$defaultDeserialize;
    return storage.getItem(storageKey).then(function(serialized) {
        if (!serialized) return undefined;
        else try {
            var state = {};
            var rawState = deserialize(serialized);
            Object.keys(rawState).forEach(function(key) {
                state[key] = transforms.reduceRight(function(subState, transformer) {
                    return transformer.out(subState, key, rawState);
                }, deserialize(rawState[key]));
            });
            return state;
        } catch (err) {
            throw err;
        }
    });
}
function $0a2c0a3a61a7a1b9$var$defaultDeserialize(serial) {
    return JSON.parse(serial);
}



function $4db55e14b5a1f785$export$2e2bcd8739ae039(config) {
    var storage = config.storage;
    var storageKey = "".concat(config.keyPrefix !== undefined ? config.keyPrefix : (0, $dc4a47ea750d5f98$export$711117ad6ad27992)).concat(config.key);
    return storage.removeItem(storageKey, $4db55e14b5a1f785$var$warnIfRemoveError);
}
function $4db55e14b5a1f785$var$warnIfRemoveError(err) {}


function $73e435e2fc216b6c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $73e435e2fc216b6c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $73e435e2fc216b6c$var$ownKeys(source, true).forEach(function(key) {
            $73e435e2fc216b6c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $73e435e2fc216b6c$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $73e435e2fc216b6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $73e435e2fc216b6c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $73e435e2fc216b6c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $73e435e2fc216b6c$var$DEFAULT_TIMEOUT = 5000;
function $73e435e2fc216b6c$export$2e2bcd8739ae039(config, baseReducer) {
    var version = config.version !== undefined ? config.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
    var debug = config.debug || false;
    var stateReconciler = config.stateReconciler === undefined ? (0, $2df6cf986f188332$export$2e2bcd8739ae039) : config.stateReconciler;
    var getStoredState = config.getStoredState || (0, $0a2c0a3a61a7a1b9$export$2e2bcd8739ae039);
    var timeout = config.timeout !== undefined ? config.timeout : $73e435e2fc216b6c$var$DEFAULT_TIMEOUT;
    var _persistoid = null;
    var _purge = false;
    var _paused = true;
    var conditionalUpdate = function conditionalUpdate(state) {
        // update the persistoid only if we are rehydrated and not paused
        state._persist.rehydrated && _persistoid && !_paused && _persistoid.update(state);
        return state;
    };
    return function(state, action) {
        var _ref = state || {}, _persist = _ref._persist, rest = $73e435e2fc216b6c$var$_objectWithoutProperties(_ref, [
            "_persist"
        ]); // $FlowIgnore need to update State type
        var restState = rest;
        if (action.type === (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2)) {
            var _sealed = false;
            var _rehydrate = function _rehydrate(payload, err) {
                if (!_sealed) {
                    action.rehydrate(config.key, payload, err);
                    _sealed = true;
                }
            };
            timeout && setTimeout(function() {
                !_sealed && _rehydrate(undefined, new Error('redux-persist: persist timed out for persist key "'.concat(config.key, '"')));
            }, timeout); // @NOTE PERSIST resumes if paused.
            _paused = false; // @NOTE only ever create persistoid once, ensure we call it at least once, even if _persist has already been set
            if (!_persistoid) _persistoid = (0, $a17e9ce2c74bd9e8$export$2e2bcd8739ae039)(config); // @NOTE PERSIST can be called multiple times, noop after the first
            if (_persist) // We still need to call the base reducer because there might be nested
            // uses of persistReducer which need to be aware of the PERSIST action
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
            if (typeof action.rehydrate !== "function" || typeof action.register !== "function") throw new Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
            action.register(config.key);
            getStoredState(config).then(function(restoredState) {
                var migrate = config.migrate || function(s, v) {
                    return Promise.resolve(s);
                };
                migrate(restoredState, version).then(function(migratedState) {
                    _rehydrate(migratedState);
                }, function(migrateErr) {
                    _rehydrate(undefined, migrateErr);
                });
            }, function(err) {
                _rehydrate(undefined, err);
            });
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: {
                    version: version,
                    rehydrated: false
                }
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$5514fc3b4067675f)) {
            _purge = true;
            action.result((0, $4db55e14b5a1f785$export$2e2bcd8739ae039)(config));
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52)) {
            action.result(_persistoid && _persistoid.flush());
            return $73e435e2fc216b6c$var$_objectSpread({}, baseReducer(restState, action), {
                _persist: _persist
            });
        } else if (action.type === (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)) _paused = true;
        else if (action.type === (0, $dc4a47ea750d5f98$export$1647ef958242c4e2)) {
            // noop on restState if purging
            if (_purge) return $73e435e2fc216b6c$var$_objectSpread({}, restState, {
                _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                    rehydrated: true
                }) // @NOTE if key does not match, will continue to default else below
            });
            if (action.key === config.key) {
                var reducedState = baseReducer(restState, action);
                var inboundState = action.payload; // only reconcile state if stateReconciler and inboundState are both defined
                var reconciledRest = stateReconciler !== false && inboundState !== undefined ? stateReconciler(inboundState, state, reducedState, config) : reducedState;
                var _newState = $73e435e2fc216b6c$var$_objectSpread({}, reconciledRest, {
                    _persist: $73e435e2fc216b6c$var$_objectSpread({}, _persist, {
                        rehydrated: true
                    })
                });
                return conditionalUpdate(_newState);
            }
        } // if we have not already handled PERSIST, straight passthrough
        if (!_persist) return baseReducer(state, action); // run base reducer:
        // is state modified ? return original : return updated
        var newState = baseReducer(restState, action);
        if (newState === restState) return state;
        return conditionalUpdate($73e435e2fc216b6c$var$_objectSpread({}, newState, {
            _persist: _persist
        }));
    };
}




function $792f2290643e73f9$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $792f2290643e73f9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $792f2290643e73f9$var$_typeof(obj);
}
function $792f2290643e73f9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $792f2290643e73f9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $792f2290643e73f9$var$ownKeys(source, true).forEach(function(key) {
            $792f2290643e73f9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $792f2290643e73f9$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $792f2290643e73f9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $792f2290643e73f9$export$2e2bcd8739ae039(inboundState, originalState, reducedState, _ref) {
    var debug = _ref.debug;
    var newState = $792f2290643e73f9$var$_objectSpread({}, reducedState); // only rehydrate if inboundState exists and is an object
    if (inboundState && $792f2290643e73f9$var$_typeof(inboundState) === "object") Object.keys(inboundState).forEach(function(key) {
        // ignore _persist data
        if (key === "_persist") return; // if reducer modifies substate, skip auto rehydration
        if (originalState[key] !== reducedState[key]) return;
        if ($792f2290643e73f9$var$isPlainEnoughObject(reducedState[key])) {
            // if object is plain enough shallow merge the new values (hence "Level2")
            newState[key] = $792f2290643e73f9$var$_objectSpread({}, newState[key], {}, inboundState[key]);
            return;
        } // otherwise hard set
        newState[key] = inboundState[key];
    });
    return newState;
}
function $792f2290643e73f9$var$isPlainEnoughObject(o) {
    return o !== null && !Array.isArray(o) && $792f2290643e73f9$var$_typeof(o) === "object";
}


function $04cffa891861b45f$export$2e2bcd8739ae039(config, reducers) {
    config.stateReconciler = config.stateReconciler === undefined ? (0, $792f2290643e73f9$export$2e2bcd8739ae039) : config.stateReconciler;
    return (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)(config, (0, $d2bed10dff9b4968$export$66e4520cdb265d18)(reducers));
}




function $46c0b3c6eec1f9fa$var$_toConsumableArray(arr) {
    return $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) || $46c0b3c6eec1f9fa$var$_iterableToArray(arr) || $46c0b3c6eec1f9fa$var$_nonIterableSpread();
}
function $46c0b3c6eec1f9fa$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $46c0b3c6eec1f9fa$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $46c0b3c6eec1f9fa$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $46c0b3c6eec1f9fa$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $46c0b3c6eec1f9fa$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $46c0b3c6eec1f9fa$var$ownKeys(source, true).forEach(function(key) {
            $46c0b3c6eec1f9fa$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $46c0b3c6eec1f9fa$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $46c0b3c6eec1f9fa$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $46c0b3c6eec1f9fa$var$initialState = {
    registry: [],
    bootstrapped: false
};
var $46c0b3c6eec1f9fa$var$persistorReducer = function persistorReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $46c0b3c6eec1f9fa$var$initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1:
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: [].concat($46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry), [
                    action.key
                ])
            });
        case 0, $dc4a47ea750d5f98$export$1647ef958242c4e2:
            var firstIndex = state.registry.indexOf(action.key);
            var registry = $46c0b3c6eec1f9fa$var$_toConsumableArray(state.registry);
            registry.splice(firstIndex, 1);
            return $46c0b3c6eec1f9fa$var$_objectSpread({}, state, {
                registry: registry,
                bootstrapped: registry.length === 0
            });
        default:
            return state;
    }
};
function $46c0b3c6eec1f9fa$export$2e2bcd8739ae039(store, options, cb) {
    var optionsToTest, bannedKeys;
    var boostrappedCb = cb || false;
    var _pStore = (0, $d2bed10dff9b4968$export$f51a9068ac82ea43)($46c0b3c6eec1f9fa$var$persistorReducer, $46c0b3c6eec1f9fa$var$initialState, options && options.enhancer ? options.enhancer : undefined);
    var register = function register(key) {
        _pStore.dispatch({
            type: (0, $dc4a47ea750d5f98$export$51e82cdd7353a0e1),
            key: key
        });
    };
    var rehydrate = function rehydrate(key, payload, err) {
        var rehydrateAction = {
            type: (0, $dc4a47ea750d5f98$export$1647ef958242c4e2),
            payload: payload,
            err: err,
            key: key // dispatch to `store` to rehydrate and `persistor` to track result
        };
        store.dispatch(rehydrateAction);
        _pStore.dispatch(rehydrateAction);
        if (boostrappedCb && persistor.getState().bootstrapped) {
            boostrappedCb();
            boostrappedCb = false;
        }
    };
    var persistor = $46c0b3c6eec1f9fa$var$_objectSpread({}, _pStore, {
        purge: function purge() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$5514fc3b4067675f),
                result: function result(purgeResult) {
                    results.push(purgeResult);
                }
            });
            return Promise.all(results);
        },
        flush: function flush() {
            var results = [];
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$2aaee4793dd13a52),
                result: function result(flushResult) {
                    results.push(flushResult);
                }
            });
            return Promise.all(results);
        },
        pause: function pause() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$dd1033c27a16bbd3)
            });
        },
        persist: function persist() {
            store.dispatch({
                type: (0, $dc4a47ea750d5f98$export$913fe0e161ed92a2),
                register: register,
                rehydrate: rehydrate
            });
        }
    });
    if (!(options && options.manualPersist)) persistor.persist();
    return persistor;
}



function $e8e82c4ef51638c8$export$2e2bcd8739ae039(migrations, config) {
    var _ref = config || {}, debug = _ref.debug;
    return function(state, currentVersion) {
        if (!state) return Promise.resolve(undefined);
        var inboundVersion = state._persist && state._persist.version !== undefined ? state._persist.version : (0, $dc4a47ea750d5f98$export$363ebe89e6e7aeef);
        if (inboundVersion === currentVersion) return Promise.resolve(state);
        if (inboundVersion > currentVersion) return Promise.resolve(state);
        var migrationKeys = Object.keys(migrations).map(function(ver) {
            return parseInt(ver);
        }).filter(function(key) {
            return currentVersion >= key && key > inboundVersion;
        }).sort(function(a, b) {
            return a - b;
        });
        try {
            var migratedState = migrationKeys.reduce(function(state, versionKey) {
                return migrations[versionKey](state);
            }, state);
            return Promise.resolve(migratedState);
        } catch (err) {
            return Promise.reject(err);
        }
    };
}


function $a82db8a0418f5db2$export$2e2bcd8739ae039(inbound, outbound) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var whitelist = config.whitelist || null;
    var blacklist = config.blacklist || null;
    function whitelistBlacklistCheck(key) {
        if (whitelist && whitelist.indexOf(key) === -1) return true;
        if (blacklist && blacklist.indexOf(key) !== -1) return true;
        return false;
    }
    return {
        in: function _in(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key, fullState) : state;
        },
        out: function out(state, key, fullState) {
            return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key, fullState) : state;
        }
    };
}








var $b36a05dffe55b995$export$1e511d4a378977f5;
var $b36a05dffe55b995$export$2e2bcd8739ae039;
"use strict";
$b36a05dffe55b995$export$1e511d4a378977f5 = true;
$b36a05dffe55b995$export$2e2bcd8739ae039 = void 0;

var $b36a05dffe55b995$var$_createWebStorage = $b36a05dffe55b995$var$_interopRequireDefault((parcelRequire("7Asxf")));
function $b36a05dffe55b995$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b36a05dffe55b995$var$_default = (0, $b36a05dffe55b995$var$_createWebStorage.default)("local");
$b36a05dffe55b995$export$2e2bcd8739ae039 = $b36a05dffe55b995$var$_default;



const $f229c5eb741d2d38$var$persistConfig = {
    key: "root",
    storage: $b36a05dffe55b995$export$2e2bcd8739ae039,
    whitelist: [
        "user",
        "movies",
        "favorites"
    ] // only persist the user slice
};
const $f229c5eb741d2d38$var$rootReducer = (0, $d2bed10dff9b4968$export$66e4520cdb265d18)({
    user: (0, $70709e160bcc9047$export$2e2bcd8739ae039),
    movies: (0, $f34c5fce3312cb42$export$2e2bcd8739ae039),
    favorites: (0, $d6e7616fb515f23c$export$2e2bcd8739ae039),
    genres: (0, $735c7bbc43965e5c$export$2e2bcd8739ae039 // add genres reducer
    )
});
const $f229c5eb741d2d38$var$persistedReducer = (0, $73e435e2fc216b6c$export$2e2bcd8739ae039)($f229c5eb741d2d38$var$persistConfig, $f229c5eb741d2d38$var$rootReducer);
const $f229c5eb741d2d38$var$store = (0, $d91034f47eb948f2$export$7d8a5b498da695ac)({
    reducer: $f229c5eb741d2d38$var$persistedReducer,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "persist/REGISTER",
                    "persist/FLUSH",
                    "persist/PAUSE",
                    "persist/PURGE"
                ]
            }
        })
});
const $f229c5eb741d2d38$export$7b682ac9934ca3e4 = (0, $46c0b3c6eec1f9fa$export$2e2bcd8739ae039)($f229c5eb741d2d38$var$store);
var $f229c5eb741d2d38$export$2e2bcd8739ae039 = $f229c5eb741d2d38$var$store;



var $acw62 = parcelRequire("acw62");
function $6e12196636af0b10$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6e12196636af0b10$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6e12196636af0b10$var$_typeof(obj);
}
function $6e12196636af0b10$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e12196636af0b10$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e12196636af0b10$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e12196636af0b10$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e12196636af0b10$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6e12196636af0b10$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e12196636af0b10$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6e12196636af0b10$var$_assertThisInitialized(self);
}
function $6e12196636af0b10$var$_getPrototypeOf(o) {
    $6e12196636af0b10$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e12196636af0b10$var$_getPrototypeOf(o);
}
function $6e12196636af0b10$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e12196636af0b10$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6e12196636af0b10$var$_setPrototypeOf(subClass, superClass);
}
function $6e12196636af0b10$var$_setPrototypeOf(o, p) {
    $6e12196636af0b10$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e12196636af0b10$var$_setPrototypeOf(o, p);
}
function $6e12196636af0b10$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6e12196636af0b10$export$311ca220e7478cda = /*#__PURE__*/ function(_PureComponent) {
    $6e12196636af0b10$var$_inherits(PersistGate, _PureComponent);
    function PersistGate() {
        var _getPrototypeOf2;
        var _this;
        $6e12196636af0b10$var$_classCallCheck(this, PersistGate);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6e12196636af0b10$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $6e12196636af0b10$var$_getPrototypeOf(PersistGate)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "state", {
            bootstrapped: false
        });
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "_unsubscribe", void 0);
        $6e12196636af0b10$var$_defineProperty($6e12196636af0b10$var$_assertThisInitialized(_this), "handlePersistorState", function() {
            var persistor = _this.props.persistor;
            var _persistor$getState = persistor.getState(), bootstrapped = _persistor$getState.bootstrapped;
            if (bootstrapped) {
                if (_this.props.onBeforeLift) Promise.resolve(_this.props.onBeforeLift()).finally(function() {
                    return _this.setState({
                        bootstrapped: true
                    });
                });
                else _this.setState({
                    bootstrapped: true
                });
                _this._unsubscribe && _this._unsubscribe();
            }
        });
        return _this;
    }
    $6e12196636af0b10$var$_createClass(PersistGate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._unsubscribe = this.props.persistor.subscribe(this.handlePersistorState);
                this.handlePersistorState();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._unsubscribe && this._unsubscribe();
            }
        },
        {
            key: "render",
            value: function render() {
                if (typeof this.props.children === "function") return this.props.children(this.state.bootstrapped);
                return this.state.bootstrapped ? this.props.children : this.props.loading;
            }
        }
    ]);
    return PersistGate;
}((0, $acw62.PureComponent));
$6e12196636af0b10$var$_defineProperty($6e12196636af0b10$export$311ca220e7478cda, "defaultProps", {
    children: null,
    loading: null
});




const $34a83e38fb8b3bfc$var$BestflixApp = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $49d9d24d620fa26d$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53aa19e059d1ce0f$export$fa32cd27347e212e), {})
    });
};
const $34a83e38fb8b3bfc$var$container = document.querySelector("#root");
const $34a83e38fb8b3bfc$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $55388fc2f116d4d7$export$2881499e37b75b9a), {
        store: (0, $f229c5eb741d2d38$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e12196636af0b10$export$311ca220e7478cda), {
            loading: null,
            persistor: (0, $f229c5eb741d2d38$export$7b682ac9934ca3e4),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($34a83e38fb8b3bfc$var$BestflixApp, {})
            })
        })
    })
}));


//# sourceMappingURL=index.ac58e644.js.map
